// i18n namespace `recognition` (de) — REQ-099 / REQ-102 / REQ-103.
// D-6 (2026-08-01): traducción completa desde el español (idioma fuente). Se retiraron los 34
// marcadores de traducción pendiente que diferían el trabajo a una "Fase 7" inexistente.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Zurück zum Portal',
    collapseMenu: 'Menü einklappen',
    expandMenu: 'Menü ausklappen',
    fundamentals: 'Grundprinzipien',
  },
  moduleTitle: 'Anerkennungsprogramm',
  nav: {
    recognize: 'Anerkennen',
    shine: 'Gemeinsam Strahlen',
    profile: 'Mein Profil',
    admin: 'Admin',
    team: 'Team',
    dashboard: 'Übersicht',
    innovation: 'Innovation LATAM',
  },
  // F8 (paridad demo, H-96/H-97)
  frontlineMore: {
    tab: 'Mehr anzeigen',
    title: 'Weitere Optionen',
    documents: 'Dokumente',
    language: 'Sprache',
    selectLanguage: 'Sprache auswählen',
  },
  common: {
    loading: 'Wird geladen…',
    error: 'Die Informationen konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    empty: 'Es gibt noch nichts anzuzeigen.',
    notConfigured: 'Der Anerkennungsdienst ist nicht konfiguriert.',
    forbidden: 'Sie haben keine Berechtigung, diesen Bereich zu sehen.',
    close: 'Schließen',
    remove: 'Entfernen',
    cancel: 'Abbrechen',
    insertEmoji: 'Emoji einfügen',
    actions: 'Aktionen',
  },
  recognize: {
    title: 'Kolleg:in anerkennen',
    subtitle: 'Bedanken Sie sich für ein Verhalten, das unseren Grundprinzipien entspricht.',
    feedTitle: 'Neueste Anerkennungen',
    feedEmpty: 'Es gibt noch keine Anerkennungen. Seien Sie die erste Person, die anerkennt!',
    newCta: 'Neue Anerkennung',
    form: {
      messagePlaceholder: 'Schreiben Sie Ihre Anerkennungsnachricht…',
      anonymous: 'Anonym senden',
      submit: 'Anerkennung senden',
    },
  },
  wall: {
    title: 'Anerkennungswand',
    count: '{{count}} Anerkennungen',
    empty: 'Es gibt noch keine Anerkennungen zum Anzeigen.',
    prev: 'Vorherige',
    next: 'Nächste',
    pageOf: 'Seite {{page}} von {{total}}',
    for: 'für',
    anonymous: 'Anonym',
    senderHidden: 'Identität nicht sichtbar',
    points_one: '+{{count}} Punkt',
    points_other: '+{{count}} Punkte',
    pointsTitle: 'Punkte, die diese Anerkennung wert ist',
    fundamentalsRecognized: 'Anerkannte Grundprinzipien',
    fundIconTooltipAria: 'Alle Grundprinzipien dieser Anerkennung ansehen',
    behaviorsRecognized: 'Anerkannte Verhaltensweisen',
    habitsRecognized: 'Anerkannte tägliche Gewohnheiten',
    detailUnavailable: 'Die vollständigen Details konnten nicht geladen werden.',
    reportCount: '{{count}} Mal gemeldet — in Prüfung',
    receivedIn: 'Erhalten in:',
    antiSpoilerBlurredHint: 'Warte auf die Preisverleihung der Brillamos-Juntos-Veranstaltung, um deine Nominierungen zu sehen.',
  },
  reactions: {
    addLabel: 'Reagieren',
    countLabel: '{{count}} Reaktionen',
    modalTitle: 'Reaktionen',
    error: 'Deine Reaktion konnte nicht gespeichert werden. Bitte versuche es erneut.',
    whoReacted: 'Reagiert haben',
    whoLoading: 'Wird geladen…',
    whoEmpty: 'Noch niemand hat reagiert.',
    whoError: 'Die Liste konnte nicht geladen werden.',
  },
  origin: {
    diario: 'Täglich',
    brillamos: 'Wir strahlen',
    personalizada: 'Kampagne',
    csv: 'Massenimport',
    delegado: 'Delegiert',
    sistema: 'System',
  },
  panel: {
    title: 'Erkennen Sie Ihre Kolleg:innen an',
    recipientsLabel: 'Personen',
    recipientsPlaceholder: 'Nach Namen suchen…',
    searchError: 'Personen konnten nicht gesucht werden',
    fundamentalLabel: 'Grundprinzip (max. {{max}})',
    fundamentalLabelUnbounded: 'Grundprinzip',
    maxFundamentalsHint: 'Sie können höchstens {{max}} Grundprinzip(ien) auswählen.',
    behaviorsLabel: 'Verhaltensweisen',
    habitsLabel: 'Tägliche Gewohnheiten',
    habitRequiredHint: 'Wählen Sie mindestens einen daily habit aus, um senden zu können.',
    summaryLabel: 'Zusammenfassung',
    edit: 'Bearbeiten',
    messageLabel: 'Ihre Nachricht',
    messagePlaceholder: 'Warum erkennen Sie diese Person an?',
    anonymous: 'Anonym senden',
    sendToBrillamos: 'Auch an Brillamos senden',
    charCount: '{{count}} Zeichen',
    charsAvailableHint: 'Sie nähern sich dem Limit. Ihnen bleiben {{remaining}} von {{max}} Zeichen.',
    charsLimitReachedHint: 'Sie haben das Limit von {{max}} Zeichen erreicht. Kürzen Sie einen Teil, um weiterzuschreiben.',
    charsLimitSentenceNote: 'Der auf dem Post-it zusammengestellte Satz zählt ebenfalls zum Limit.',
    errMessageTooLong: 'Ihre Nachricht überschreitet das Limit von {{max}} Zeichen. Kürzen Sie einen Teil und senden Sie sie erneut.',
    errRecipientRequired: 'Wählen Sie die Person aus, die Sie anerkennen möchten, bevor Sie senden.',
    errFundamentalRequired: 'Wählen Sie mindestens ein Fundamental aus, bevor Sie senden.',
    errSessionUnknown: 'Wir konnten Ihre Sitzung nicht identifizieren. Schließen Sie die App, melden Sie sich erneut an und versuchen Sie es noch einmal.',
    send: 'Senden',
    sending: 'Wird gesendet…',
    sentTitle: 'Anerkennung gesendet!',
    sentSubtitle: 'Sichtbar für das Team und die Führungskraft.',
    sendErrorGeneric: 'Die Anerkennung konnte nicht gesendet werden. Versuchen Sie es erneut.',
    legalHint: 'Sie müssen die geltenden rechtlichen Bedingungen akzeptieren, bevor Sie anerkennen.',
    sendingDisabledHint: 'Das Senden von Anerkennungen ist vorübergehend deaktiviert.',
    scheduleRestrictedHint: 'Das Senden liegt gerade außerhalb des für Ihren Standort freigegebenen Zeitfensters.',
    weeklyLimitHint: 'Für Ihren Standort gilt ein Limit von {{count}} Anerkennungen pro Woche.',
    missingRecipientsHint: 'Wählen Sie mindestens eine Person aus, die Sie anerkennen möchten.',
    missingFundamentalHint: 'Wählen Sie mindestens ein Grundprinzip aus.',
    messageMinCharsHint: 'Schreiben Sie mindestens {{count}} Zeichen in Ihre Nachricht.',
    missingBehaviorForHabitHint: 'Wählen Sie eine Verhaltensweise aus, um die verfügbaren daily habits zu sehen.',
    noHabitsAvailableHint: 'Für dieses Grundprinzip sind keine daily habits konfiguriert; wählen Sie ein anderes.',
    groupTag: 'Team',
    delegateTitle: 'Sendemodus',
    modeSelfTab: 'In meinem Namen',
    modeOnBehalfTab: 'Im Namen einer anderen Person',
    delegateLabel: 'Im Namen von',
    delegateSubtitle: 'Sie können Anerkennungen im Namen von Mitarbeitenden in der Produktion senden.',
    delegatePlaceholder: 'Mitarbeiter:in suchen…',
    onBehalfActiveBanner: 'Sie erkennen im Namen von {{name}} an.',
  },
  profile: {
    title: 'Mein Anerkennungsprofil',
    subtitle: 'Ihre Anerkennungsaktivität und Ihre Serie.',
    received: 'Erhalten',
    sent: 'Gesendet',
    streak: 'Serie',
    empty: 'Sie haben noch keine Anerkennungsaktivität.',
    weeksStreak: 'Wochen in Serie',
    monthsStreak: 'Monate Serie',
    record: 'Rekord',
    totalSent: 'Gesendet',
  },
  catalog: {
    title: 'Grundprinzipien',
    empty: 'Der Katalog der Grundprinzipien ist leer.',
  },
  notifications: {
    title: 'Benachrichtigungen',
    close: 'Benachrichtigungen schließen',
    placeholder: 'Der Benachrichtigungsposteingang ist bald verfügbar.',
    unread: '{{count}} ungelesen',
    markAllRead: 'Alle als gelesen markieren',
    markRead: 'Als gelesen markieren',
    readState: 'Lesestatus',
    inviteToRecognize: 'Jemanden anerkennen',
    markUnread: 'Als ungelesen markieren',
    loadMore: 'Frühere Benachrichtigungen anzeigen',
    recognitionUnavailable: 'Diese Anerkennung ist nicht mehr verfügbar.',
    unsavedTitle: 'Sie haben ungespeicherte Änderungen',
    unsavedDesc: 'Wenn Sie jetzt gehen, verlieren Sie, was Sie gerade schreiben.',
    unsavedConfirm: 'Ohne Speichern verlassen',
    unsavedCancel: 'Hier bleiben',
    campaignInactive: 'Die Kampagne dieser Anerkennung ist beendet und kann daher nicht mehr geöffnet werden.',
    campaignUnavailable: 'Diese Kampagne ist beendet und kann daher nicht mehr geöffnet werden.',
    unavailable: 'Der Posteingang ist derzeit nicht verfügbar.',
    empty: 'Sie haben keine Benachrichtigungen.',
  },
  // ── WP-12/WP-13 (D4) — Strahlen+Nominieren, Bibliothek, Profil, Wrapped ──
  home: {
    sent: 'Gesendet', received: 'Erhalten', recognizeCta: 'Jetzt anerkennen', recent: 'Neueste Anerkennungen',
    active: 'Aktive Kampagne',
    ended: 'Kampagne beendet',
    daysLeft: 'Noch {{count}} Tage',
    heroLogoAlt: 'Shine Together',
    nominateNow: 'Jetzt nominieren',
    // Demo-Parität (D1/D2) — Hero von /app/reconocer, aus HomePage.tsx der Demo übernommen.
    titleLine1: 'Nominiere, wer',
    titleVive: 'lebt die',
    subtitle: 'Würdige eine:n Kolleg:in, die/der andere inspiriert, indem sie/er unsere Grundprinzipien lebt.',
    cta: '✨ Jemanden nominieren',
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: 'Du hast noch niemanden gewürdigt!',
    emptyReceived: 'Lebe die Fundamentals weiter — schon bald wirst du gewürdigt!',
  },
  streak: {
    title: 'Deine Nominierungsserie',
    subtitle: 'Würdige jede Woche und bleib am Ball!',
    subtitleMonthly: 'Würdige jeden Monat und strahle weiter!',
    weeks: 'Wo.',
    months: 'Mon',
    month: 'Mon',
    monthsMany: 'Mon',
    record: 'Rekord',
    total: 'Nominierungen',
    activeDays: '{{count}} aktive Tage diese Woche',
    currentLevel: 'AKTUELLES LEVEL',
    atRisk: 'Ihre Serie ist diese Woche in Gefahr',
    atRiskMonthly: 'Deine Serie ist diesen Monat in Gefahr',
    // PHASE 7 (Demo-Parität, H-91) — vereinheitlichte .streak-*-Familie.
    current: 'Aktuelle Serie',
    thisWeek: 'Diese Woche',
    days: 'Tage',
    today: 'Heute!',
    nudgeDone: 'Du hast heute schon nominiert! 🌟',
    nudgeTodo: 'Würdige heute und halte deine Serie! 🚀',
    periodProgress: '{{sent}} von {{min}} diese Woche',
    periodProgressDone: 'Wochenziel erreicht! ({{sent}} von {{min}})',
    periodProgressMonthly: '{{sent}} von {{min}} diesen Monat',
    periodProgressDoneMonthly: 'Monatsziel erreicht! ({{sent}} von {{min}})',
    provisionalNote: 'Enthält diese Woche · wird beim Abschluss bestätigt',
    provisionalNoteMonthly: 'Enthält diesen Monat · wird beim Abschluss bestätigt',
    badgeProvisional: 'BEIM ABSCHLUSS',
    badgeProvisionalTooltip: 'Sie haben das Minimum für diesen Zeitraum bereits erreicht: Das Abzeichen wird schon angezeigt und beim Abschluss des Zeitraums offiziell bestätigt.',
    badgesTitle: 'Abzeichen',
    celebration: {
      title: 'Abzeichen freigeschaltet!',
      message: 'Weiter so, deine Beständigkeit zeigt sich!',
      cta: 'Klasse!',
    },
    badgeWeek: '{{count}} Woche',
    badgeWeeks: '{{count}} Wochen',
    badgeWeeksMany: '{{count}} Wochen',
    badgeMonth: '{{count}} Monat',
    badgeMonths: '{{count}} Monate',
    badgeMonthsMany: '{{count}} Monate',
    note: '* Die Serie wird aus den gesendeten Anerkennungen berechnet',
    day: { mon: 'M', tue: 'D', wed: 'M', thu: 'D', fri: 'F', sat: 'S', sun: 'S' },
  },
  // 2026-08-10 — nur `crossOu` wird noch verwendet (von NominarView). Der Rest gehörte zum
  // "Aktivitäts-Feed" von Brillamos Juntos (`BrillamosFeed`, auf Kundenwunsch aus dem Baum entfernt).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "Alle Sprachen",
    title: 'Kampagnendokumente',
    download: 'Herunterladen',
    loadError: 'Dokument konnte nicht geladen werden.',
    cat: {
      howto: 'So nominieren Sie',
      awards: 'Preise',
      legal: 'Teilnahmebedingungen',
      privacy: 'Datenschutzerklärung',
      cookies: 'Cookie-Richtlinie',
      notice: 'Impressum',
    },
  },
  library: {
    title: 'Die Grundprinzipien',
    subtitle: 'Die Basis dafür, wie wir bei Sigma arbeiten, zusammenarbeiten und wachsen.',
    watchVideo: 'Video ansehen',
    behaviorsCount: '{{count}} Haltungen und Verhaltensweisen',
    dailyHabits: 'Tägliche Gewohnheiten',
    micrositeSpace: 'Bereich der Kultur-Microsite',
  },
  nominate: {
    back: 'Gemeinsam Strahlen',
    thanksTo: 'Danke an {{name}} für',
    demonstrating: 'das Zeigen von {{fundamental}}',
    defaultMessage: 'Anerkennung gesendet',
    sentTitle: 'Nominierung gesendet!',
    sentSubtitle: 'Danke, dass Sie {{name}} zum Strahlen bringen.',
    redirecting: 'Zurück zur Kampagne…',
    yourRecognition: 'Ihre Anerkennung',
    thanksWord: 'Danke an',
    slotWho: 'wen?',
    forWord: 'für',
    slotWhat: 'was hat er/sie getan?',
    demonstratingWord: 'und zeigt damit',
    slotFund: 'Grundprinzip?',
    elements: '{{done}}/3 Elemente',
    eyebrow: 'Anerkennung erstellen',
    title: 'Füllen Sie die drei Felder aus',
    field1: 'Markieren Sie Ihre:n Kolleg:in',
    searchPlaceholder: 'Name der Kollegin / des Kollegen…',
    noResults: 'Wir haben niemanden mit diesem Namen gefunden.',
    field2: 'Bei welchem Grundprinzip?',
    field3: 'Was hat er/sie getan?',
    noActions: 'Für dieses Grundprinzip sind keine Verhaltensweisen konfiguriert.',
    pickFundFirst: 'Wählen Sie zuerst ein Grundprinzip.',
    completeMessage: 'Vervollständigen Sie Ihre Nachricht',
    personalizeTitle: 'Personalisieren Sie Ihre Nachricht',
    personalizeSub: 'Fügen Sie Ihre eigene Stimme hinzu. Der Rest ist schon fertig.',
    messagePlaceholder: 'Beschreiben Sie den konkreten Moment, den Sie beobachtet haben…',
    charCount: '{{count}} Zeichen',
    idealRange: '30–80 ideal',
    nudgeText: 'Ihre Nachricht wirkt stärker, wenn Sie eine eigene Zeile hinzufügen.',
    addLine: 'Zeile hinzufügen',
    sendAnyway: 'Trotzdem senden',
    send: 'Nominierung senden',
  },
  wrapped: {
    readyTitle: 'Ihr Recap ist fertig', readySubtitle: 'Erleben Sie die Momente noch einmal, die Ihr {{year}} zum Strahlen gebracht haben.', open: 'Mein Recap ansehen',
    introHint: 'Ein Blick auf Ihr Jahr des Anerkennens.',
    topReceptor: 'Wen Sie am häufigsten anerkannt haben',
    topEmisor: 'Ihr Fan Nr. 1',
    topFundamentalHint: 'Das, was Sie am meisten gefeiert haben.',
    bottomFundamentalHint: 'Das, was Sie am wenigsten gefeiert haben. Deine Herausforderung für dieses Jahr.',
    crossOuValue: '{{count}} Cross-OU-Anerkennungen',
    messageFrom: 'Von {{name}}',
    winnerYear: 'Jahr {{anio}}',
    winnerPosition: 'Platz {{position}}',
    sinceMonth: 'Ihre Zusammenfassung beginnt im {{month}}.',
    streakValue: '{{count}} Wochen',
    streakValueOne: '{{count}} Woche',
    streakValueMany: '{{count}} Wochen',
    streakValueMonth: '{{count}} Monate',
    streakValueMonthOne: '{{count}} Monat',
    streakValueMonthMany: '{{count}} Monate',
    unavailable: 'Ihr Wrapped ist noch nicht verfügbar.',
    // RF-130-Korrektur F1 (H-06) — das Backend liefert einen STABILEN SCHLÜSSEL
    // (`GetRecognitionWrappedQueryHandler.cs`), keinen Text. `WrappedModal.tsx` löst ihn gegen diese
    // drei auf, mit einer Whitelist: niemals `t(rohesSchlüssel)`.
    generosityTag: {
      generoso: 'Großzügig',
      muyGeneroso: 'Sehr großzügig',
      superGeneroso: 'Super großzügig',
    },
  },
  prof: {
    myFolders: 'Meine erhaltenen Anerkennungen, gefiltert nach Fundamental',
    viewingTitle: 'Profil von {{name}}',
    backToMine: 'Mein Profil',
    myTeam: 'Team',
    searchColleague: 'Kolleg:in suchen…',
    campaignBannerSub: 'Die Kampagne läuft — gehen Sie zu Gemeinsam Strahlen',
    ctaRecognize: 'Jemanden anerkennen',
    myWrapped: 'Mein Wrapped {{year}}',
    brillamosFolder: 'Gemeinsam Strahlen',
    emptySent: 'Sie haben noch keine Anerkennungen gesendet.',
    emptyBrillamos: 'Hier gibt es noch keine Anerkennungen aus Wir strahlen.',
    folderEmpty: 'In diesem Ordner gibt es noch keine Anerkennungen.',
    recognizeName: '{{name}} anerkennen',
    // PHASE 6 (Demo-Parität, H-75/H-77/H-78) — Profil `.rp2-*`.
    thisWeek: 'Diese Woche',
    weekdayInitials: 'M,D,M,D,F,S,S',
    badges: 'Abzeichen · Shine Together',
    recap: 'Wrapped {{year}}',
    sigmaMsg: '"Danke, dass Sie die Kultur von Sigma leben"',
    sigmaFrom: 'Sigma · {{year}}',
    sigmaNote: 'Keine erhaltenen Anerkennungen in {{year}}. Diese Anerkennung ist eine Erinnerung an Ihren Wert für das Team.',
    sigmaNoteSent: 'Keine gesendeten Anerkennungen in {{year}}. Diese Anerkennung ist eine Erinnerung an Ihren Wert für das Team.',
  },
  time: {
    moment: 'Gerade eben',
    hours: 'Vor {{n}} Std.',
    yesterday: 'Gestern',
    days: 'Vor {{n}} Tagen',
  },
  // ── WP-11 REQ-104 — Interaktives Post-it / Word Builder ──
  builder: {
    modeLabel: 'Anerkennungsmodus',
    modeClassic: 'Klassisch',
    modeInteractive: 'Interaktiv',
    previewLabel: 'Vorschau der Anerkennung',
    thanksWord: 'Ich erkenne an',
    forWord: 'für',
    demonstratingWord: 'und zeigt damit',
    slotWho: 'wen?',
    slotWhat: 'was hat er/sie getan?',
    slotFund: 'Grundprinzip?',
    stepOf: 'Schritt {{step}} von {{total}}',
    step1Title: 'Wen erkennen Sie an?',
    step3Title: 'Welches Verhalten oder welche Gewohnheit?',
    step4Title: 'Fügen Sie Ihre Nachricht hinzu',
    complementPlaceholder: 'Beschreiben Sie den konkreten Moment, den Sie beobachtet haben…',
    noActions: 'Für dieses Grundprinzip sind weder Verhaltensweisen noch Gewohnheiten konfiguriert.',
    back: 'Zurück',
    next: 'Weiter',
  },
  ri: {
    bankLabel: 'Wortbank',
    bankTitle: 'Wählen Sie Ihre Wörter',
    bankHint: 'Tippen Sie unten auf ein Wort, um Ihr Post-it zu vervollständigen 👇',
    forWhom: 'Für wen',
    searchPlaceholder: 'Name der Kollegin / des Kollegen…',
    catAccion: 'Grundprinzipien',
    catComportamiento: 'Verhaltensweisen',
    catHabito: 'Gewohnheiten',
    catImpacto: 'Wirkung',
    msgLabel: 'Ihre Nachricht',
    msgTitle: 'Bauen Sie Ihre Anerkennung',
    words: 'Elemente',
    clear: 'Leeren',
    clickToRemove: 'Zum Entfernen klicken',
    clickHint: 'Klicken Sie auf ein Wort aus der Wortbank',
    pickFundFirst: '👆 Wählen Sie ein Grundprinzip, um seine Verhaltensweisen zu sehen',
    pickBehaviorFirst: '👆 Wählen Sie ein Verhalten, um seine Gewohnheiten zu sehen',
    noHabitsForFund: '👆 Für dieses Grundprinzip sind keine Gewohnheiten konfiguriert',
    howLabel: 'Wie funktioniert das?',
    howTitle: 'Drei einfache Schritte',
    step1: '<strong>Fahren Sie mit der Maus</strong> über ein Wort, und das Zielfeld leuchtet auf.',
    step2: '<strong>Klicken Sie</strong> auf das Wort, um es in die Nachricht einzufügen.',
    step3: '<strong>Klicken Sie auf das Feld</strong> des Post-its, um ein eingesetztes Wort zu entfernen.',
    quote: 'Anerkennen heißt, das Unsichtbare zu benennen. Wenn wir jemandem sagen, was wir in ihm sehen, weben wir Gemeinschaft.',
    cta: 'Vervollständigen Sie Ihre Nachricht',
    ctaDone: 'Vervollständigen Sie Ihre Nachricht →',
    popupTitle: 'Fügen Sie die persönliche Note hinzu',
    popupChars: '30-80 Zeichen ideal',
    nudgeMsg: 'Ihre Nachricht wirkt stärker, wenn Sie eine eigene Zeile hinzufügen 💛',
    nudgeAdd: 'Zeile hinzufügen',
    nudgeSkip: 'Trotzdem senden',
    sent: 'Anerkennung gesendet!',
    sentIntro: 'Danke an meine:n',
    continueBtn: 'Weiter →',
    seeRecognition: 'Meine Anerkennung ansehen →',
    clearReset: 'Leeren und neu beginnen',
    wStep: 'Schritt {{step}} von {{total}}',
    wQPersona: 'Wen erkennen Sie an?',
    wQFund: 'Welches Grundprinzip hat er/sie gelebt?',
    wQBehavior: 'Welches Verhalten hat er/sie gezeigt?',
    wQHabit: 'Welche Gewohnheit war es?',
    wQImpact: 'Welche Wirkung hatte das?',
    templateThanks: 'Ich erkenne an',
    templateForLiving: 'für das Leben von',
    templateWith: 'mit',
    templateShowing: ', und zeigt damit, dass',
    templateThat: '. Das',
    slotPersona: 'Person',
    slotAccion: 'Grundprinzip',
    slotComportamiento: 'Verhalten',
    slotHabito: 'Gewohnheit',
    slotImpacto: 'Wirkung',
    impact1: 'inspiriert uns',
    impact2: 'lässt uns wachsen',
    impact3: 'richtet uns aus',
    impact4: 'bringt das Team voran',
    tooltipFundamental: 'Ein Fundamental ist der Wert, den die Person gelebt hat.',
    tooltipComportamiento: 'Das konkrete Verhalten, das diesen Wert gezeigt hat.',
    tooltipHabito: 'Die tägliche Gewohnheit, in der sich dieses Verhalten zeigt.',
    tooltipImpacto: 'Die Wirkung, die es auf das Team hatte.',
    guideStep1Title: 'Wähle deine Wörter',
    guideStep1Text: 'Hier wählst du das Fundamental, das Verhalten, die Gewohnheit und die Wirkung, die du anerkennen möchtest.',
    guideStep2Title: 'Dein Post-it entsteht',
    guideStep2Text: 'Jedes gewählte Wort füllt eine Lücke im Satz deiner Anerkennung.',
    guideStep3Title: 'Füge deine persönliche Note hinzu',
    guideStep3Text: 'Diese Nachricht ist optional, macht deine Anerkennung aber persönlicher.',
    guideStep4Title: 'Sende deine Anerkennung',
    guideStep4Text: 'Sobald alles vollständig ist, wird dieser Button aktiv und du kannst senden.',
    guideReopen: 'Anleitung erneut ansehen',
    guideNext: 'Weiter',
    guideSkip: 'Überspringen',
    guideDone: 'Verstanden',
    progressLabel: '{{value}} von {{total}} Schritten abgeschlossen',
  },
  // ── WP-11 REQ-106 — CSV-Massenimport ──
  bulk: {
    or: 'oder',
    open: 'Massen-Upload',
    title: 'Massen-Upload von Anerkennungen',
    subtitle: 'Lade eine CSV mit mehreren Anerkennungen auf einmal hoch, prüfe und korrigiere vor der Bestätigung.',
    stepInstructions: 'Anleitung',
    stepUpload: 'Datei hochladen',
    stepReview: 'Prüfen',
    stepConfirm: 'Bestätigen',
    stepOf: 'Schritt {{step}} von {{total}}',
    next: 'Weiter',
    back: 'Zurück',
    instructionsIntro: 'Lade die Vorlage herunter, fülle sie mit einer Person pro Zeile aus und lade sie hoch, um sie zu validieren und im Batch zu laden.',
    matchByIdentity: 'Suche die Person über ihre registrierte E-Mail-Adresse oder ihre Personalnummer — eines von beidem genügt. Kennst du die E-Mail nicht? Die Personalnummer funktioniert genauso gut.',
    onePersonPerRowWarning: 'Wichtig: Jede Zeile der Datei steht für GENAU EINE Person. Trage nicht mehrere E-Mail-Adressen oder Personalnummern in dieselbe Zelle ein — wenn du mehrere Personen anerkennen möchtest, füge für jede Person eine eigene Zeile hinzu.',
    // colRequired/colOptional: gemeinsam mit adminBulkUsers/StepInstructions.tsx genutzt
    // (Europa/USA-Verzeichnis) — dieser Wizard verwendet sie nicht mehr (seine festen Spalten
    // tragen kein Pflicht-/Optional-Tag). Bei einer Bereinigung hier nicht entfernen, ohne vorher
    // diesen anderen Verbraucher zu prüfen.
    colRequired: 'Pflichtfeld',
    colOptional: 'Optional',
    colNameNombre: 'Name',
    colNameCorreoNomina: 'E-Mail oder Personalnummer',
    colNameFundamental: 'Grundwert',
    colReceptorEmailDesc: 'E-Mail der Person, die die Anerkennung erhält.',
    colMensajeDesc: 'Anerkennungsnachricht. Je nach Organisationseinheit ggf. Pflichtfeld.',
    colEmisorEmailDesc: 'E-Mail des Absenders. Leer = du selbst.',
    colReceptorNominaDesc: 'Personalnummer der empfangenden Person (AD, SuccessFactors oder das Europa-Verzeichnis). Alternative zur E-Mail — ersetzt sie nicht, dient für Personen ohne E-Mail oder ohne Registrierung.',
    colEmisorNominaDesc: 'Personalnummer der absendenden Person. Leer = du.',
    markColumnsTitle: 'Und je eine Spalte für jedes Fundamental, Verhalten und Daily Habit',
    markColumnsIntro: 'Nach diesen festen Spalten siehst du eine Spalte für jedes davon — markiere die passende mit einem X (oder einem beliebigen Zeichen wie „ja"). Kein Code zum Eintippen.',
    markFundamentalHint: 'Markiere ein oder mehrere Fundamentals pro Zeile — bis zu dem Limit, das deine Organisationseinheit erlaubt.',
    markBehaviorHint: 'Das Verhalten ist optional — du kannst mehrere markieren.',
    markHabitHint: 'Die Daily Habits sind optional — du kannst mehrere markieren.',
    markColumnsOutro: 'Die Spalte Mensaje ist die letzte Spalte in der Datei, nach allen Markierungsspalten.',
    downloadTemplate: 'Vorlage herunterladen',
    templateError: 'Vorlage konnte nicht heruntergeladen werden.',
    catalogError: 'Der Fundamentals-Katalog konnte nicht geladen werden. Bitte versuche es erneut — ohne den Katalog kann die Datei nicht validiert werden.',
    upload: 'CSV hochladen',
    dragDropHint: 'Ziehe deine CSV-Datei hierher oder klicke, um sie auszuwählen.',
    invalidFileType: 'Es werden nur CSV-Dateien akzeptiert.',
    emptyFile: 'Die Datei enthält keine Datenzeilen.',
    parseError: 'CSV-Datei konnte nicht gelesen werden.',
    uploadError: 'Massen-Upload konnte nicht verarbeitet werden.',
    validRows: '{{count}} gültige Zeilen',
    invalidRows: '{{count}} mit Fehlern',
    reviewHint: 'Korrigiere die rot markierten Zeilen direkt in der Tabelle; jede Änderung wird erneut geprüft.',
    colLine: '#',
    colReceptor: 'Empfänger',
    colFundamental: 'Fundamental',
    colMensaje: 'Nachricht',
    colReceptorNomina: 'Personalnr.',
    colBehavior: 'Verhalten',
    colHabits: 'Daily Habits',
    colStatus: 'Status',
    ok: 'Gültig',
    expandRow: 'Details zu Zeile {{line}} anzeigen',
    collapseRow: 'Details zu Zeile {{line}} ausblenden',
    habitsCount_one: '{{count}} Daily Habit',
    habitsCount_other: '{{count}} Daily Habits',
    revalidating: 'Wird erneut geprüft…',
    downloadErrors: 'Fehler herunterladen (CSV)',
    confirmSummary: 'Es werden {{count}} Anerkennungen erstellt. Fehlerhafte Zeilen werden übersprungen.',
    confirm: '{{count}} gültige laden',
    committed: '{{created}} Anerkennungen wurden erstellt. {{skipped}} Zeilen wurden übersprungen.',
    duplicatesSkipped_one: '1 Anerkennung wurde nicht gesendet: Sie wurde bereits zuvor mit derselben Nachricht gesendet.',
    duplicatesSkipped_other: '{{count}} Anerkennungen wurden nicht gesendet: Sie wurden bereits zuvor mit derselben Nachricht gesendet.',
    notFoundTitle: 'In der Adressliste nicht gefundene E-Mails:',
    errors: {
      receptorRequired: 'Die E-Mail des Empfängers ist erforderlich.',
      receptorNotFound: 'Diese E-Mail existiert nicht in der Adressliste.',
      multiplePeopleNotSupported: 'Diese Spalte darf nur eine Person enthalten (eine E-Mail-Adresse oder eine Personalnummer). Um mehrere Personen anzuerkennen, füge eine Zeile pro Person hinzu.',
      fundamentalInvalid: 'Der Fundamental-Wert ist erforderlich, oder die Nachricht erfüllt nicht die Vorgaben deiner Organisationseinheit.',
      selfRecognition: 'Du kannst dich nicht selbst anerkennen.',
      blockedWord: 'Die Nachricht enthält ein nicht zulässiges Wort.',
      weeklyCapExceeded: 'Der Absender hat sein wöchentliches Limit an Anerkennungen erreicht.',
      duplicateInFile: 'Diese Zeile ist in der Datei mehrfach vorhanden.',
      behaviorInvalid: 'Das Verhalten ist für das Fundamental dieser Zeile nicht gültig.',
      habitInvalid: 'Einer der Daily Habits ist für das Fundamental dieser Zeile nicht gültig.',
      campaignClosed: 'Die Kampagne ist nicht aktiv.',
      notAllowedForCampaign: 'Diese Zeile ist für die Kampagne dieses Stapels nicht zulässig.',
      maxFundamentalsExceeded: 'Für diese Anerkennung können keine weiteren Fundamentale ausgewählt werden: das Limit ergibt sich aus der Konfiguration der Organisationseinheit des Absenders.',
      generic: 'Diese Zeile konnte nicht validiert werden.',
    },
  },
  // ── WP-11 REQ-107 — Post-it-Aktionen ──
  actions: {
    // RF-086 / RN-M06 — der Gründe-Katalog (`reportReasons`) entfiel: der Grund ist Freitext.
    reportCharsLeft: 'Noch {{n}} Zeichen',
    edit: 'Bearbeiten',
    report: 'Melden',
    delete: 'Löschen',
    saveEdit: 'Speichern',
    editError: 'Die Anerkennung konnte nicht bearbeitet werden.',
    editMinChars: 'Die Nachricht muss mindestens {{min}} Zeichen enthalten ({{count}}/{{min}}).',
    reportReason: 'Grund der Meldung',
    reportPlaceholder: 'Beschreiben Sie das Problem kurz…',
    reportError: 'Die Meldung konnte nicht gesendet werden.',
    reportSent: 'Meldung gesendet. Unser Team wird sie prüfen.',
    sendReport: 'Meldung senden',
    deleteConfirm: 'Möchten Sie diese Anerkennung wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteError: 'Die Anerkennung konnte nicht gelöscht werden.',
    confirmDelete: 'Ja, löschen',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Massenimport der Personalliste (Europa und USA)',
      descLong: 'Anlage und Aktualisierung der Personalliste Europa/USA über eine CSV mit 24 Spalten, plus der Region der Datei (Europa oder USA), die beim Hochladen ausgewählt wird. Der Import ist inkrementell: Wer nicht in der Datei vorkommt, bleibt unverändert; Austritte werden über die Spalte EMPLOYEE DELETED markiert. Alle anderen Regionen synchronisiert SuccessFactors automatisch.',
      importHint: 'Vorlage herunterladen, ausfüllen und hochladen. Beim Hochladen wird zuerst eine Vorschau angezeigt, die nichts speichert. Datumsformat MM/dd/jjjj.',
      openWizard: 'Massenimport öffnen',
      wizardSubtitle: 'CSV der Personalliste hochladen, Ergebnis prüfen und bestätigen — es wird erst im letzten Schritt gespeichert.',
      confirm: 'Import bestätigen',
      downloadErrors: 'Fehler herunterladen (CSV)',
      received: 'Zeilen',
      created: 'Angelegt',
      updated: 'Aktualisiert',
      deactivated: 'Deaktiviert',
      skipped: 'Übersprungen',
      disabled: 'Der Massenimport Europa/USA ist in den Quelleinstellungen deaktiviert.',
      previewNotice: 'Vorschau: Es wurde noch nichts gespeichert. Dies sind die Zahlen, die der echte Import liefern wird.',
      allOk: 'Alle Zeilen wurden ohne Fehler verarbeitet.',
      importError: 'Die Datei konnte nicht verarbeitet werden.',
      importErrorTimeout: 'Der Server hat zu lange für eine Antwort gebraucht. Der Import ist serverseitig möglicherweise trotzdem abgeschlossen worden — bitte die Personalliste prüfen, bevor Sie es erneut versuchen. Referenz: {{correlationId}}',
      ignoredColumnsNotice: 'Diese Spalten Ihrer Datei werden nicht erkannt und ignoriert: {{columns}}',
      confirmRecap: 'Es werden {{total}} Zeilen verarbeitet: {{created}} neu, {{updated}} aktualisiert, {{deactivated}} deaktiviert.',
      committed: 'Import abgeschlossen: {{created}} neu, {{updated}} aktualisiert, {{deactivated}} deaktiviert, {{skipped}} übersprungen.',
      paginationPage: 'Seite {{page}} von {{total}}',
      errorColumn: 'Spalte',
      errorDetail: 'Fehler-/Auslassungsdetail',
      ouLabel: 'Region der Datei',
      ouPlaceholder: 'Region auswählen',
      ouEuropa: 'Europa',
      ouUsa: 'USA',
      ouCentral: 'Central',
      ouHint: 'Gilt für alle Zeilen der Datei. Wird nicht mehr pro Zeile in der CSV erfasst, um Tipp- oder Sprachfehler zu vermeiden.',
      ouRequired: 'Wählen Sie die Region, bevor Sie die Datei hochladen.',
      col: {
        employeeDeleted: '1 deaktiviert die Person; 0 oder leer lässt sie aktiv.',
        localId: 'Personalnummer des Mitarbeiters. Das ist der Schlüssel — ohne ihn kann die Zeile nicht verarbeitet werden.',
        firstName: 'Vorname.',
        lastName: 'Nachname.',
        secondLastName: 'Zweiter Nachname (optional).',
        completeName: 'Vollständiger Anzeigename. Wenn leer, wird er aus den drei vorherigen Feldern gebildet.',
        email: 'E-Mail des Mitarbeiters. Kann leer sein — der Datensatz bleibt in der Liste, bis sich die Person registriert.',
        bu: 'Geschäftseinheit.',
        siteId: 'Standort-/Werk-ID.',
        site: 'Standort-/Werksname.',
        orgDirectionId: 'ID der Organisationsdirektion.',
        orgDirection: 'Name der Organisationsdirektion.',
        funcDirectionId: 'ID der Funktionsdirektion.',
        funcDirection: 'Name der Funktionsdirektion.',
        departmentId: 'Abteilungs-ID.',
        department: 'Abteilungsname.',
        jobPosition: 'Position des Mitarbeiters.',
        manager: 'Name des direkten Vorgesetzten (nur informativ).',
        managerId: 'Personalnummer des direkten Vorgesetzten. Verknüpft die Hierarchie; der Vorgesetzte muss bereits in der Liste existieren.',
        managerEmail: 'E-Mail des direkten Vorgesetzten (nur informativ).',
        hireDate: 'Eintrittsdatum, Format MM/dd/jjjj.',
        birthDate: 'Geburtsdatum, Format MM/dd/jjjj.',
        notification: "YES oder NO: ob die Person Benachrichtigungen erhält. Leer bedeutet 'nicht festgelegt', nicht NO.",
        country: 'Land der Person. Optional, aber ohne dieses Feld fällt die Person aus dem Zuständigkeitsbereich der Länderadministratoren.',
      },
    },
    title: 'Verwaltung',
    subtitle: 'Konfigurieren Sie das Anerkennungsprogramm.',
    denied: 'Sie haben keine Berechtigung für diesen Bereich.',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    saved: 'Änderungen gespeichert',
    saveError: 'Die Änderungen konnten nicht gespeichert werden.',
    rowsPerPage: 'Zeilen pro Seite',
    fundPanelTitle: 'Admin Grundprinzipien — Anerkennung',
    fundPanelSubtitle: 'Jedes Modul ist unabhängig. Aktiviere oder deaktiviere es je nach den Anforderungen deiner Organisation.',
    pager: {
      showing: '{{range}} von {{total}} werden angezeigt',
      perPage: '{{size}} pro Seite',
      all: 'Alle',
      prev: 'Vorherige Seite',
      next: 'Nächste Seite',
      pageSize: 'Ergebnisse pro Seite',
    },
    nav: {
      roles: 'Rollen und Berechtigungen konfigurieren',
      points: 'Punkte',
      moderation: 'Moderation',
      winners: 'Gewinner:innen',
      campaigns: 'Kampagnen',
      reports: 'Berichte',
      team: 'Team',
      dashboard: 'Übersicht',
      management: 'Steuerung',
      notifications: 'Benachrichtigungen',
      views: 'Ansichten',
      docs: 'Dokumentation',
      recap: 'Recap',
    },
    roles: {
      title: 'Rollen und Berechtigungen konfigurieren',
      desc: 'Verwalten Sie Administrator:innen, ihren Geltungsbereich nach OU/Land und ihre Berechtigungsmatrix.',
      searchEmail: 'Nach E-Mail suchen…',
      empty: 'Es gibt keine Administrator:innen zum Anzeigen.',
      colAdmin: 'Administrator:in',
      colRole: 'Rolle',
      colScope: 'Geltungsbereich',
      colStatus: 'Status',
      allScopes: 'Alle',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      edit: 'Bearbeiten',
      remove: 'Entfernen',
      removeConfirmTitle: 'Brillamos-Administrator:in entfernen',
      removeConfirmMsg: '"{{name}}" als Brillamos-Administrator:in entfernen? Das Konto bleibt als Standard-Mitarbeiter bestehen.',
      removeConfirm: 'Ja, entfernen',
      removeError: 'Die Administratorrolle konnte nicht entfernt werden. Versuchen Sie es erneut.',
      status: 'Status',
      permMatrix: 'Berechtigungsmatrix',
      readOnlyConflict: '„Nur Lesen“ kann nicht mit Schreibrechten kombiniert werden (RN-R03). Aktuell aktiv: {{permisos}}. Sobald Sie ein Kästchen ändern, wird es aufgelöst; so gespeichert lehnt der Server es ab.',
      addAdmin: 'Administrator:in hinzufügen',
      addTitle: 'Administrator:in hinzufügen',
      editTitle: 'Administrator:in bearbeiten — {{name}}',
      searchPersonLabel: 'Mitarbeiter:in suchen',
      searchPersonPlaceholder: 'Name oder E-Mail der Mitarbeiter:in…',
      alreadyAdminNote: 'Diese Person ist bereits Anerkennung-Administrator:in — bearbeiten Sie ihre Daten unten.',
      cannotEditGlobal: 'Diese Person hat bereits die Rolle Admin Allgemein. Diese Rolle wird nicht von hier aus verwaltet.',
      selectRolePlaceholder: 'Rolle auswählen…',
      selectRoleFirst: 'Wählen Sie eine Rolle, bevor Sie speichern.',
      saveForbidden: 'Sie haben keine Berechtigung für diese Änderung.',
      role: {
        AdminGlobal: 'Admin Allgemein',
        AdminBrillamos: 'Admin Anerkennung',
        AdminOUBrillamos: 'Admin OU Anerkennung',
      },
    },
    perm: {
      manageUsers: 'Benutzer:innen verwalten',
      manageRecognitions: 'Anerkennungen verwalten',
      manageNotifications: 'Benachrichtigungen verwalten',
      manageDocuments: 'Dokumente verwalten',
      manageWinners: 'Gewinner:innen verwalten',
      viewAnalytics: 'Analytics ansehen',
      viewReports: 'Berichte ansehen',
      exportData: 'Daten exportieren',
      configureViews: 'Ansichten konfigurieren',
      bulkCsv: 'Massenversand (CSV)',
      moderateContent: 'Inhalte moderieren',
      manageCampaigns: 'Kampagnen verwalten',
      createCampaigns: 'Kampagnen erstellen und verwalten',
      readOnly: 'Nur Lesen',
      approveNominations: 'Gewinner:innen bestätigen',
      managePoints: 'Steuerung',
      manageRoles: 'Rollen und Berechtigungen konfigurieren',
      manageBlockedWords: 'Gesperrte Wörter verwalten',
      managePointsConfig: 'Punkte',
      manageRecap: 'Jahres-Recap bearbeiten',
      delegateRecognition: 'Im Namen einer anderen Person anerkennen',
      accessCatalogFundamentals: 'Katalog Fundamentals',
      accessCatalogOus: 'Katalog OUs',
    },
    points: {
      title: 'Punkte',
      desc: 'Punkte pro Kriterium konfigurieren (0-9), gespiegelt für Staff/Frontline. Punkte sind für Mitarbeitende nie sichtbar.',
      empty: 'Keine Punktekriterien konfiguriert.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Aktiv',
      segmentActiveHint: 'Wenn deaktiviert, vergibt diese Tabelle (Staff oder Frontline) keine Punkte, auch wenn Kriterien konfiguriert sind.',
      lockedCampaign: 'Die Konfiguration ist nach Kampagnenstart nicht mehr bearbeitbar.',
      campaignActiveWarning: 'Die Punktekonfiguration kann nicht bearbeitet werden, solange in dieser Organisationseinheit eine Kampagne aktiv ist.',
      colCategory: 'Kategorie',
      colCriterion: 'Kriterium',
      colPoints: 'Punkte',
      colActive: 'Aktiv',
      criterionActiveHint: 'Wenn deaktiviert, vergibt dieses Kriterium keine Punkte, auch wenn es erfüllt ist.',
      colAccumulated: 'Gesamtsumme',
      accumulatedFooter: 'Bewertete Nominierungen',
      resetAccumulated: 'Auf 0 zurücksetzen',
      resetAccumulatedConfirmTitle: 'Kumulierten Gesamtwert zurücksetzen',
      resetAccumulatedConfirmMessage: 'Der Zähler "Kumuliert gesamt" dieser OE und dieses Segments wird auf 0 zurückgesetzt. Der Anerkennungsverlauf wird NICHT gelöscht; er wird ab jetzt nur nicht mehr gezählt. Diese Aktion kann nicht rückgängig gemacht werden.',
      resetAccumulatedSuccess: 'Der kumulierte Gesamtwert wurde auf 0 zurückgesetzt.',
      resetAccumulatedError: 'Der kumulierte Gesamtwert konnte nicht zurückgesetzt werden.',
      accumulatedError: 'Die Nominierungszahl konnte nicht geladen werden.',
      accumulatedDisabledHint: 'Bei deaktivierten Punkten bewertet die Engine nicht, daher bleibt die Summe null, auch wenn es Anerkennungen gibt.',
      globalToggle: 'Punkte gelten (global)',
      globalToggleHint: 'Schaltet das Punktesystem für ALLE Organisationseinheiten ein oder aus, unabhängig von der individuellen Konfiguration jeder einzelnen.',
      visibleToEmployees: 'Für Mitarbeitende sichtbar',
      visibleToEmployeesHint: 'Zeigt auf dem Post-it die Punkte jeder Anerkennung dieser OU. Niemals den Gesamtstand einer Person.',
      visibleUnknown: 'Der Zustand des Schalters konnte nicht gelesen werden. Bis dahin ändert sich nichts.',
      visibleGdprBlocked: 'Diese OU unterliegt der DSGVO: Punkte werden auch bei eingeschaltetem Schalter nicht angezeigt.',
      globalOffHint: 'Der globale Schalter ist aus: keine OU vergibt Punkte, auch wenn ihre Tabelle aktiv ist.',
      ouPicker: 'Organisationseinheit',
      ouPickPlaceholder: 'Einheit auswählen…',
      pickOuFirst: 'Wählen Sie eine Organisationseinheit, um ihre Punktekonfiguration zu sehen und zu bearbeiten.',
      accumulatedNoKey: 'Dieses Kriterium hat keinen kanonischen Schlüssel und lässt sich daher nicht zuordnen.',
      globalOverriddenHint: 'Diese Einheit hat eine eigene Ausnahme: hier ist der Schalter {{estado}}, unabhängig vom globalen Wert.',
      globalOn: 'ein',
      globalOff: 'aus',

      globalUnknown: 'Der globale Schalter konnte nicht gelesen werden; sein tatsächlicher Zustand ist unbekannt.',
      noOuInProfile: 'Ihrem Profil ist keine Organisationseinheit zugewiesen, daher gibt es keine Punktekonfiguration. Wenden Sie sich an den globalen Administrator.',
      exportReport: 'Punktebericht herunterladen',
      exporting: 'Wird heruntergeladen…',
      exportError: 'Der Punktebericht konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
      exportEmpty: 'In diesem Bereich gibt es keine Punktezeilen zum Exportieren.',
      exportTruncated: 'Der Bericht wurde bei {{tope}} Zeilen abgeschnitten; grenzen Sie den Bereich ein, um alles zu exportieren.',
      exportNamesUnresolved: 'Einige Namen konnten nicht aufgelöst werden; diese Zeilen enthalten stattdessen die Kennung.',
      exportColPerson: 'Person',
      exportColOu: 'Organisationseinheit',
      exportColPoints: 'Punkte'
    },
    placeholder: {
      soon: 'Dieser Bereich ist bald verfügbar.',
      tracked: 'Nachverfolgung: {{req}}',
    },
    recognitions: {
      title: 'Anerkennungen',
      descLong: 'Verwalten Sie den Katalog der Grundprinzipien/Gewohnheiten: anlegen, bearbeiten, aktivieren/deaktivieren, mit Kampagne und Microsite verknüpfen.',
      tabActive: 'Grundprinzipien',
      tabTrash: 'Papierkorb',
      tabHabits: 'Daily Habits',
      newHabit: 'Neuer Daily Habit',
      habitSearchPlaceholder: 'Habit suchen…',
      habitsEmpty: 'Es gibt keine Daily Habits im Katalog.',
      colColor: 'Farbe',
      colNameEs: 'Name (ES)',
      colNameEn: 'Name (EN)',
      colParent: 'Übergeordnetes Fundament',
      colOuVisibility: 'Sichtbarkeit nach OE',
      ouInherited: 'Vom Fundament geerbt',
      habitStatusAll: 'Alle',
      habitStatusActive: 'Aktiv',
      habitStatusInactive: 'Inaktiv',
      deleteHabitConfirm: 'Diesen Daily Habit aus dem Katalog löschen?',
      newHabitTitle: 'Neuer Daily Habit',
      editHabitTitle: 'Daily Habit bearbeiten',
      new: 'Neues Grundprinzip',
      searchPlaceholder: 'Nach Code oder Name suchen…',
      empty: 'Der Katalog ist leer.',
      colCode: 'Code',
      colName: 'Name',
      colHabits: 'Gewohnheiten',
      colBrillamos: 'Wir strahlen',
      colMicrosite: 'Microsite',
      colStatus: 'Status',
      inBrillamos: 'In Wir strahlen',
      notInBrillamos: 'Außerhalb',
      openMicrosite: 'Öffnen',
      edit: 'Bearbeiten',
      deleteConfirm: 'Dieses Grundprinzip in den Papierkorb verschieben?',
      trashEmpty: 'Der Papierkorb ist leer.',
      newTitle: 'Neues Grundprinzip',
      editTitle: '{{code}} bearbeiten',
      needAllLangs: 'Füllen Sie den Namen in allen 7 Sprachen aus.',
      fieldCode: 'Code',
      fieldOrder: 'Reihenfolge',
      fieldName: 'Name',
      fieldShortName: 'Kurzname',
      fieldColor: 'Farbe',
      fieldMicrosite: 'URL der Microsite',
      fieldCampaignScope: 'Verknüpfte Kampagne',
      campaignScopeHint: 'Kampagnen-Id (leer = globaler Katalog)',
      fieldBrillamos: 'Nimmt an Gemeinsam Strahlen teil',
      legacyCatalogWarning: 'Dieser Katalog ist vorübergehend: Änderungen hier wirken sich noch nicht auf das aus, was Mitarbeitende beim Anerkennen sehen (P2-010).',
    },
    moderation: {
      desc: 'Gesperrte Wörter und Meldungs-Posteingang.',
      title: 'Moderation',
      descLong: 'Meldungs-Posteingang mit Weiterleitung, Katalog gesperrter Wörter und Moderationsschalter.',
      contentTitle: 'Inhaltsmoderation',
      wordsTitle: 'Gesperrte Wörter',
      wordsDesc: 'Sie werden beim Senden einer Anerkennung automatisch erkannt und gesperrt.',
      wordsCounted: 'gesperrte Wörter',
      manageWords: 'Verwalten',
      wordsManagerDesc: 'Wörter je Sprache hinzufügen, bearbeiten oder löschen. Geeignet für mehr als 100 Wörter.',
      newWord: 'Neues Wort',
      region: 'Land/Region',
      regionGlobal: 'Global (alle)',
      regionHint: 'Dieselbe Sprache kann je nach Land oder Region unterschiedliche Wörter haben.',
      allRegions: 'Alle Regionen',
      searchWord: 'Suchen…',
      editWord: 'Wort bearbeiten',
      word: 'Wort',
      wordPlaceholder: 'z. B. unangemessen…',
      language: 'Sprache',
      addWord: 'Hinzufügen',
      wordsEmpty: 'Keine Wörter entsprechen dem Filter.',
      langOther: 'Sonstige',
      // RF-082 — Tabelle Land→Sprachen, die bestimmt, welcher Katalog fuer wen gilt.
      countryLanguagesTitle: 'Länder und Sprachen',
      countryLanguagesDesc: 'Legen Sie fest, welche Sprachen in jedem Land gesprochen werden. Ein mehrsprachiges Land (Belgien: nl und fr) wendet die Wörter aller seiner Sprachen an, ohne sie doppelt zu erfassen. Länder in ISO-3166 (MX, ES, BE) und Sprachen aus den 7 der Plattform (es, en, pt, fr, de, nl, ro). Um ein Wort auf ein bestimmtes Land zu begrenzen, nutzen Sie dessen Feld Land/Region.',
      countryLanguagesEmpty: 'Die Tabelle der Länder und Sprachen ist leer.',
      regionsTitle: 'Regionen',
      regionMembers: 'Länder darin',
      countryLanguagesInvalid: 'Prüfen Sie diese Codes vor dem Speichern: {{codes}}. Das Land steht als 2-stelliger ISO-Code (MX), und die Sprache muss eine der 7 der Plattform sein (es, en, pt, fr, de, nl, ro), ohne Ländervariante.',
      countryLanguagesUnreadable: 'Die Tabelle konnte nicht gelesen werden und lässt sich daher nicht speichern: Beim Speichern wird sie vollständig ersetzt und alles nicht Angezeigte ginge verloren.',
      country: 'Land',
      languages: 'Sprachen',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Land hinzufügen',
      countryPlaceholder: 'MX',
      autoTitle: 'Einstellungen der Auto-Moderation',
      aiAutoBlock: 'Automatische KI-Sperre',
      aiAutoBlockHint: 'Wenn aktiviert, wird jede Anerkennungsnachricht beim Senden per KI (Azure AI Content Safety) geprüft und blockiert, falls sie beleidigend ist.',
      helpAria: 'Hilfe',
      aiHelp: 'Prüft jede Nachricht beim Senden per KI (Azure AI Content Safety) und erkennt Toxizität im Kontext (Hass, Drohungen, Belästigung). Ergänzt den Katalog gesperrter Wörter: beide können gleichzeitig aktiv sein. Erfordert, dass „Moderation aktiv (global)" eingeschaltet ist; ist der globale Schalter aus, greift diese Ebene nicht.',
      globalHelp: 'Hauptschalter der Moderation. Ist er aus, wird NICHTS moderiert: weder die KI-Sperre noch der Katalog gesperrter Wörter, und es werden keine Meldungen angenommen. Schalten Sie ihn ein, damit die anderen Ebenen funktionieren.',
      wordsHelp: 'Sperrt exakte Wörter beim Senden, unabhängig vom Kontext. Ergänzt die KI-Sperre (die Toxizität im Kontext erkennt). Beide Ebenen erfordern, dass „Moderation aktiv (global)" eingeschaltet ist.',
      hideThreshold: 'Meldungsschwelle zum Ausblenden',
      notifyReporter: 'Meldende Person benachrichtigen',
      aiPendingNote: 'Bei aktivierter automatischer KI-Sperre werden Anerkennungsnachrichten beim Senden von Azure AI Content Safety geprüft und abgelehnt, wenn sie gegen die Verhaltensregeln verstoßen. Sie ergänzt den Katalog gesperrter Wörter.',
      hideThresholdHint: 'Wie viele Meldungen nötig sind, um eine Anerkennung automatisch auszublenden. Der Wert 1 entspricht der geltenden Regel: Ausblenden bereits bei der ersten Meldung.',
      notifyReporterHint: 'Speichert die Einstellung und übermittelt sie mit dem Moderationsereignis. Die E-Mail an die meldende Person versendet NotificationService, sobald diese Benachrichtigung existiert.',
      advanced: 'Erweiterte Einstellungen',
      globalEnabled: 'Moderation aktiv (global)',
      reportEnabledGlobal: 'Melden standardmäßig aktiviert',
      dailyReportLimit: 'Tägliches Meldungslimit',
      // RF-084 — Ausnahmen fuer "Melden erlauben" je Knoten, Kaskade Site -> BU -> OU -> global.
      overridesTitle: 'Melden nach Einheit (Kaskade)',
      overridesDesc: 'Ausnahmen vom globalen Wert. Es gilt der spezifischste Knoten: Site, dann BU, dann OU und deren übergeordnete Einheiten. Eine Einheit ohne Ausnahme erbt die der übergeordneten Einheit.',
      overridesNode: 'Einheit, BU oder Site',
      overridesNodePlaceholder: 'OU auswählen oder BU-/Site-ID eingeben',
      overridesAllow: 'Erlaubt',
      overridesBlock: 'Gesperrt',
      overridesEmpty: 'Keine Ausnahmen: alle Einheiten verwenden den globalen Wert.',
      overridesDuplicate: 'Für „{{node}}“ existiert bereits eine Ausnahme. Bezeichner unterscheiden nicht zwischen Groß- und Kleinschreibung: bearbeite oder entferne die vorhandene.',
      inboxTitle: 'Meldungs-Posteingang',
      inboxDesc: 'Meldungen von Nutzenden. Beim Ausblenden verschwindet die Anerkennung von der Pinnwand der empfangenden Person und aus den gesendeten Anerkennungen der sendenden Person; sie wird außerdem aus dem Medaillenspiegel entfernt und ihre Punkte werden storniert.',
      searchName: 'Nach Namen suchen…',
      filterAll: 'Alle',
      filterOu: 'OU: Alle',
      filterBu: 'BU: Alle',
      filterSite: 'Standort: Alle',
      filterFrom: 'Von',
      filterTo: 'Bis',
      filterType: 'Typ: Alle',
      type: { fundamentales: 'Grundprinzipien', brillamos: 'Gemeinsam Strahlen', diario: 'Tägliche Anerkennung' },
      uiStatus: { pendiente: 'Ausstehend', restaurado: 'Wiederhergestellt', eliminado: 'Gelöscht' },
      uiStatusPlural: { pendiente: 'Ausstehende', restaurado: 'Wiederhergestellte', eliminado: 'Gelöschte' },
      status: { Publicado: 'Veröffentlicht', Pendiente: 'Ausstehend', Resuelto: 'Gelöst', Desestimado: 'Abgewiesen' },
      reportsEmpty: 'Keine Meldungen entsprechen dem Filter.',
      colReportedBy: 'Gemeldet von',
      colRecognitionFrom: 'Anerkennung von',
      colTo: 'Für',
      colDetail: 'Detail',
      colReason: 'Grund',
      colDate: 'Datum',
      colStatus: 'Status',
      colActions: 'Aktionen',
      // RF-090 — Umschlag-Schaltflaeche: eskaliert den Fall an den OU-/Landes-Admin, ohne Wartezeit.
      notifyAdmin: 'Admin benachrichtigen',
      notifyAdminHint: 'Sendet sofort einen Hinweis an die Administration der Einheit dieser Anerkennung, ohne auf den Wochenbericht zu warten.',
      notifyAdminConfirm: 'Einen Hinweis an die Administration der Einheit von {{name}} senden? Die E-Mail geht sofort raus.',
      notifyAdminSent: 'Hinweis an die Administration gesendet.',
      notifyAdminError: 'Der Hinweis an die Administration konnte nicht gesendet werden.',
      // RF-090 — Vorschau der Empfänger: Die Umschlag-Schaltfläche meldete „gesendet“, auch wenn niemand es erhielt.
      notifyPreviewTitle: 'Dieser Hinweis erreicht:',
      notifyPreviewLoading: 'Empfänger werden ermittelt…',
      notifyPreviewEmpty: 'Es konnte kein Empfänger ermittelt werden.',
      notifyPreviewError: 'Es konnte nicht geprüft werden, wen der Hinweis erreichen würde.',
      notifyReason: {
        'sin-admins-en-la-ou': 'Für diese Einheit ist keine Administration hinterlegt, und es gibt keine globale Administration, an die der Fall eskaliert werden könnte.',
        'escalado-a-globales': 'Die Einheit hat keine eigene Administration: Der Fall wird an die globale Administration eskaliert.',
        'admin-sin-correo': 'Für die Administration ist im Verzeichnis keine nutzbare E-Mail-Adresse hinterlegt, daher lässt sich niemand anschreiben.',
        'directorio-no-responde': 'Das Benutzerverzeichnis hat nicht geantwortet: Es lässt sich nicht feststellen, wer benachrichtigt werden müsste.',
        'suprimido-por-allowlist': 'Der Versand würde verworfen: Diese Adresse steht nicht auf der Liste zugelassener Empfänger des Benachrichtigungsdienstes.',
        'allowlist-desconocida': 'Die Liste zugelassener Empfänger konnte nicht geprüft werden; der Versand könnte spurlos verworfen werden.',
        desconocido: 'Der Hinweis kann aus einem Grund nicht gesendet werden, den der Dienst nicht erklären konnte.',
      },
      deleteLabel: 'Löschen',
      hideHint: 'Blendet die Anerkennung von der Pinnwand aus, entfernt sie aus dem Medaillenspiegel und storniert ihre Punkte.',
      restore: 'Wiederherstellen',
      reopen: 'Wieder öffnen',
      reopenHint: 'Stellt den Fall als Offen zurück in die Warteschlange und blendet die Anerkennung wieder aus.',
      viewDetail: 'Details ansehen',
      detailTitle: 'Details der Meldung',
      whoReported: 'Wer gemeldet hat',
      whoWasReported: 'Wer gemeldet wurde',
      reportedRecognition: 'Gemeldete Anerkennung',
      messageUnavailable: 'Text nicht verfügbar.',
      // RF-087 — Weiterleitung des Falls: E-Mail und OU werden immer gezeigt, mit Platzhalter wenn sie fehlen.
      dataUnavailable: 'Nicht verfügbar',
      detailLoading: 'Wird geladen…',
      detailError: 'Die aktuellen Kontaktdaten konnten nicht geladen werden; angezeigt werden die zum Zeitpunkt der Meldung gespeicherten.',
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
    },
    winners: {
      // Task 2.5 — Kartenraster für Kampagnen-Abzeichen in Gewinner (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Kampagnen-Abzeichen',
        permanenceNote: 'Diese Abzeichen sind dauerhaft: Sie werden nicht wie Serien-Abzeichen aktiviert oder deaktiviert, sondern bleiben an die Kampagne und das Jahr gebunden, für das sie vergeben wurden.',
        empty: 'Noch keine Kampagnen-Abzeichen vorhanden.',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        deleteConfirm: 'Kampagnen-Abzeichen „{{name}}“ löschen? Name in allen 7 Sprachen, Symbol und Jahr gehen verloren. Dies kann nicht rückgängig gemacht werden.',
        add: '+ Abzeichen hinzufügen',
        editTitle: 'Kampagnen-Abzeichen bearbeiten',
        fieldTitle: 'Titel',
        fieldYearSubtitle: 'Jahr / Untertitel',
        fieldYear: 'Jahr der Auszeichnung',
        yearNone: 'Ohne Jahr',
        fieldYearHint: 'Wird bei der Vergabe geprüft: Ein Abzeichen aus einem Jahr kann nicht in einer Kampagne eines anderen Jahres vergeben werden. "Ohne Jahr" deaktiviert die Prüfung.',
        fieldImage: 'Bild',
        imageUploadHintNew: 'Speichern Sie das Abzeichen zuerst, um sein Bild hochladen zu können.',
        imageFormatInvalid: 'Das Bildformat ist ungültig. Verwenden Sie PNG, JPG, WEBP oder SVG.',
        previewTitle: 'Vorschau',
      },
      bulkTitle: 'Sammelbestätigung',
      bulkSelected: '{{count}} ausgewählt',
      bulkConfirm: '{{count}} bestätigen',
      bulkConfirming: 'Wird bestätigt…',
      bulkClear: 'Auswahl aufheben',
      bulkSelectAll: 'Alle offenen dieser Seite auswählen',
      bulkSelectOne: '{{name}} auswählen',
      bulkFailed: '{{count}} konnten nicht bestätigt werden. Die übrigen schon; versuche es nur mit diesen erneut.',
      editTitle: 'Gewinner bearbeiten — {{nombre}}',
      actionError: 'Die Aktion konnte nicht abgeschlossen werden.',
      badExtension: 'Format nicht unterstützt. Zulässig: {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Position',
      colDepto: 'Abteilung',
      colFundamental: 'Fundamental',
      colStatus: 'Status',
      colUser: 'Nutzer',
      colUserNomina: 'Personalnummer: {{nomina}}',
      colYear: 'Jahr',
      colBadge: 'Abzeichen',
      badgeNone: 'Kein Abzeichen',
      exportFiltered: 'Die Gewinner der aktuellen Filter als Excel herunterladen',
      exportEmpty: 'Mit diesen Filtern gibt es keine Gewinner zum Exportieren',
      exporting: 'Wird exportiert…',
      exportTruncated: 'Der Download wurde auf 5000 Zeilen begrenzt. Grenze die Filter weiter ein, um den Rest zu exportieren.',
      exportError: 'Der Download konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
      confirmAction: 'Als Gewinner bestätigen',
      confirmDelete1: '{{nombre}} aus der Gewinnerliste entfernen?',
      confirmDelete2: 'Das lässt sich nicht rückgängig machen und wird protokolliert. Bestätigen?',
      deleteTitle: 'Gewinner entfernen',
      deleteConfirm: 'Entfernen',
      countryAll: 'Land: Alle',
      editAction: 'Bearbeiten',
      editClosed: 'Außerhalb des Bearbeitungszeitraums.',
      editWindowNote: 'Sie können einen Gewinner bis zu 1 Monat nach dem Hochladen bearbeiten. Der General-Admin kann jeden Gewinner der letzten 3 Jahre bearbeiten.',
      exportNominations: 'Nominierungen exportieren',
      exportWinners: 'Gewinner exportieren',
      exportNominationsTruncated: 'Der Download wurde auf 5000 Zeilen begrenzt. Wähle eine Kampagne mit weniger Nominierungen oder versuche es in Teilen erneut.',
      exportNominationsEmpty: 'Für diese Kampagne gibt es keine Nominierungen zum Exportieren.',
      exportPending: 'Der Export wird im nächsten Paket angebunden.',
      filterCountry: 'Land',
      filterFundamental: 'Fundamental',
      filterYear: 'Jahr',
      filtersToggle: 'Filter',
      flowHint: 'Gewinner werden per Datei hochgeladen. Ablauf: Vorlage hochladen → erscheint hier → als endgültigen Gewinner bestätigen.',
      fundamentalAll: 'Fundamental: Alle',
      fundamentalNone: 'Kein Fundamental',
      importErrorsTitle: 'Abgelehnte Zeilen',
      importSummary: '{{importados}} von {{total}} Zeilen importiert · {{rechazados}} abgelehnt.',
      manageTitle: 'Gewinnerverwaltung',
      moduleHint: 'Aktivieren, um das Hochladen von Gewinnern und die Vergabe von Abzeichen zu ermöglichen.',
      moduleOffWarn: 'Gewinner-Modul deaktiviert. Diese Einstellung wird vorerst nur gespeichert und ändert noch nichts für die Nutzer.',
      moduleSaveError: 'Die Änderung am Gewinner-Modul konnte nicht gespeichert werden. Bitte erneut versuchen.',
      moduleTitle: 'Gewinner-Modul',
      needsCsv: 'Dies ist eine binäre Excel-Mappe und kann nicht gelesen werden. Öffnen und als CSV (UTF-8) speichern, dann erneut hochladen.',
      noResults: 'Keine Gewinner entsprechen dem Filter.',
      ouAll: 'OU: Alle',
      pagerInfo: 'Seite {{page}} von {{paginas}} · {{total}} Gewinner',
      searchByName: 'Nach Namen suchen…',
      statusConfirmed: '✓ Bestätigt',
      statusPending: '⏳ Ausstehend',
      uploadFile: 'Excel hochladen',
      uploadCampaign: 'Kampagne der Liste',
      uploadMode: 'Ausgabe der Liste',
      uploadModeCurrent: 'Aktuell',
      uploadModeHistoric: 'Historisch',
      uploadOpen: 'Liste hochladen',
      uploadOpenHint: 'Öffnet den Assistenten zum Hochladen der Gewinnerliste, aktuell oder historisch.',
      uploadModalTitle: 'Gewinnerliste hochladen',
      uploadModalToggleHint: 'Wählen Sie „Aktuell“, wenn die Liste zu einer Kampagne gehört, die auf der Website aktiv ist. Wählen Sie „Historisch“, um Auszeichnungen aus früheren Jahren hochzuladen, die nicht als Kampagne dokumentiert sind.',
      uploadBadge: 'Abzeichen',
      uploadBadgeHint: 'Jede Zeile der Datei erhält DIESES Abzeichen. Wählen Sie es aus, bevor Sie die Datei hochladen.',
      uploadBadgePick: 'Abzeichen auswählen…',
      uploadBadgeClarify: 'Das Abzeichen ist keine Kampagne: Es ist das Bild, das die Person als gewonnene Auszeichnung sieht (zum Beispiel eine Medaille oder eine Trophäe).',
      pickBadgeFirst: 'Wählen Sie zuerst das Abzeichen aus, das die Gewinner dieser Datei erhalten sollen.',
      uploadHistoricWarning: 'Historische Daten werden direkt gespeichert, ohne Verknüpfung zu einer Kampagne. Prüfen Sie Name, E-Mail und Abzeichen, bevor Sie hochladen.',
      helpOpen: 'Hilfe zum Hochladen der Liste',
      helpModalTitle: 'Wie lade ich die Gewinnerliste hoch?',
      helpIntroVigente: 'Aktuell: Verwenden Sie diesen Modus, wenn die Auszeichnung zu einer Kampagne gehört, die auf der Website existiert und gerade aktiv ist. Sie wählen die Kampagne und das Abzeichen (das Bild, das als gewonnene Auszeichnung angezeigt wird) aus und laden die Vorlage herunter: Sie fragt nur nach der E-Mail-Adresse oder Personalnummer der Person. Name, Jahr und OE/Standort kennt das System bereits — die müssen Sie nicht eintragen.',
      helpIntroHistorico: 'Historisch: Verwenden Sie diesen Modus, wenn die Auszeichnung aus einer alten Kampagne stammt, die es auf der Website nicht mehr gibt, oder von der Sie keine Aufzeichnung haben. Sie wählen KEINE Kampagne aus: Stattdessen wählen Sie EIN Abzeichen aus (das Bild, das als gewonnene Auszeichnung angezeigt wird, kein Kampagnenname), das JEDER Person in der Datei vergeben wird. Laden Sie die Vorlage mit 2 Spalten (Name und E-Mail oder Personalnummer) herunter, füllen Sie sie aus und laden Sie sie hoch.',
      helpDirectorio: 'Die E-Mail-Adresse oder die Personalnummer muss im Firmenverzeichnis eingetragen sein. Wird keines von beiden gefunden, wird nur diese Zeile abgelehnt, der Rest der Datei wird trotzdem geladen. Hat die Person keine E-Mail-Adresse (zum Beispiel Werkspersonal), tragen Sie die Personalnummer in dieselbe Spalte ein — die E-Mail-Adresse ist dann nicht nötig.',
      helpNoDownload: 'Wenn Sie versuchen, eine Datei herunterzuladen, und es keine Daten zum Anzeigen gibt, wird nichts heruntergeladen: Sie erhalten stattdessen eine Meldung auf dem Bildschirm.',
      downloadTemplateHint: 'Laden Sie eine leere Excel-Datei mit den passenden Spalten für diesen Modus in Ihrer Sprache herunter.',
      downloadTemplateCurrent: 'Aktuelle Vorlage herunterladen',
      downloadTemplateHistoric: 'Historische Vorlage herunterladen',
      uploadFileHint: 'Laden Sie die ausgefüllte Excel-Datei mit den Daten der Liste hoch.',
      importWizard: {
        subtitle: 'Liste hochladen, Ergebnis vor dem Bestätigen prüfen und Fehler herunterladen, falls etwas schiefgeht.',
        colNombreDesc: 'Name des Gewinners, so wie er angezeigt wird.',
        colNombreDescVigente: 'Name des Gewinners. Sie können das Feld leer lassen: Wenn Sie nichts eintragen, wird der Name verwendet, der für diese Person bereits gespeichert ist.',
        colEmailDesc: 'E-Mail ODER Personalnummer der Person — eines der beiden reicht; identifiziert, wer den Preis erhält.',
        colFundamentalDesc: 'Anerkannter Grundsatz (Name in beliebiger Sprache oder Katalogcode). Wird ignoriert, wenn er mit keinem übereinstimmt.',
        badgePreviewHint: 'So sieht das Abzeichen aus — genau das, was jeder Gewinner dieser Datei erhalten wird.',
        dropHint: 'Ziehe deine Excel- oder CSV-Datei hierher, oder klicke, um sie auszuwählen.',
        reviewHint: 'Dies ist nur eine VALIDIERUNG: Es wird noch nichts gespeichert. Prüfe die Zusammenfassung und gehe bei Bedarf zurück, um eine korrigierte Datei zu wählen.',
        previewPending: 'Datei wird validiert…',
        noErrors: 'Keine Fehler — alle Zeilen sind gültig.',
        fileLevelError: 'Datei/Auswahl',
        confirmPending: 'Wird gespeichert…',
      },
      filterEstado: 'Status',
      estadoAll: 'Status: Alle',
      uploadCampaignPick: 'Kampagne auswählen…',
      pickCampaignFirst: 'Wählen Sie zuerst die Kampagne aus, zu der die Liste gehört.',
      exportNominationsCatalogError: 'Der Fundamentals/Habits-Katalog konnte nicht geladen werden: Der Export könnte unvollständig sein. Bitte versuche es erneut.',
      yearAll: 'Jahr: Alle',
      desc: 'Register der Gewinner:innen von Gemeinsam Strahlen.',
      title: 'Gewinner:innen',
      descLong: 'Gewinner:innen nach Kampagne/OU. Manuelle Anlage und CSV-Import der Historie mit Rückmeldung je Zeile.',
      filterCampaign: 'Kampagne',
      campaignIdHint: 'Kampagnen-Id',
      filterOu: 'OU',
      ouHint: 'OU-Id',
      add: 'Gewinner:in hinzufügen',
      addTitle: 'Neue:r Gewinner:in',
      fieldCampaign: 'Kampagne',
      fieldUser: 'Benutzer:in',
      fieldName: 'Name',
      fieldOuName: 'OU',
      fieldCountry: 'Land',
      fieldPosition: 'Platzierung',
      save: 'Speichern',
      importTitle: 'CSV-Import',
      importHint: 'Laden Sie die Vorlage herunter, füllen Sie sie aus und laden Sie sie hoch. Der Import ist idempotent pro Kampagne + Benutzer:in.',
      downloadTemplate: 'Vorlage herunterladen',
      uploadCsv: 'CSV hochladen',
      templateError: 'Die Vorlage konnte nicht heruntergeladen werden.',
      importError: 'Der Import konnte nicht verarbeitet werden.',
      deleteError: 'Dieser Gewinner konnte nicht entfernt werden.',
      totalRows: 'Zeilen gesamt',
      imported: 'Importiert',
      rejected: 'Abgelehnt',
      row: 'Zeile',
      reason: 'Grund',
      empty: 'Für diese Filter gibt es keine Gewinner:innen.',
      colPosition: 'Platzierung',
      colName: 'Name',
      colOu: 'OU',
      colCountry: 'Land',
      colCrossed: 'Gekreuzter Ursprung',
      colDate: 'Registriert',
      // Task 16 — Spaltenüberschriften des rohen Nominierungs-Exports (i18n, kein festes Spanisch mehr).
      nominationsExport: {
        // Die `nominee*`-Schlüssel enthalten die Person, die NOMINIERT HAT (der Block Nominee_* des
        // DTOs stammt aus Recognition.EmisorSnapshot). Die nominierte Person steht im Block
        // `candidate*` weiter unten.
        nomineeName: 'Nominierender: Name',
        nomineeEmail: 'Nominierender: E-Mail',
        nomineeEmployeeId: 'Nominierender: Personalnr.',
        nomineeOu: 'Nominierender: OU',
        nomineeBu: 'Nominierender: BU',
        nomineeSite: 'Nominierender: Site',
        nomineeDepartment: 'Nominierender: Position',
        onBehalfOfName: 'Im Namen von: Name',
        onBehalfOfEmail: 'Im Namen von: E-Mail',
        onBehalfOfEmployeeId: 'Im Namen von: Personalnr.',
        onBehalfOfOu: 'Im Namen von: OU',
        onBehalfOfBu: 'Im Namen von: BU',
        onBehalfOfSite: 'Im Namen von: Site',
        onBehalfOfDepartment: 'Im Namen von: Position',
        candidateName: 'Kandidat: Name',
        candidateEmail: 'Kandidat: E-Mail',
        candidateEmployeeId: 'Kandidat: Personalnr.',
        candidateOu: 'Kandidat: OU',
        candidateBu: 'Kandidat: BU',
        candidateSite: 'Kandidat: Site',
        candidateDepartment: 'Kandidat: Position',
        date: 'Datum',
        year: 'Jahr',
        month: 'Monat',
        habitPrefix: 'Gewohnheit',
        comment: 'Kommentar',
        streakBadge: 'Serienabzeichen',
        fromDayToDay: 'Kommt aus dem Alltag',
        status: 'Status',
        type: 'Typ',
        audienceNominee: 'Zielgruppe des Nominierenden',
        audienceCandidate: 'Zielgruppe des Kandidaten',
        points: 'Punkte',
        retiredHabitsGroup: 'Sonstige / entfernte Gewohnheiten',
      },
    },
    campaigns: {
      desc: 'Assistent für Anerkennungskampagnen.',
      statusDivider: 'Kampagnenstatus',
      title: 'Kampagnen',
      descLong: 'Liste der Kampagnen und Assistent in 5 Schritten: Info, Zielgruppe, Konfiguration, Dokumente und Veröffentlichung.',
      filterAll: 'Alle',
      status: {
        Borrador: 'Entwurf', Activa: 'Aktiv', Finalizada: 'Beendet', PendienteAprobacion: 'Genehmigung ausstehend',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Aktiv · außerhalb des Zeitraums',
        ActivaPorIniciar: 'Aktiv · noch nicht gestartet',
        ActivaVencidaHint: 'Die Kampagne ist weiterhin als aktiv markiert, ihr Zeitraum ist jedoch abgelaufen: Mitarbeitende im Geltungsbereich sehen sie nicht.',
        ActivaPorIniciarHint: 'Die Kampagne ist aktiv, aber ihr Startdatum ist noch nicht erreicht.',
      },
      approvals: 'Genehmigungen',
      new: 'Neue Kampagne',
      empty: 'Es gibt keine Kampagnen.',
      colName: 'Name',
      colType: 'Typ',
      colStatus: 'Status',
      colScope: 'Geltungsbereich',
      allScopes: 'Alle OUs',
      editBtn: 'Bearbeiten',
      duplicate: 'Duplizieren',
      panic: 'Kampagne stoppen',
      deactivateConfirmTitle: 'OU-Ausnahme stoppen',
      deactivateConfirmMsg: 'Diese OU-Ausnahme jetzt stoppen? Sie gilt danach sofort nicht mehr für ihren Bereich.',
      panicConfirm: 'Diese Kampagne sofort stoppen?',
      type: { Fundamentales: 'Grundprinzipien', Brillamos: 'Wir strahlen', Personalizada: 'Individuell' },
      wizardEditTitle: 'Kampagne bearbeiten',
      wizardNewTitle: 'Neue Kampagne',
      wizardSub: 'Führen Sie die 6 Schritte aus, um die Kampagne zu erstellen oder zu bearbeiten.',
      backToList: 'Zurück zur Liste',
      step: { info: 'Info', design: 'Design', audience: 'Zielgruppe', config: 'Konfiguration', documents: 'Dokumente', publish: 'Veröffentlichen' },
      tabFundamentales: 'Fundamentals',
      tabBrillamos: 'Shine Together',
      tabPersonalizadas: 'Individuell',
      fundActiveTitle: 'Immer aktiv',
      fundRules: 'Sende-Regeln',
      fundActiveDesc: 'Fundamentals ist die Basis des Anerkennungsprogramms. Es kann nicht deaktiviert, nur seine Regeln konfiguriert werden.',
      fundConfigNote: 'Detaillierte Sende-Regeln und Limits werden im Bereich Verwaltung verwaltet.',
      globalPanic: 'Alle Kampagnen stoppen',
      globalPanicConfirm: 'Alle aktiven Shine-Together-Kampagnen sofort beenden? Diese Aktion kann nicht rückgängig gemacht werden.',
      globalPanicDone: '{{count}} Kampagne(n) beendet.',
      docCategoria: 'Kategorie',
      docCatNone: 'Keine Kategorie',
      fieldType: 'Kampagnentyp',
      fieldName: 'Name',
      fieldDescription: 'Beschreibung',
      fieldSlug: 'Slug der Landingpage',
      fieldScope: 'Geltungsbereich (OUs)',
      fieldExclusions: 'Ausschlüsse',
      fieldStart: 'Startdatum',
      fieldEnd: 'Enddatum',
      fieldTimezone: 'Zeitzone',
      fieldStreakMinimum: 'Serien-Minimum der Kampagne',
      streakMinimumInherit: 'Globalen Wert verwenden',
      streakMinimumHint: 'Sendungen, die diese Kampagne im Zeitraum für die Serie verlangt (1-20). Leer = es gilt das globale Minimum aus der Verwaltung.',
      streakMinimumLocked: 'Die Kampagne läuft bereits: Das Serien-Minimum kann sich nicht ändern, ohne den laufenden Zeitraum neu zu bewerten.',
      fieldRecognitionsLimitOwn: 'Sende-Limit der Kampagne',
      recognitionsLimitOwnInherit: 'Globalen Wert verwenden',
      recognitionsLimitNotApplicable: 'Nicht zutreffend (kein Sende-Limit)',
      recognitionsLimitNotApplicableShort: 'Kein Limit',
      fieldSameFundamentalLimit: 'Mal gleiches Fundamental an dieselbe Person',
      sameFundamentalInherit: 'Globalen Wert verwenden',
      sameFundamentalNotApplicable: 'Nicht zutreffend (kein Limit)',
      sameFundamentalNotApplicableShort: 'Kein Limit',
      recognitionsLimitOwnHint: 'Anerkennungen, die diese Kampagne pro Zeitraum erlaubt. Leer = das globale Gestión-Limit gilt. Jederzeit änderbar, auch wenn die Kampagne bereits aktiv ist.',
      fieldWrappedRelease: 'Wrapped-Veröffentlichung',
      wrappedReleaseOnFinish: 'Beim Abschluss der Kampagne',
      wrappedReleaseHint: 'Tag, an dem das Wrapped für den Geltungsbereich dieser Kampagne sichtbar wird, in ihrer eigenen Zeitzone. Leer = es erscheint, sobald die Kampagne auf Abgeschlossen wechselt.',
      visibility: 'Sichtbarkeit',
      visSender: 'Absender anzeigen',
      visFundamental: 'Grundprinzip anzeigen',
      visText: 'Text anzeigen',
      visHabit: 'Gewohnheit anzeigen',
      visSent: 'Zähler der gesendeten',
      visReceived: 'Zähler der erhaltenen',
      visAnonymous: 'Anonyme zulassen',
      visBulk: 'CSV-Massenimport',
      visReactions: 'Reaktionen (👏❤️😊🎉👍)',
      visCampaignTag: 'Kampagnen-Label anzeigen',
      visFromFundamentals: 'Senden aus den Fundamentals erlauben',
      visSendingDisabled: 'Versand von Anerkennungen deaktivieren',
      anonymousOverrideLabel: 'Anonyme Anerkennungen',
      anonymousOverrideInherit: 'Von Gestión übernehmen',
      anonymousOverrideAllow: 'Erlauben',
      anonymousOverrideDeny: 'Nicht erlauben',
      anonymousOverrideHint: 'Gilt NUR für diese Kampagne. Bei "Von Gestión übernehmen" verwendet diese Kampagne die globale Einstellung.',
      points: 'Punkte',
      pointsLocked: 'Die Punkte sind unveränderlich: die Kampagne ist bereits gestartet.',
      pointsHint: 'Nur Europa; das Frontend zeigt die Punkte nie an.',
      applyPoints: 'Die Kampagne vergibt Punkte',
      brillamosRecurringDesc: 'Wiederkehrende Nominierungskampagne auf Basis der Fundamentals.',
      paisScheduleTitle: 'Zeiten und Daten nach Land',
      paisScheduleIntro: 'Konfiguriere unterschiedliche Zeiten oder Daten pro Land. Ohne Angabe gilt das globale Fenster.',
      paisCol: 'Land',
      paisOpen: 'Öffnungszeit',
      paisClose: 'Schließzeit',
      paisActive: 'Aktiv',
      paisApplySchedule: 'Zeitfenster anwenden',
      paisClearHours: 'Zeitfenster leeren',
      paisOverrideBadge: 'OE-Kampagne',
      paisOverrideWins: 'Hat Vorrang vor dieser Zeile: {{alcance}}.',
      paisOverrideNoSend: 'Versand deaktiviert',
      paisOverrideDates: 'Daten {{inicio}} → {{fin}}',
      paisOverrideHours: 'Uhrzeit {{inicio}}–{{fin}}',
      paisScheduleNoActive: 'Es gibt keine aktive Shine-Together-Kampagne: Länderzeiten werden an der laufenden Kampagne gepflegt. Aktiviere eine Kampagne, um sie zu erfassen.',
      saveDraftFirst: 'Speichern Sie den Entwurf, um seine Dokumente zu verwalten.',
      saveDraft: 'Entwurf speichern',
      saveDraftLater: 'Der Entwurf wird gespeichert, sobald die Konfiguration abgeschlossen ist. Nutzen Sie „Weiter“, um durch die Schritte zu gehen.',
      dates: 'Daten',
      publishRequirements: 'Erfordert einen Namen in allen 7 Sprachen, mindestens eine OU im Geltungsbereich sowie Start- und Enddatum. Speichern wird aktiv, sobald die Konfiguration vollständig ist.',
      valNameAllLangs: 'Geben Sie den Namen in allen 7 Sprachen ein.',
      valScope: 'Wählen Sie mindestens eine Organisationseinheit im Geltungsbereich aus.',
      scopeConflict: "Diese Einheiten sind bereits in einer aktiven Kampagne: {{campanas}}. Entfernen Sie sie aus dem Geltungsbereich oder beenden Sie diese Kampagne.",
      valScopeConflict: "Der Geltungsbereich steht im Konflikt mit einer aktiven Kampagne: {{campanas}}.",
      scopeConflictPartial: "Es gibt mehr aktive Kampagnen als überprüft werden konnten: die Konfliktprüfung kann unvollständig sein.",
      scopeEmpty: "Sie haben keine Organisationseinheiten in Ihrem Bereich, um Kampagnen zu erstellen. Bitten Sie einen globalen Administrator, Ihnen einen Bereich zuzuweisen.",
      outOfScopeHint: "Diese Kampagne umfasst Organisationseinheiten außerhalb Ihres Bereichs: Nur ein Administrator, der alle abdeckt, kann sie bearbeiten.",
      valScopeExcludesOwn: "Sie können Ihre eigene Organisationseinheit nicht aus dem Geltungsbereich ausschließen.",
      valStart: 'Geben Sie das Startdatum der Kampagne ein.',
      valEnd: 'Geben Sie das Enddatum der Kampagne ein.',
      valTimezone: 'Wählen Sie die Zeitzone der Kampagne aus.',
      valDateOrder: 'Das Enddatum muss nach dem Startdatum liegen.',
      designMenu: 'Symbol und Titel im Seitenmenü',
      designMenuHint: 'So erscheint die Kampagne in der Seitenleiste der Plattform für die Nutzer.',
      designIcon: 'Symbol',
      designMenuTitle: 'Menütitel',
      designMenuTitlePh: 'z. B. LATAM Innovation',
      designSections: 'Landing-Abschnitte',
      designSectionsHint: 'Das Banner und das Nominierungsformular sind immer vorhanden. Aktivieren Sie die optionalen Abschnitte.',
      designShowStreak: 'Anerkennungsserie',
      designShowRecent: 'Neueste Anerkennungen',
      designBrillamosLocked: 'Die Identität von Shine Together ist unveränderlich: Ihr Design kann nicht bearbeitet werden.',
      approvalSent: 'Genehmigungsanfrage gesendet.',
      submitApproval: 'Zur Genehmigung einreichen',
      submitApprovalConfirmTitle: 'Zur Genehmigung einreichen',
      submitApprovalConfirmMsg: 'Diese Kampagne zur Genehmigung einreichen? Der Admin General muss sie prüfen, bevor sie aktiv wird.',
      prev: 'Zurück',
      next: 'Weiter',
      docLang: 'Sprache',
      docUrl: 'URL des Dokuments',
      docTitle: 'Titel',
      addDoc: 'Dokument hinzufügen',
      docCategoryRequired: 'Wähle eine Kategorie, bevor du das Dokument hinzufügst.',
      docTitleRequired: 'Vervollständige den Titel in allen 7 Sprachen, bevor du das Dokument hinzufügst.',
      docsEmpty: 'Es gibt keine Dokumente.',
      docsFallbackNote: 'Werden hier keine Dokumente hochgeladen, zeigt diese Kampagne die Dokumente aus dem Bereich Dokumentation der Verwaltung an.',
      approvalsTitle: 'Ausstehende Genehmigungen',
      approvalsSub: 'Kampagnen, die auf Ihre Genehmigung warten (AdminGlobal).',
      approvalsEmpty: 'Es gibt keine ausstehenden Genehmigungen.',
      colCampaign: 'Kampagne',
      requestedBy: 'Beantragt von',
      approve: 'Genehmigen',
      approveConfirmTitle: 'Kampagne genehmigen',
      approveConfirmMsg: 'Diese Kampagne genehmigen? Sie wird aktiv und für ihren Bereich sichtbar.',
      reject: 'Ablehnen',
      rejectReason: 'Grund der Ablehnung (erforderlich)',
      rejectConfirm: 'Ablehnung bestätigen',
      viewDetail: 'Details ansehen',
      bannerDesign: 'Banner-Design',
      bannerScopeLabel: 'Dieser Banner gilt nur für diese Kampagne; ohne Konfiguration wird der globale Banner des Programms übernommen.',
      bannerDesignHint: 'Wechseln Sie oben die Sprache, um Titel, Untertitel und Logo dieser Sprache zu bearbeiten — die Vorschau wird live aktualisiert.',
      bannerTitle1: 'Titel (Zeile 1)',
      bannerTitle2: 'Titel (Zeile 2)',
      bannerSubtitle: 'Untertitel',
      bannerLogoNote: 'Der Upload des Logobilds (PNG je Sprache) folgt in Kürze.',
      bannerLogo: 'Logo (Bild für diese Sprache)',
      bannerLogoUpload: 'PNG hochladen',
      bannerLogoReset: 'Auf Standard zurücksetzen',
      bannerLogoHint: 'Empfohlen: transparentes PNG ~4:3. Standardmäßig wird das Fundamentals-Logo angezeigt.',
      bannerLogoErrPng: 'Das Logo muss ein PNG sein.',
      bannerLogoErrSize: 'Das PNG darf 500 KB nicht überschreiten.',
      bannerPreview: 'Vorschau',
      bannerPreviewEmpty: 'Banner-Titel',
      bannerCta: 'Jemanden würdigen',
      brillamosBannerTitle: 'Shine-Together-Banner',
      brillamosBannerHint: 'Passe Untertitel und Logo des Shine-Together-Heros je Sprache an. Die Vorschau aktualisiert sich live.',
      brillamosBannerLogoHint: 'Empfohlen: transparentes PNG. Standardmäßig wird das Shine-Logo angezeigt.',
      entryPoints: 'Anerkennungsmodus (Entry Points)',
      entry: { A: 'Entry A — Klassisches Formular', B: 'Entry B — Interaktives Post-it (Word Builder)', both: 'Beide sichtbar (A/B-Test)' },
      commentRequired: 'Kommentar erforderlich',
      vista: 'Ansicht:',
      vistaGlobal: 'Globaler Admin',
      vistaOu: 'OU-Admin / Botschafter',
      rulesTitle: 'Sende-Regeln',
      brillamosRulesIntro: 'Diese Regeln gelten nur fuer Shine Together. Ein leeres Feld erbt den globalen Wert aus der Verwaltung.',
      ruleMultiPersona: 'Mehrere Personen',
      ruleMultiFundamental: 'Mehrere Fundamentals',
      ruleBulkCsv: 'CSV-Massenupload',
      ruleReactions: 'Reaktionen an der Wand',
      ruleSendingDisabled: 'Senden deaktivieren',
      ruleAnonymousEnabled: 'Anonyme Anerkennungen zulassen',
      anonymousGestionHint: 'Gilt für alles (Fundamentals, Brillamos und individuelle Kampagnen), außer eine Kampagne legt im Konfigurationsschritt des Assistenten eine eigene Einstellung fest. Betrifft nicht die automatische DSGVO-Anonymisierung in Europa.',
      ruleMinChars: 'Min. Zeichen',
      moderationTitle: 'Moderation',
      modPostEdit: 'Bearbeiten nach dem Senden',
      moderationNote: 'Die Melden-Schaltfläche und der Wortfilter werden im Bereich Moderation verwaltet.',
      resetToGlobal: 'Zurücksetzen (vom globalen Wert übernehmen)',
      streakTitle: 'Serien-Einstellungen (Fundamente)',
      streakActive: 'Serie aktiv',
      streakSentNote: 'Die Serie wird anhand GESENDETER Anerkennungen berechnet.',
      streakInProfile: 'Serie im Profil anzeigen',
      badgesActive: 'Abzeichen aktiv',
      streakPeriod: 'Zeitraum',
      periodWeekly: 'Wöchentlich',
      periodMonthly: 'Monatlich',
      periodDaily: 'Täglich',
      limitsTitle: 'Limits (Limit-Verwaltung)',
      limitsActive: 'Limits aktiv',
      limitName: 'Name',
      limitDescription: 'Beschreibung',
      limitRecognitionsDesc: 'Maximale Anerkennungen',
      limitFundamentalsDesc: 'Max. auswählbar pro Sendung',
      limitValue: 'Limit',
      limitFrequency: 'Häufigkeit',
      limitActiveCol: 'Aktiv',
      limitRecognitions: 'Anerkennungen pro Zeitraum',
      limitFundamentals: 'Fundamentals pro Anerkennung',
      perSubmission: 'Pro Sendung',
      readonlyTitle: 'Allgemeine Konfiguration — Fundamentals (standardmäßig angewendet)',
      readonlyBadge: 'Nur Lesen',
      readonlyNote: 'Wenn Sie eine Ausnahme nach OU hinzufügen möchten, wird sie vom globalen Admin genehmigt.',
      colDate: 'Datum',
      exc: {
        title: 'Ausnahmen nach OU',
        intro: 'Punktuelle Ausnahmen zur Basiskonfiguration für einen bestimmten OU/BU/Site-Geltungsbereich. Jede durchläuft die Genehmigung des globalen Admins.',
        new: 'Neue Ausnahme nach OU',
        colException: 'Ausnahme',
        colScope: 'OU / BU / Site',
        colState: 'Status der Ausnahme',
        fullOu: 'Gesamte OU',
        sites: '{{count}} Sites',
        scopePopTitle: 'Sites im Geltungsbereich',
        stateActive: 'Aktiv',
        stateInactive: 'Inaktiv',
        toggleHint: 'Nur eine genehmigte Ausnahme kann aktiviert oder deaktiviert werden.',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        empty: 'Noch keine Ausnahmen nach OU.',
        deleteTitle: 'Ausnahme löschen',
        deleteMsg: 'Diese Ausnahme nach OU wird dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteConfirm: 'Löschen',
        summaryTope: 'Limit: {{max}} Recos / {{freq}}',
        summaryDisable: 'Senden deaktivieren',
        disableTitle: 'Senden deaktivieren (Override)',
        disableNote: 'Blockiert vorübergehend das Senden von Anerkennungen für den gewählten Bereich, ohne das Programm zu deaktivieren. Erfordert die Freigabe des globalen Admins.',
        summarySchedule: 'Eingeschränkte Zeiten',
        summaryVisibility: 'Sichtbarkeit',
        summaryBanner: 'Banner',
        approvalsTitle: 'Genehmigungen',
        approvalsColSolicitante: 'Antragsteller',
        approvalsColAprobador: 'Genehmiger',
        approvalsColFecha: 'Datum',
        approvalsColEstado: 'Status',
        approved: 'Genehmigt',
        pending: 'Ausstehend',
        rejected: 'Abgelehnt',
        approvalsEmpty: 'Noch keine Ausnahmen zu genehmigen.',
        pendingBanner: 'Sie haben {{count}} Ausnahme(n), die auf Ihre Genehmigung warten.',
        approve: 'Genehmigen',
        reject: 'Ablehnen',
        rejectReason: 'Ablehnungsgrund (erforderlich)',
        rejectConfirm: 'Ablehnung bestätigen',
        back: 'Ausnahmen nach OU',
        wizardTitle: 'Ausnahme nach OU — Fundamentals',
        wizardTitleBrillamos: 'OU-Ausnahme — Gemeinsam Glänzen',
        stepScope: 'Geltungsbereich',
        stepSchedule: 'Zeitplan',
        stepBanner: 'Banner',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Basiskampagne',
        baseCampaignHint: 'Eine OU-Ausnahme funktioniert nicht allein: sie ÜBERSCHREIBT Teile einer aktiven Kampagne für deinen Geltungsbereich. Deckt keine aktive Kampagne diese OUs ab, hat diese Ausnahme keinerlei Wirkung. Wenn du eine eigene vollständige Kampagne für die OU brauchst, erstelle sie unter Kampagnen, nicht hier.',
        baseCampaignLabel: 'Überschriebene Kampagne',
        baseCampaignNone: 'Nicht angegeben (gilt für die aktive Kampagne, die den Bereich abdeckt)',
        baseCampaignNinguna: 'Es gibt keine aktive Kampagne von Gemeinsam Glänzen. Erstelle und aktiviere zuerst eine, sonst gilt diese Ausnahme für niemanden.',
        baseCampaignRequerida: 'Wähle die Basiskampagne, um speichern zu können: ohne sie würde die Ausnahme für niemanden gelten.',
        baseCampaignVentana: 'Die Basiskampagne läuft vom {{inicio}} bis {{fin}}. Diese Daten gehören zur Kampagne und werden hier nicht bearbeitet.',
        baseCampaignSinVentana: 'Für die Basiskampagne ist kein Zeitraum festgelegt.',
        scheduleWindow: 'Lokales Datum und Uhrzeit der Ausnahme',
        scheduleStart: 'Beginn der Ausnahme',
        scheduleEnd: 'Ende der Ausnahme',
        scheduleTz: 'Zeitzone',
        scheduleRestrictTitle: 'Anerkennungen deaktivieren',
        scheduleRestrictNote: 'Wenn aktiv, können außerhalb des für diesen Bereich konfigurierten Datums und der Uhrzeit keine Anerkennungen gesendet werden. Erfordert die Freigabe des globalen Admins.',
        scheduleWindowNota: 'Wenn du ein Zeitfenster festlegst, werden Sendungen in diesem Bereich darauf beschränkt. Leer lassen, um nichts einzuschränken.',
        scheduleInvalid: 'Das Zeitfenster erfordert Start- und Enddatum/-zeit, und das Ende muss nach dem Start liegen.',
        bannerTitle: 'Shine-Together-Banner (Override)',
        bannerIntro: 'Überschreibt Untertitel und Logo des Shine-Together-Banners nur für den Geltungsbereich dieser Ausnahme. Wenn Sie hier keine Sprache bearbeiten, bleibt der globale Banner unverändert.',
        bannerScopeLabel: 'Dieser Banner gilt nur für den Geltungsbereich dieser Ausnahme, nicht für den globalen Shine-Together-Banner.',
        stepDocs: 'Dokumente',
        stepVisibility: 'Sichtbarkeit',
        scopeIntro: 'Legen Sie den organisatorischen Geltungsbereich fest.',
        docsIntro: 'Fügen Sie spezifische Dokumente für diese Ausnahme nach OU hinzu.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Aktivierte Sendewege (Override)',
        entryPointModeApp: 'Nur Formular',
        entryPointModePostit: 'Nur interaktives Post-it',
        entryPointModeAmbos: 'Beide',
        visTitle: 'Sichtbarkeit der Anerkennung (Override)',
        visIntro: 'Legen Sie fest, welche Informationen dem Nutzer beim Empfang oder Anzeigen einer Anerkennung gezeigt werden.',
        visText: 'Text/Kommentar der Anerkennung anzeigen',
        visFundamental: 'Zugewiesenen Fundamental anzeigen',
        visSender: 'Namen des Absenders anzeigen',
        visHabit: 'Ausgewähltes Daily Habit anzeigen',
        visRanking: 'Ranking anderer OUs anzeigen',
        visMultiFund: 'Mehrere Fundamentals pro Anerkennung zulassen',
        maxFundamentales: 'Max. Fundamentals pro Anerkennung',
        rulesTitle: 'Senderegeln (Override)',
        ruleMultiPersona: 'Mehrere Personen',
        ruleComment: 'Kommentar erforderlich',
        ruleMinChars: 'Min. Zeichen',
        ruleCsv: 'CSV-Upload',
        modTitle: 'Moderation (Override)',
        modReport: 'Melden-Schaltfläche',
        modEditDelete: 'Bearbeiten- und Löschen-Schaltflächen (nur gesendete)',
        streakTitle: 'Serie (Override)',
        streakMin: 'Min. Sendungen/Woche',
        streakPeriod: 'Zeitraum',
        limitsTitle: 'Limits (Override)',
        limitMax: 'Max. Recos',
        limitFreq: 'Häufigkeit',
        approvalRequiredTitle: 'Genehmigung erforderlich',
        approvalRequiredMsg: 'Alle Änderungen müssen vom globalen Admin genehmigt werden, bevor sie wirksam werden.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Haufigkeit',
      frecuenciaPlaceholder: 'z. B. Monatlich, Alle 3 Meetings…',
      frecuencia: {
        mensual: 'Monatlich',
        trimestral: 'Vierteljahrlich',
        cadaNReuniones: 'Alle 3 Meetings',
        porEvento: 'Pro Ereignis',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Kampagne reaktivieren',
      undoPanicConfirm: 'Diese Kampagne wird reaktiviert und in ihrem Bereich wieder sichtbar. Nur innerhalb von 24 h moglich. Fortfahren?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Teilnehmerziel",
      metaParticipantesInherit: "Kein Ziel",
      metaParticipantesHelp: "Unterschiedliche Personen, die teilnehmen — anerkennend oder anerkannt. Leer = kein Ziel.",
      tooltip: {
        entryPoints: 'Wie Mitarbeitende jemanden anerkennen können: klassisches Formular, interaktives Post-it oder beides gleichzeitig.',
        ruleMultiPersona: 'Ermöglicht es, mehr als eine Person als Empfänger in derselben Anerkennung einzuschließen.',
        ruleMultiFundamental: 'Ermöglicht es, mehr als ein Fundamental in derselben Anerkennung zu markieren.',
        commentRequired: 'Erfordert einen Kommentar, um die Anerkennung senden zu können.',
        ruleBulkCsv: 'Aktiviert den Massenimport von Anerkennungen per CSV-Datei.',
        ruleReactions: 'Ermöglicht es anderen Personen, mit Emojis auf eine Anerkennung zu reagieren.',
        ruleSendingDisabled: 'Schaltet den Versand von Anerkennungen für diesen Bereich vollständig ab, ohne bereits gesendete zu beeinträchtigen.',
        ruleAnonymousEnabled: 'Ermöglicht es, eine Anerkennung zu senden, ohne den Namen der absendenden Person anzuzeigen.',
        modPostEdit: 'Ermöglicht es, eine bereits gesendete Anerkennung innerhalb des Bearbeitungsfensters zu bearbeiten.',
        antiSpoiler: 'Blendet aktuelle Anerkennungen auf der Startseite aus, damit vor dem Abschluss keine Überraschungen verraten werden.',
        streakActive: 'Aktiviert die wöchentliche Serienzählung von Anerkennungen für diese Kampagne.',
        dailyHabitsMandatory: 'Erfordert die Markierung einer täglichen Gewohnheit, damit die Anerkennung für die Serie zählt.',
        streakInProfile: 'Zeigt die aktuelle Serie im öffentlichen Profil der Nutzerin bzw. des Nutzers an.',
        badgesActive: 'Aktiviert die Vergabe von Abzeichen für das Erreichen von Serienzielen.',
        limitsActive: 'Aktiviert die unten festgelegten Versandgrenzen, sowohl für Anerkennungen als auch für Fundamentals.',
        recognitionsLimitActive: 'Wendet die Obergrenze für Anerkennungen pro Zeitraum auf diesen Bereich an.',
        recognitionsLimitDisabled: 'Aktivieren Sie „Nicht zutreffend“, damit diese Kampagne KEIN Gesamt-Sendelimit hat: eine Person kann im Zeitraum beliebig viele Anerkennungen senden, unabhängig vom globalen Limit in der Verwaltung. Deaktiviert lassen (und das Feld leer), um das globale Limit zu verwenden.',
        streakMinimum: 'Mindestanzahl an Anerkennungen, die eine Person im Zeitraum SENDEN muss, damit dieser für ihre Serie zählt (1-20). Überschreibt das globale Minimum aus der Verwaltung nur für diese Kampagne; leer = das globale gilt. Nach dem Start der Kampagne nicht mehr änderbar.',
        recognitionsLimitOwn: 'Maximale GESAMTZAHL an Anerkennungen, die eine Person im Zeitraum senden kann (an beliebige Personen, beliebiges Fundamental). Überschreibt das globale Limit aus der Verwaltung nur für diese Kampagne; leer = das globale gilt. Jederzeit änderbar, auch nach dem Start der Kampagne.',
        sameFundamentalLimit: 'Wie oft eine Person eine andere zum GLEICHEN Fundamental im Zeitraum anerkennen kann (an dieselbe Person). Überschreibt den globalen Wert aus der Verwaltung nur für diese Kampagne; leer = das globale gilt. In Europa bleibt das gesetzliche Minimum (DSGVO) erhalten.',
        sameFundamentalLimitDisabled: 'Aktivieren Sie „Nicht zutreffend“, um dasselbe Fundamental an dieselbe Person OHNE Limit zu wiederholen, unabhängig vom globalen Wert. Deaktiviert lassen (und das Feld leer), um das globale zu verwenden. In Europa bleibt das gesetzliche Limit auch bei Aktivierung erhalten.',
        fundamentalsLimitActive: 'Wendet die Obergrenze für Fundamentals pro Versand auf diesen Bereich an.',
        designShowStreak: 'Zeigt den Serien-Block auf der Landingpage dieser Kampagne an.',
        designShowRecent: 'Zeigt aktuelle Anerkennungen auf der Landingpage dieser Kampagne an.',
        visSender: 'Zeigt den Namen der Person an, die die Anerkennung sendet.',
        visFundamental: 'Zeigt das in der Anerkennung zugewiesene Fundamental an.',
        visText: 'Zeigt den Text bzw. Kommentar der Anerkennung an.',
        visHabit: 'Zeigt das ausgewählte Daily Habit an, sofern zutreffend.',
        visSent: 'Zeigt den Tab für gesendete Anerkennungen an.',
        visReceived: 'Zeigt den Tab für erhaltene Anerkennungen an.',
        visBulk: 'Aktiviert den CSV-Massenimport nur für diese Kampagne.',
        visReactions: 'Aktiviert Emoji-Reaktionen nur für diese Kampagne.',
        visCampaignTag: 'Zeigt das Etikett mit dem Kampagnennamen auf jedem Post-it an.',
        visFromFundamentals: 'Ermöglicht es, diese Anerkennung von der Fundamentals-Seite aus zu starten.',
        visSendingDisabled: 'Schaltet den Versand von Anerkennungen nur für diese Kampagne ab.',
        applyPoints: 'Anerkennungen in dieser Kampagne vergeben einlösbare Punkte. Kann nicht mehr abgeschaltet werden, sobald die Kampagne gestartet ist.',
        visRanking: 'Zeigt das Ranking im Vergleich zu anderen OUs an.',
        visMultiFund: 'Ermöglicht es, mehr als ein Fundamental zu markieren, als Ausnahme für diese OU.',
        modReport: 'Ermöglicht es, eine unangemessene Anerkennung zu melden.',
        modEditDelete: 'Aktiviert das Bearbeiten und Löschen einer bereits gesendeten Anerkennung, nur für diese OU. Das Backend behandelt beide Berechtigungen als einen einzigen Schalter.',
        scheduleEnabled: 'Beschränkt den Versand von Anerkennungen auf das oben festgelegte Zeitfenster.',
        disableSend: 'Blockiert den Versand von Anerkennungen für diesen konkreten Bereich.',
        paisActive: 'Wenn deaktiviert, ist die Kampagne für dieses Land nicht mehr aktiv, selbst wenn das konfigurierte Datum und Zeitfenster noch gültig sind.',
        paisApplySchedule: 'Ausgeschaltet bleiben Datum und Uhrzeit dieser Zeile gespeichert, werden aber NICHT angewendet: das Land hat keine zeitliche Einschränkung. Praktisch, um ein Fenster vorzubereiten und später einzuschalten, ohne es neu zu erfassen.',
      },
      tooltipAria: 'Hilfe',
    },
    reports: { desc: 'Berichte und Analytics des Programms.' },
    translate: {
      button: 'In die anderen Sprachen übersetzen',
      buttonFrom: 'Von {{lang}} in die anderen Sprachen übersetzen',
      loading: 'Übersetzen…',
      hint: 'Geben Sie mindestens eine Sprache ein, um zu übersetzen.',
      error: 'Die automatische Übersetzung ist fehlgeschlagen.',
      sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte lade die Seite neu und melde dich erneut an.',
    },
    misSolicitudes: {
      title: "Meine Kampagnenanträge",
      desc: "Der Status Ihrer Vorschläge. Sie können einen Antrag zurückziehen, solange er aussteht, und ihn erneut einreichen, wenn er abgelehnt wurde.",
      empty: "Sie haben noch keine Anträge gesendet.",
      colCampana: "Kampagne",
      colFecha: "Antragsdatum",
      colEstado: "Status",
      colComentario: "Kommentar",
      colAcciones: "Aktionen",
      editar: "Bearbeiten",
      retirar: "Antrag zurückziehen",
      reenviar: "Erneut einreichen",
      estado: {
        pendiente: "Ausstehend",
        aprobada: "Genehmigt",
        rechazada: "Abgelehnt",
      },
    },
    management: {
      desc: 'Versandregeln, Obergrenzen und Serie.',
      title: 'Steuerung',
      descLong: 'Globale Einstellungen: Seriendescription ×7, Abzeichen, globale Schalter und Freeze. Atomares Speichern.',
      fixValidation: 'Beheben Sie die Validierungen vor dem Speichern.',
      streakDescription: 'Beschreibung der Serie',
      fundamentalsTitle: 'Verfügbare Fundamentals',
      fundamentalsDesc: 'Welche Fundamentals beim Anerkennen angeboten werden. Eines zu entfernen löscht es nicht aus dem Katalog: es erscheint nur in diesem Programm nicht mehr.',
      fundamentalsLastOne: 'Das ist das letzte verfügbare: Wird es entfernt, könnte niemand mehr eine Anerkennung senden.',
      avatarTitle: 'Avatar-Einstellungen (Frontline)',
      avatarDesc: 'Frontline-Nutzende, die über die Webapp einsteigen, können einen Farbavatar anpassen. Wer über Teams kommt, behält sein Profilbild.',
      avatarEnabled: 'Anpassbarer Avatar aktiv',
      avatarSelector: 'Auswahl nach der Registrierung zeigen',
      avatarColors: 'Verfügbare Farben:',
      placeholderTitle: 'Konfigurierbare Beschreibung des Textfelds',
      placeholderDesc: 'Der Hilfetext des Nachrichtenfelds beim Anerkennen. Jede leer gelassene Sprache nutzt den Produkttext.',
      placeholderLabel: 'Hilfetext der Nachricht',
      panicTitle: 'Notaus-Schalter — Brillamos Juntos',
      panicDesc: 'Deaktiviert sofort das Senden von Anerkennungen in allen aktiven Kampagnen. Gilt sowohl für Shine Together als auch für Anerkennen (Fundamentals). Nur General-Admin.',
      panicToggle: 'Globaler Kill-Switch Brillamos',
      panicActiveHint: 'Das Senden ist DEAKTIVIERT: Derzeit kann niemand Anerkennungen senden.',
      panicSameSwitchHint: 'Dies ist ein globaler Schalter: solange er aktiv ist, kann keine Einstellung pro Programm oder pro Kampagne das Senden wieder aktivieren.',
      panicNoActiveCampaign: 'Dieser Schalter wird verfügbar, sobald mindestens eine Shine Together-Kampagne aktiv ist (RN-C08). Derzeit gibt es keine, also auch keine Kampagnen-Einsendungen zum Stoppen.',
      needAllLangs: 'Füllen Sie alle 7 Sprachen aus.',
      globalToggles: 'Globale Schalter',
      streakEnabled: 'Serie aktiv',
      multinomination: 'Mehrfachnominierung',
      dailyHabitsMandatory: 'Tägliche Gewohnheiten verpflichtend',
      antiSpoiler: 'Anti-Spoiler',
      antiSpoilerTitle: 'Anti-Spoiler-Modus (Preisverleihung)',
      antiSpoilerDesc: 'Blendet während der jährlichen Preisverleihung vorübergehend fremde Profile und Anerkennungen aus, damit die Gewinner nicht verraten werden.',
      antiSpoilerActivo: 'Anti-Spoiler aktiv',
      antiSpoilerFrom: 'Von',
      antiSpoilerTo: 'Bis',
      antiSpoilerHint: 'Solange er aktiv ist, sehen Mitarbeitende weder Profile von Kolleginnen und Kollegen noch die Details fremder Anerkennungen.',
      antiSpoilerSinVentana: 'Ohne Datumsangaben schützt er, solange der Schalter an ist.',
      antiSpoilerVentanaInvertida: '„Von“ liegt nach „Bis“: so schützt das Zeitfenster nie. Bitte korrigieren, um speichern zu können.',
      wrappedByOu: 'Wrapped pro OU',
      reactionsEnabled: 'Reaktionen (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Senden an Brillamos erlauben',
      allowPostEdit: 'Bearbeitung nach dem Senden',
      postEditTitle: 'Bearbeitung gesendeter Anerkennungen',
      postEditDesc: 'Erlaubt es der sendenden Person, den Text einer bereits gesendeten Anerkennung zu bearbeiten. Standardmäßig aus.',
      postEditWindow: 'Bearbeitungsfenster',
      postEditWindowOpt: { '24h': '24 Stunden', '48h': '48 Stunden', '7d': '7 Tage', unlimited: 'Ohne Begrenzung' },
      streakPerPersonCapEnabled: 'Obergrenze pro Person (Serie)',
      streakPerPersonCap: 'Max. pro Person (Serie)',
      weeklyMinimum: 'Minimum pro Zeitraum',
      periodicity: 'Periodizität',
      period: { weekly: 'Wöchentlich', monthly: 'Monatlich' },
      periodicityHint: 'Das Minimum gilt für den gewählten Zeitraum: bei Monatlich wächst oder reißt die Serie pro Kalendermonat, nicht pro Woche.',
      periodicityMonthlyWarning: 'Bei Monatlich zählt die Serie aufeinanderfolgende MONATE, und die App zeigt das bereits so (Widget, Profil, Wrapped und Schwellen). ZWEI Produktentscheidungen stehen vor der Aktivierung in der Produktion aus: RF-038 definiert die Abzeichen-Schwellen in Wochen (1/4/8/12/20), das 4er-Abzeichen käme also nach 4 Monaten; und die Missbrauchsgrenze von 2 Anerkennungen pro Person gilt statt pro Woche nun pro Monat, was ein hohes Minimum in kleinen Teams unerreichbar machen kann.',
      freezeFrom: 'Freeze ab',
      freezeTo: 'Freeze bis',
      badges: 'Abzeichen',
      noBadges: 'Es sind keine Abzeichen konfiguriert.',
      badge: 'Abzeichen',
      weeksRequired: '{{count}} Wochen',
      weeksRequiredOne: '{{count}} Woche',
      weeksRequiredMany: '{{count}} Wochen',
      badgeName: 'Name des Abzeichens',
      badgeIcon: 'Symbol',
      badgeColor: 'Farbe',
      weeks: 'Erforderliche Wochen',
      notApplicable: 'Nicht zutreffend',
      iconFormatInvalid: 'Ungültiges Bildformat. Verwenden Sie PNG, JPG, WEBP oder SVG.',
      addBadge: '+ Abzeichen hinzufügen',
      editBadge: 'Bearbeiten',
      deleteBadge: 'Löschen',
      deleteBadgeConfirm: 'Abzeichen „{{name}}“ löschen? Name in allen 7 Sprachen, Symbol und Schwellenwert gehen verloren. Die Löschung wird beim Speichern wirksam.',
      badgeActive: 'Aktiv',
      badgeInactive: 'Inaktiv',
      imageUploadHintNew: 'Speichern Sie das Abzeichen zuerst, um das Symbol hochladen zu können.',
      previewTitle: 'Vorschau',
      saveBadgeChanges: 'Änderungen speichern',
    },
    // PHASE 7 (Demo-Parität, H-93/H-94/H-95) — Admin › Benachrichtigungen (REQ-135).
    notifications: {
      title: 'Benachrichtigungseinstellungen',
      desc: 'Legen Sie fest, welche E-Mail-Hinweise gesendet werden und auf welcher Organisationsebene. Auf dieser Ebene nicht definierte Werte werden von der nächsten geerbt.',
      precedenceTitle: 'Wie die Konfiguration aufgelöst wird',
      precedence1: 'Vorrang: Site > BU > OU > Global. Es gilt der Wert der spezifischsten Ebene.',
      precedence2: 'Ein Schalter auf «Geerbt» ist nicht ausgeschaltet: Er übernimmt den Wert der darunterliegenden Ebene. Gespeichert wird nur, was Sie hier definieren.',
      precedence3: 'Jede Person kann ihre eigenen E-Mails zusätzlich im Profil abbestellen; diese Einstellung reaktiviert nie, was hier ausgeschaltet wurde.',
      scopeTitle: 'Konfigurationsebene',
      scopeUnit: 'Einheit',
      scopePick: 'Einheit auswählen…',
      scopeRequired: 'Wählen Sie eine Einheit, um ihre Konfiguration zu sehen und zu bearbeiten.',
      scopeOuContext: 'OU der Einheit',
      scopeOuFirst: 'Zuerst eine OU auswählen…',
      unsavedLock: 'Es gibt ungespeicherte Änderungen; die Ebene bleibt fest, bis Sie speichern oder verwerfen.',
      discard: 'Änderungen verwerfen',
      scope: { global: 'Global (gesamter Tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'E-Mail', categories: 'Hinweistypen', summary: 'Periodische Zusammenfassung', blocked: 'Gesperrte E-Mails' },
      blocked: {
        desc: 'Adressen, die keine E-Mail des Programms erhalten, unabhängig von ihren persönlichen Einstellungen.',
        scopeWarning: 'Die Sperre gilt für den GESAMTEN Tenant, nicht nur für diese Ebene: eine hier gesperrte Adresse ist in allen OUs gesperrt. Sie sticht auch den Hauptschalter.',
        placeholder: 'name@unternehmen.com',
        add: 'Sperren',
        remove: 'Sperre für {{email}} aufheben',
        empty: 'Keine gesperrten E-Mails.',
      },
      design: {
        title: 'E-Mail-Design',
        desc: 'So sehen sie heute aus: Die Fundamentals nutzen einen warmen Stil, Shine Together einen dunklen mit Sternen. Das Design jeder E-Mail wird direkt in der Vorlage festgelegt, nicht hier.',
        fund: { name: 'Fundamentals', style: 'Warmer Stil · Creme/Orange' },
        shine: { name: '✨ Shine Together', style: 'Dunkler Stil · Sterne/Violett' },
      },
      broadcast: {
        title: 'Systemmeldungen',
        desc: 'Für Wartungen, Ausfälle oder einmalige Hinweise. Wird mit der bereits gestalteten Vorlage gesendet: schreib nur die Nachricht.',
        overridesHint: '🔴 Diese Meldung erreicht ALLE, auch wer seine Benachrichtigungen abgeschaltet hat. Sie ist kein Programminhalt, sondern Information über das Werkzeug.',
        kindLabel: 'Art der Meldung',
        kind: { maintenance: 'Geplante Wartung', suspension: 'Vorübergehende Störung', restored: 'Dienst wiederhergestellt', general: 'Allgemeiner Hinweis' },
        subject: 'Betreff',
        subjectPlaceholder: 'Geplante Wartung — Samstag 2 Uhr',
        message: 'Nachricht',
        messagePlaceholder: 'Nachricht für die Nutzenden...',
        everyone: 'Alle',
        singleOu: 'Eine bestimmte OU',
        chooseOu: 'OU auswählen',
        send: 'Meldung jetzt senden',
        error: 'Die Meldung konnte nicht gesendet werden.',
        sentSummary: 'An {{sent}} von {{recipients}} Personen gesendet.',
        skipped: '· {{count}} ohne auflösbare Identität haben sie nicht erhalten.',
      },
      channel: { inapp: 'Glocke', email: 'E-Mail', teams: 'Teams' },
      tables: {
        shine: '✨ Benachrichtigungen — Shine Together',
        admin: '🛡️ Benachrichtigungen — Admin',
        colType: 'Typ',
        colSubject: 'Betreff (ES)',
        colLanguages: 'Sprachen',
        editSubject: 'Betreff von „{{row}}“ in allen 7 Sprachen bearbeiten',
        subjectByLanguage: 'Betreff nach Sprache',
        close: 'Schließen',
        saveSubject: 'Betreff speichern',
        nineRows: 'Neun Zeilen statt dreizehn: vier der im Mockup gezeichneten entsprechen keiner Benachrichtigung, die das System heute sendet.',
        rows: {
          'campaign-new': { name: 'Neue Kampagne gestartet', trigger: 'Ein Admin aktiviert eine Kampagne' },
          'campaign-ending': { name: 'Kampagne endet bald', trigger: 'Letzte Tage zum Nominieren' },
          'recognition-sent': { name: 'Anerkennung an Shine Together gesendet', trigger: 'Bestätigung, dass sie zur Kampagne zählt' },
          'ranking-position': { name: 'Position im Ranking', trigger: 'Du steigst im Leaderboard auf' },
          'campaign-approval': { name: 'Kampagnenantrag einer Einheit', trigger: 'Ein OU-Admin stellt einen Antrag → Global-Admin' },
          'moderation-case-alert': { name: 'Moderationsmeldung', trigger: 'Eine neue Meldung wartet auf den OU-Admin' },
          'moderation-educational': { name: 'Gemeldete Nachricht, Hinweis an den Absender', trigger: 'Informiert die Person, die die Anerkennung gesendet hat' },
          'low-participation-alert': { name: 'Warnung bei geringer Beteiligung', trigger: 'Eine Kampagne liegt unter dem Beteiligungsschwellenwert' },
          'pending-nomination-manager': { name: 'Offene Nominierung (Führungskraft)', trigger: 'Eine Nominierung muss genehmigt werden' },
        },
      },
      master: {
        label: 'E-Mail-Benachrichtigungen',
        desc: 'Hauptschalter: Ist er aus, wird in diesem Bereich keine Programm-E-Mail versendet. Betrifft weder Teams noch die Glocke.',
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Erhaltene Anerkennungen', desc: 'Hinweis an die Person, wenn sie jemand anerkennt.' },
        streakAndBadgesEnabled: { label: 'Serien und Abzeichen', desc: 'Serien-Erinnerungen und freigeschaltete Abzeichen.' },
        campaignsEnabled: { label: 'Kampagnen', desc: 'Neue Kampagne, endende Kampagne, Gewinner und Freigaben.' },
        digestEnabled: { label: 'Wöchentliche Zusammenfassung', desc: 'Digest mit der gesammelten Aktivität der Woche.' },
      },
      monthly: {
        label: 'Monatliche Zusammenfassung',
        desc: 'Standardmäßig aus. Nur aktivieren, wenn diese Einheit zusätzlich eine monatliche Zusammenfassung wünscht.',
      },
      masterOffHint: 'Die einzelnen Typen wirken nur bei eingeschaltetem Hauptschalter.',
      inherited: 'Geerbt',
      inApp: { label: 'In-App-Benachrichtigungen (Glocke)', desc: 'Die Glocke im Portal. Sie hängt nicht vom E-Mail-Schalter ab: es ist ein eigener Kanal.' },
      teams: { label: 'Teams Activity Feed', desc: 'Der Hinweis im Teams-Aktivitätsfeed, für Personen mit Firmenkonto.' },
      frequency: {
        label: 'Sendefrequenz (E-Mail)',
        desc: 'Wie oft Hinweise zu einer Zusammenfassung gebündelt werden. E-Mails pro Ereignis sind nicht betroffen.',
        opt: {
          immediate: 'Sofort (pro Ereignis)',
          daily: 'Tägliche Zusammenfassung',
          weekly: 'Wöchentliche Zusammenfassung',
          biweekly: 'Zweiwöchentliche Zusammenfassung',
        },
        immediateHint: 'Mit „Sofort“ wird keine Zusammenfassung verschickt, auch wenn die Kategorie aktiv bleibt: jeder Hinweis geht einzeln raus.',
      },
      resetToInherited: 'Zurück auf geerbt',
      active: 'aktiv',
      saved: 'Änderungen gespeichert!',
      loadError: 'Die Konfiguration dieser Ebene konnte nicht geladen werden.',
      saveError: 'Die Konfiguration konnte nicht gespeichert werden. Bitte erneut versuchen.',
    },
    views: {
      title: 'Benutzeransichten',
      desc: 'Für Mitarbeitende sichtbare Ansichten und Microsites.',
      descLong: 'Welche Ansichten jede OU ihren Mitarbeitenden anbietet. Desktop + mobil.',
      scope: 'Konfigurationsebene',
      scopeGlobal: 'Global (alle OUs)',
      unsavedLock: 'Speichern oder verwerfen Sie die Änderungen, bevor Sie die Ebene wechseln.',
      infoAria: 'Hilfe zu {{label}}',
      micrositesTitle: 'Microsite-URLs pro Fundamental',
      micrositesDesc: 'Externer Link mit mehr Infos zu jedem Fundamental. Leer lassen, wenn es keine Microsite gibt.',
      card: {
        medallero: { label: 'Medaillenspiegel', desc: 'Gesendet + erhalten' },
        perfilUsuario: { label: 'Benutzerprofil', desc: 'Erhalten neu→alt' },
        enviarReconocimiento: {
          label: 'Anerkennung senden', desc: 'Gemäß Admin-Konfiguration',
          tooltip: 'Zeigt die Schaltfläche und das Formular, um einen Kollegen anzuerkennen. Kombiniert sich mit dem allgemeinen Sende-Schalter: Ist dieser deaktiviert, erscheint diese Ansicht nicht, selbst wenn sie hier aktiviert ist.',
        },
        historicoPorAnio: {
          label: 'Verlauf nach Jahr', desc: 'Aktuelles Jahr zuerst',
          tooltip: 'Zeigt den Anerkennungsverlauf gruppiert nach Jahr, aktuelles Jahr zuerst. Hängt außerdem davon ab, dass die aktive Kampagne den Verlauf aktiviert hat.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Rangliste',
          tooltip: 'Zeigt die Rangliste der Personen mit den meisten gesendeten oder erhaltenen Anerkennungen. Sie ist die einzige Ansicht, die standardmäßig deaktiviert ist.',
        },
        feedActividad: { label: 'Aktivitäts-Feed', desc: 'Aktuelle Timeline' },
        resumenMensual: {
          label: 'Monatsrückblick', desc: 'Wrap-up im Spotify-Stil',
          tooltip: 'Aktiviert den Rückblick im „Wrapped“-Stil mit den Zahlen des Zeitraums für jede Person. Wird nur angezeigt, wenn Wrapped für die OU aktiviert ist und die Kampagne bereits abgeschlossen ist.',
        },
        busquedaCompaneros: {
          label: 'Kollegensuche', desc: 'Medaillenspiegel anderer ansehen',
          tooltip: 'Ermöglicht die Suche nach anderen Kollegen und das Ansehen ihres Medaillenspiegels. Wird während des aktiven Anti-Spoiler-Modus automatisch ausgeblendet, damit vor einer Preisverleihung nichts verraten wird.',
        },
        vistaFundamentales: {
          label: 'Fundamentals-Ansicht', desc: 'Infos zu jedem Fundamental',
          tooltip: 'Zeigt die Konstellation mit den Informationen zu jedem Kultur-Fundamental innerhalb des Brillamos-Juntos-Bildschirms.',
        },
        banderaReportar: {
          label: 'Melde-Flagge', desc: 'Unangemessene Anerkennungen melden',
          tooltip: 'Fügt eine Schaltfläche hinzu, mit der Mitarbeitende eine unangemessene Anerkennung melden können. Hängt außerdem davon ab, dass die Melde-Flagge unter Moderation aktiviert ist.',
        },
        recordatorioDiario: { label: 'Tägliche Erinnerung', desc: 'Täglicher Anstoß zum Anerkennen' },
        verATuEquipo: {
          label: 'Dein Team ansehen', desc: 'Nur für Führungskräfte',
          tooltip: 'Ermöglicht Führungskräften und Managern, die Anerkennungen der von ihnen geführten Personen zu sehen. Gilt nur für Personen, die im Organigramm als Führungskraft geführt werden und die Team-Kennzahlen-Berechtigung besitzen.',
        },
      },
      compose: {
        sending: 'Hängt zusätzlich vom Notaus-Schalter ab: bei deaktiviertem Senden erscheint diese Ansicht nicht, auch wenn sie hier aktiv ist.',
        campaign: 'Hängt zusätzlich vom Verlaufs-Toggle der aktiven Kampagne ab (RN-PR09).',
        wrapped: 'Hängt zusätzlich davon ab, dass die OU Wrapped aktiviert hat und ihre Kampagne beendet ist.',
        antiSpoiler: 'Hängt zusätzlich vom Anti-Spoiler-Modus ab: solange dessen Fenster aktiv ist, bleibt die Ansicht verborgen.',
        report: 'Hängt zusätzlich vom Toggle „Melde-Button“ im Bereich Moderation ab.',
        manager: 'Hängt zusätzlich davon ab, Führungskraft im Organigramm zu sein und die Team-Metriken-Berechtigung zu haben.',
      },
    },
    docs: {
      desc: 'Unternehmens- und Rechtsdokumente.',
      legalTab: 'Rechtsgrundlagen',
      privacyTab: 'Datenschutzhinweis',
      corpTab: 'Unternehmen',
      pillsTab: 'Benutzer-Pills',
      bibliotecaTab: 'Bibliothek',
      legalesTab: 'Rechtsdokumente',
      gestionTitle: 'Dokumentenverwaltung',
      gestionDesc: 'Konfigurieren Sie die Benutzer-Schnellzugriffe, verwalten Sie die Dateibibliothek und die obligatorischen Rechtsdokumente.',
      pills: {
        nueva: 'Pille hinzufügen',
        sectionTitle: 'Schnellzugriff (Pills)',
        sectionSubtitle: 'Schnellzugriff-Kapseln, die in der Benutzeroberfläche sichtbar sind. Lege Name, Symbol, Farbe und den Inhalt fest, den sie beim Klick öffnen.',
        editar: 'Pille bearbeiten',
        titulo: 'Titel',
        tipo: 'Typ',
        tipos: { documento: 'Dokument', url: 'Link', video: 'Video' },
        icono: 'Symbol',
        color: 'Farbe',
        orden: 'Reihenfolge',
        documento: 'Unternehmensdokument',
        elegirDocumento: 'Dokument wählen…',
        sinDocumentos: 'Keine Unternehmensdokumente verfügbar. Laden Sie sie im Tab „Unternehmen“ hoch.',
        url: 'Ziel-URL',
        visibilidad: 'Sichtbarkeit nach OE',
        visibilidadHint: 'Keine OE ausgewählt = für alle Einheiten sichtbar.',
        activa: 'Aktive Pille (im Rail sichtbar)',
        activaSi: 'Aktiv',
        activaNo: 'Inaktiv',
        estado: 'Status',
        vistaPrevia: 'Vorschau',
        nombre: 'Name',
        tipoContenido: 'Inhaltstyp',
        documentoColumna: 'Verknüpftes Dokument',
        documentoNoEncontrado: 'Dokument nicht gefunden',
        documentoAlcanceIncompleto: 'Deckt nicht alle OUs dieser Pill ab',
        sinTitulo: 'Ohne Titel',
        todas: 'Alle',
        vacio: 'Noch keine Schnellzugriffe konfiguriert.',
        eliminar: 'Pille löschen',
        eliminarConfirm: 'Diesen Schnellzugriff aus dem Rail entfernen?',
        errorCargar: 'Schnellzugriffe konnten nicht geladen werden.',
        errorGuardar: 'Schnellzugriff konnte nicht gespeichert werden.',
        errorEliminar: 'Schnellzugriff konnte nicht gelöscht werden.',
      },
      corp: {
        firstLogin: 'Erster Login',
        versionEs: 'Version ES',
        versionEn: 'Version EN',
        subirVersion: 'Hochladen',
        reemplazar: 'Ersetzen',
        verVersion: 'Version ansehen',
        quitarVersion: 'Version entfernen',
        triggerUpdate: 'Update auslösen',
        ousActivas: 'Aktive OUs',
        nombre: 'Dokumentname',
        tipo: 'Typ',
        visibilidad: 'Sichtbarkeit nach OE',
        idiomas: 'Sprachen',
        idiomasHint: 'Keine Auswahl = alle Sprachen.',
        versionesPorIdioma: 'Versionen pro Sprache',
        versionesPorIdiomaCount: 'Versionen ({{count}}/{{total}})',
        archivo: 'PDF-Datei',
        elegirArchivo: 'PDF auswählen…',
        subir: 'Dokument hochladen',
        agregarDocumento: 'Dokument hinzufügen',
        subirArchivo: 'Datei hochladen',
        libType: { todos: 'Alle', pdf: 'PDF', video: 'Video', imagen: 'Bild' },
        filterType: 'Typ',
        nombreArchivo: 'Dateiname',
        idioma: 'Sprache',
        pillAsignado: 'Zugewiesene Pille',
        subido: 'Hochgeladen',
        documento: 'Dokument',
        actualizado: 'Aktualisiert',
        mediaKind: 'Dateityp',
        externalUrl: 'Externe URL',
        externalUrlHint: 'Füge den Video- oder Bildlink ein (Teams, SharePoint usw.).',
        requiereUrl: 'Gib eine gültige externe URL ein.',
        abrir: 'Öffnen',
        dropMain: 'Dateien hierher ziehen oder zum Hochladen klicken',
        dropSub: 'PDF · Max. 25 MB pro Datei',
        subidoOk: 'Dokument hochgeladen.',
        errorSubir: 'Das Dokument konnte nicht hochgeladen werden.',
        lista: 'Hochgeladene Dokumente',
        listaCount: '{{count}} Dokumente konfiguriert',
        legalInfo: 'Diese Dokumente werden im obligatorischen Akzeptanz-Dialog angezeigt. Erster Login aktiviert sie beim ersten Zugriff. Aktualisierung auslösen zeigt sie erneut an, auch wenn der Benutzer sie bereits akzeptiert hat. Eine ausdrückliche Zustimmung ist zum Fortfahren erforderlich.',
        searchPlaceholder: 'Datei suchen…',
        filterLang: 'Nach Sprache filtern',
        filterLangAll: 'Alle Sprachen',
        noResults: 'Keine Dokumente entsprechen dem Filter.',
        vacio: 'Es gibt noch keine Unternehmensdokumente.',
        fecha: 'Datum',
        acciones: 'Aktionen',
        descargar: 'Herunterladen',
        editar: 'Bearbeiten',
        eliminar: 'Löschen',
        guardar: 'Änderungen speichern',
        cancelar: 'Abbrechen',
        eliminarConfirm: 'Dieses Dokument aus dem Repository löschen?',
        errorEliminar: 'Das Dokument konnte nicht gelöscht werden.',
        errorActualizar: 'Das Dokument konnte nicht aktualisiert werden.',
        errorCargar: 'Die Liste konnte nicht geladen werden.',
        soloPdf: 'Nur PDF bis 25 MB ist zulässig.',
        requiereNombre: 'Namen eingeben.',
        requiereOu: 'Mindestens eine OE auswählen.',
        requiereArchivo: 'PDF-Datei auswählen.',
        tipos: {
          PoliticaPrivacidad: 'Datenschutzrichtlinie',
          BasesLegales: 'Rechtliche Grundlagen',
          GuiaUsuario: 'Benutzerhandbuch',
          Premios: 'Preise',
          CookiesPolicy: 'Cookie-Richtlinie',
          LegalNotice: 'Impressum',
        },
      },
      currentVersion: 'Aktuelle Version',
      noVersionYet: 'Es wurde noch keine Version veröffentlicht',
      newVersionLabel: 'Neue zu veröffentlichende Version',
      loadError: 'Der Entwurf konnte nicht geladen werden.',
      titleLabel: 'Titel',
      sectionHeading: 'Überschrift',
      sectionBody: 'Inhalt',
      addSection: 'Abschnitt hinzufügen',
      removeSection: 'Abschnitt entfernen',
      saveDraft: 'Entwurf speichern',
      publish: 'Veröffentlichen',
      publishConfirm: 'Du bist dabei, eine neue Version zu veröffentlichen. Alle Nutzer müssen sie erneut akzeptieren, bevor sie Anerkennungen aussprechen können. Fortfahren?',
      missingLanguages: 'Fehlende Sprachen: {{languages}}',
      draftSaved: 'Entwurf gespeichert',
      published: 'Version veröffentlicht',
      saveError: 'Der Entwurf konnte nicht gespeichert werden.',
      publishError: 'Die Version konnte nicht veröffentlicht werden.',
    },
    recap: {
      title: 'Jahres-Recap',
      desc: 'Konfigurieren Sie das Recap-Erlebnis pro Ausgabe. Hintergründe und Symbole sind pro Slide konfigurierbar; die Nutzerdaten (Anerkennungen, meistempfangenes Grundprinzip, Fan Nr. 1, Serie) werden automatisch von der Plattform eingefügt.',
      deniedRole: 'Die Verwaltung des Recap ist Admin Allgemein und Admin Grundprinzipien vorbehalten.',
      fixValidation: 'Füllen Sie die Pflichttexte vor dem Speichern aus.',
      noEditions: 'Es gibt noch keine Recap-Ausgaben.',
      createFirst: 'Erste Ausgabe erstellen',
      edition: 'Ausgabe',
      editionName: 'Für Benutzer:innen sichtbarer Name',
      newEdition: 'Neue Ausgabe',
      scope: 'OU-Geltungsbereich',
      scopeGlobal: 'Global (alle)',
      active: 'Recap aktiv',
      activeOn: 'Aktiv',
      activeOff: 'Inaktiv',
      visibleFrom: 'Beginn der Sichtbarkeit',
      visibleTo: 'Ende der Sichtbarkeit',
      notification: 'Benachrichtigung',
      notifiedAt: 'Gesendet {{date}}',
      neverNotified: 'Nicht benachrichtigt',
      difusionLockHint: 'Dieses Recap wurde bereits angekündigt. Sie können Geltungsbereich und Sichtbarkeitsfenster ERWEITERN, aber nicht verkleinern: Eine OU zu entfernen oder die Fristen zu verkürzen würde bereits benachrichtigte Personen ausschließen. Alles Übrige bleibt bearbeitbar.',
      slidesTitle: 'Slide-Konfiguration ({{count}} Slides)',
      slidesHint: 'Die Symbole der Grundprinzipien und die Nutzerdaten werden automatisch eingefügt. Hier konfigurieren Sie nur die visuelle Ebene und die Texte.',
      i18nHint: 'Mehrsprachig: der Titel jedes Slides wird über die Schaltfläche Bearbeiten in allen 7 Sprachen erfasst.',
      colSlide: 'Slide',
      colPreview: 'Vorschau',
      colTitle: 'Titel',
      colActive: 'Aktiv',
      colActions: 'Aktionen',
      edit: 'Bearbeiten',
      titleMissing: 'Ohne Titel',
      needAllLangs: 'Es fehlen noch Sprachen (alle 7 sind erforderlich).',
      slides: {
        portada:    { name: 'Titelseite',                  hint: 'Begrüßungsbildschirm' },
        numeros:    { name: 'Ihr Jahr in Zahlen',          hint: 'Erhalten + gesendet' },
        define:     { name: 'Was Sie ausmacht',            hint: 'Meistempfangenes Grundprinzip (automatischer Wert)' },
        mensaje:    { name: 'Die Nachricht',               hint: 'Längste Anerkennung (automatischer Wert)' },
        quienes:    { name: 'Wer Sie anerkannt hat',       hint: 'Summen und Personen (automatischer Wert)' },
        red:        { name: 'Ihr Netzwerk',                hint: 'Verschiedene Bereiche, die Sie anerkannt haben (automatischer Wert)' },
        constancia: { name: 'Ihre Beständigkeit',          hint: 'Wochenserie (automatischer Wert)' },
        reto:       { name: 'Ihre Herausforderung fürs nächste Jahr', hint: 'Am wenigsten gezeigtes Grundprinzip und Handlungsaufruf' },
        ganador:    { name: 'Jahresgewinner:in',           hint: 'Wenn die Person gewonnen hat: echtes Abzeichen aus dem Bereich Gewinner:innen' },
      },
      notifyTitle: 'Recap-Benachrichtigung',
      notifyDesc: 'Informieren Sie die Mitarbeitenden im gewählten Geltungsbereich, dass ihr Recap {{year}} bereit ist.',
      preview: 'Vorschau',
      send: 'Benachrichtigung senden',
      notifyNeedsActive: 'Aktivieren Sie die Ausgabe, um sie benachrichtigen zu können.',
      notifyError: 'Die Benachrichtigung konnte nicht gesendet werden.',
      previewNote: 'So wird die Ausgabe durchlaufen: nur die aktiven Slides, mit ihren Hintergründen und Titeln. Die Zahlen stammen von der Person, die sie öffnet.',
      genericTitle: 'Generische Nachricht (Rückfall)',
      genericDesc: 'Wird angezeigt, wenn die Person im Zeitraum keine Anerkennungen hat oder eintritt, bevor das Recap sichtbar ist.',
      genericTitleLabel: 'Titel der generischen Nachricht',
      genericDescLabel: 'Untertitel / Beschreibung',
      genericNote: 'Diese Nachricht ist der Rückfall: wer Daten hat, sieht sein personalisiertes Recap.',
      imageUrlPlaceholder: 'URL des Bildes (PNG / JPG)',
      historyTitle: 'Recap-Historie und Jahresgewinner:innen',
      historyDesc: 'Registrierte Ausgaben und die jeweils zugeordneten Jahresgewinner:innen.',
      colEdition: 'Ausgabe',
      colYear: 'Jahr',
      colScope: 'Geltungsbereich',
      colSlides: 'Slides',
      colWinners: 'Jahresgewinner:innen',
      colStatus: 'Status',
      winnersCount: '{{count}} Gewinner:innen',
      status: { activa: 'Aktiv', completada: 'Abgeschlossen', borrador: 'Entwurf' },
      editorTitle: 'Slide {{index}} bearbeiten',
      editorDescData: 'Konfigurieren Sie den Titel (7 Sprachen), den Hintergrund und den Text, der den dynamischen Wert begleitet. Die Vorschau aktualisiert sich beim Schreiben.',
      editorDescIcon: 'Konfigurieren Sie den Titel (7 Sprachen), den Hintergrund und das Symbol des Slides. Die Vorschau aktualisiert sich beim Schreiben.',
      titleLangs: 'Titel (7 Sprachen)',
      titlePlaceholder: 'Titel auf {{lang}}',
      autoIcon: 'Das Symbol dieses Slides ist automatisch: es verwendet das echte Abzeichen der gewinnenden Person aus dem Bereich Gewinner:innen.',
      icon: 'Symbol',
      iconPlaceholder: 'Emoji oder Bild-URL',
      numberLabels: 'Text unter den Zahlen',
      numberLabelsHint: 'Die Zahlen berechnet die Plattform; hier legen Sie das Wort darunter fest.',
      numberLabelPlaceholder: 'z. B.: erhalten',
      background: 'Hintergrund',
      previewLabel: 'Vorschau',
      previewDataNote: 'Die angezeigten Zahlen stammen von der Person, die ihr Recap öffnet.',
      apply: 'Anwenden',
    },
  },
  // ── WP-16 REQ-140 — Rechtliche Modale ──
  legal: {
    privacy: 'Datenschutzerklärung',
    legal: 'Teilnahmebedingungen des Programms',
    reachedEnd: 'Sie haben das Ende erreicht!',
    scrollHint: 'Scrollen Sie bis zum Ende, um zu akzeptieren',
    accept: 'Ich akzeptiere',
    acceptError: 'Ihre Zustimmung konnte nicht erfasst werden.',
    loadError: 'Das Dokument konnte nicht geladen werden.',
    pdfError: 'Das PDF-Dokument konnte nicht angezeigt werden.',
    retry: 'Erneut versuchen',
    openInNewTab: 'In neuem Tab öffnen',
  },
  // ── WP-16 REQ-139 — Standalone-Registrierung Frontline ──
  register: {
    backToLogin: '← Zurück zur Anmeldung',
    entraTitle: 'Haben Sie bereits eine geschäftliche E-Mail?',
    entraSub: 'Sie müssen sich nicht registrieren — melden Sie sich direkt mit Ihrem Sigma-Konto an.',
    title: 'Registrierung',
    subtitle: 'Erstellen Sie Ihren Zugang zum Anerkennungsprogramm.',
    fullName: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    ou: 'Organisationseinheit',
    selectOu: 'Wählen Sie Ihre OU',
    startDate: 'Eintrittsdatum bei Sigma',
    employeeId: 'Personalnummer',
    bu: 'Geschäftsbereich',
    site: 'Arbeitsstandort',
    department: 'Abteilung',
    selectBu: 'Wählen Sie Ihren Geschäftsbereich',
    selectSite: 'Wählen Sie Ihren Arbeitsstandort',
    selectDepartment: 'Wählen Sie Ihre Abteilung',
    errName: 'Geben Sie Ihren vollständigen Namen ein.',
    errEmail: 'Geben Sie eine gültige E-Mail-Adresse ein.',
    errOu: 'Wählen Sie Ihre OU.',
    errCatalogs: 'Füllen Sie Geschäftsbereich, Standort und Abteilung aus.',
    errStartDate: 'Geben Sie Ihr Eintrittsdatum ein.',
    errEmployeeId: 'Geben Sie Ihre Personalnummer ein.',
    catalogsError: 'Die Kataloge konnten nicht geladen werden.',
    submit: 'Registrieren',
    submitError: 'Die Registrierung konnte nicht abgeschlossen werden.',
    checkEmailTitle: 'Prüfen Sie Ihre E-Mails',
    checkEmailSub: 'Wir haben einen Bestätigungslink an {{email}} gesendet.',
    verifyFailed: 'Ihre E-Mail konnte nicht bestätigt werden. Der Link ist möglicherweise abgelaufen.',
    verified: 'E-Mail bestätigt',
    allSet: 'Alles bereit!',
    allSetSub: 'Ihr Konto ist eingerichtet. Sie können nun Ihre Kolleg:innen anerkennen.',
    password: 'Passwort (mind. 8 Zeichen)',
    confirmPassword: 'Passwort bestätigen',
    errPassword: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    errPasswordMatch: 'Die Passwörter stimmen nicht überein.',
    errLegal: 'Sie müssen die Teilnahmebedingungen akzeptieren.',
    errLegalVersion: 'Das Rechtsdokument konnte nicht geladen werden. Bitte erneut versuchen.',
    errPrivacy: 'Sie müssen die Datenschutzerklärung akzeptieren.',
    errLocalId: 'Geben Sie Ihre Local ID ein (bis zu 8 Ziffern).',
    errDepartment: 'Wählen Sie Ihre Abteilung.',
    acceptPrivacy: 'Ich habe gelesen und akzeptiere die',
    acceptLegalBases: 'Ich habe gelesen und akzeptiere die',
    privacyLink: 'Datenschutzerklärung',
    legalLink: 'Teilnahmebedingungen',
    localId: 'Local ID',
    policyPlaceholder: 'Lesen Sie das vollständige Dokument. Am Ende können Sie es akzeptieren.',
    createdTitle: 'Konto erstellt',
    createdSub: 'Sie können sich jetzt mit Ihrer E-Mail und Ihrem Passwort anmelden. Nach der Anmeldung können Sie Ihren Avatar wählen.',
    checkEmailHint: 'Öffne den Link, um deine E-Mail-Adresse zu bestätigen und dich anmelden zu können. Er läuft in 72 Stunden ab.',
    resend: 'E-Mail erneut senden',
    resendDone: 'Wenn dein Konto noch bestätigt werden muss, haben wir dir einen neuen Link geschickt. Wenn du es schon bestätigt hast, melde dich einfach mit E-Mail und Passwort an.',
  },
  // ── Anmeldung (RF-002) ──
  login: {
    title: 'Anmelden',
    subtitle: 'Anerkennungsprogramm',
    entraRouteTitle: 'Mit Ihrer geschäftlichen E-Mail anmelden',
    entraRouteSub: 'Verwenden Sie Ihr Sigma-Konto (Entra ID).',
    entra: 'Mit Sigma-E-Mail anmelden',
    frontlineRouteTitle: 'Keine geschäftliche E-Mail?',
    frontlineRouteSub: 'Melden Sie sich mit Ihrer E-Mail und Ihrem Passwort an.',
    email: 'E-Mail',
    password: 'Passwort',
    submit: 'Anmelden',
    submitting: 'Anmeldung…',
    or: 'oder',
    toRegister: 'Noch kein Konto? Registrieren',
    noAccountLede: 'Kein institutionelles Konto?',
    noAccountSub: 'Verwenden Sie eine private E-Mail',
    alreadyRegisteredLede: 'Schon registriert?',
    hasInstitutionalEmailLede: 'Haben Sie eine geschäftliche E-Mail?',
    register: 'Registrieren',
    back: 'Zurück',
    forgot: 'Passwort vergessen?',
    forgotIntro: 'Gib deine E-Mail-Adresse ein und wir schicken dir einen Link, um ein neues Passwort zu erstellen.',
    forgotSubmit: 'Link zusenden',
    forgotSent: 'Wenn diese Adresse registriert ist, haben wir dir einen Link geschickt. Er läuft in 60 Minuten ab.',
    resendVerification: 'Keine Bestätigungs-E-Mail erhalten?',
    resendIntro: 'Gib deine E-Mail-Adresse ein und wir schicken dir einen neuen Bestätigungslink.',
    resendSubmit: 'E-Mail erneut senden',
    resendSent: 'Wenn dein Konto noch bestätigt werden muss, haben wir dir einen neuen Link geschickt. Wenn du es schon bestätigt hast, melde dich einfach mit E-Mail und Passwort an.',
    errRequired: 'Geben Sie Ihre E-Mail und Ihr Passwort ein.',
    errCredentials: 'E-Mail oder Passwort falsch.',
  },
  // ── Gemeinsame Landingpage (Regel #3) ──
  landing: {
    question: 'Welche Fundamentals wollen wir heute anerkennen?',
    subtitle: 'Wähle einen Bereich, um deine Fundamentals zu leben',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: 'Wie war dein Team im letzten Meeting? Sag ihnen, was dir aufgefallen ist 💬',
    shineHover: 'Willst du sehen, wer glänzt, und eine Kollegin nominieren?',
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  reset: {
    title: 'Erstelle dein neues Passwort',
    subtitle: 'Wähle ein Passwort, um wieder hineinzukommen.',
    password: 'Neues Passwort (mind. 8 Zeichen)',
    confirmPassword: 'Passwort bestätigen',
    submit: 'Mein Passwort ändern',
    errPassword: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    errPasswordMatch: 'Die Passwörter stimmen nicht überein.',
    errInvalidLink: 'Der Link ist ungültig oder abgelaufen. Fordere auf der Anmeldeseite einen neuen an.',
    doneTitle: 'Passwort aktualisiert',
    doneSub: 'Du kannst dich jetzt mit deiner E-Mail-Adresse und deinem neuen Passwort anmelden.',
    noToken: 'Ungültiger Link',
    noTokenSub: 'Der Link ist ungültig oder unvollständig. Sieh in der E-Mail nach, die du erhalten hast.',
  },
  auth: {
    retryIn: 'Du kannst es in {{seconds}} s erneut versuchen',
    contactHR: 'Wenn Sie Probleme bei der Registrierung haben, wenden Sie sich an Ihr Human-Capital-Team.',
    errorTitle: 'Wir konnten nicht fortfahren',
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Wählen Sie Ihren Avatar',
    subtitle: 'Wählen Sie das Bild, das Sie repräsentiert.',
    loading: 'Avatare werden geladen…',
    empty: 'Es sind noch keine Avatare verfügbar.',
    loadError: 'Avatare konnten nicht geladen werden.',
    saveError: 'Ihr Avatar konnte nicht gespeichert werden.',
    saved: 'Avatar gespeichert',
    confirm: 'Bestätigen',
    required: 'Wählen Sie Ihren Avatar, um fortzufahren.',
    unavailable: 'Dieser Avatar ist nicht mehr verfügbar. Bitte wählen Sie einen anderen.',
    change: 'Avatar ändern',
    continueWithout: 'Ohne Avatar fortfahren',
  },
  // ── WP-08 — Berichte zur Anerkennung ──
  reports: {
    title: 'Berichte',
    subtitle: 'Analytik des Anerkennungsprogramms. Zeigt nie Punkte an.',
    emptyScope: 'Ihnen ist innerhalb Ihres Bereichs keine Organisationseinheit zugewiesen.',
    tabs: {
      daily: 'Reco Diario',
      shine: 'Brillamos Juntos',
      history: 'Historie',
      heatmap: 'Heatmap',
      network: 'ONA-Netzwerk',
      generational: 'Demografisch',
      leaders: 'Führungskräfte',
      moderation: 'Moderation',
      campaigns: 'Kampagnen — allgemein',
    },
    common: {
      loading: 'Berichte werden geladen…',
      error: 'Der Bericht konnte nicht geladen werden.',
      empty: 'Für die gewählten Filter gibt es keine Daten.',
      retry: 'Erneut versuchen',
      suppressedNote: 'Einige Aggregate wurden wegen der Anonymitätsschwelle ausgeblendet (weniger als 5).',
      suppressedNoteHelp: 'Wenn eine Gruppe weniger als 5 Personen hat, werden ihre aufgeschlüsselten Kennzahlen nicht veröffentlicht: Bei so wenigen ließe sich aus den Daten auf einzelne Personen schließen. Das ist weder ein Fehler noch eine fehlende Angabe.',
      colScope: 'Geltungsbereich (Einheiten)',
      colScopeHelp: 'Organisationseinheiten, an die sich die Kampagne richtete.',
      colAudienceHelp: 'Anzahl der Mitarbeitenden, an die sich die Kampagne richtete. Sie ist der Nenner der Teilnahmequote.',
      scopeAll: 'Gesamte Organisation',
      scopeMore: '+{{n}} weitere',
      masked: 'Aus Anonymitätsgründen ausgeblendet',
      showingRange: '{{desde}}–{{hasta}} von {{total}}',
      pageSize: 'Zeilen pro Seite',
      perPage: '{{n}} pro Seite',
      exportExcel: 'Nach Excel exportieren',
      yes: 'Ja',
      no: 'Nein',
    },
    context: {
      unifiedTitle: 'Einheitliche Kennzahlen',
      unifiedText: '— Reco Diario und Brillamos Juntos verwenden dieselbe Zähllogik. Die Daten sind modulübergreifend konsistent.',
      auditTitle: 'Auditierung aktiv.',
      auditText: 'Jeder Download wird mit Ihrem Benutzer, der Registerkarte und dem Datum protokolliert.',
      showing: 'Anzeige:',
      wholeOrg: 'die gesamte Organisation',
    },
    filters: {
      allFundamentals: 'Alle Fundamentals',
      allOus: 'Alle OUs',
      dateFrom: 'Von',
      dateTo: 'Bis',
      reset: 'Leeren',
      ou: 'Einheit',
      fundamental: 'Fundamentals',
      dateRange: 'Daten',
      remove: 'Filter {{filter}} entfernen',
      person: 'Person',
      personPlaceholder: 'Person suchen…',
      personClear: 'Ausgewählte Person entfernen',
      personNoResults: 'Keine Treffer im Verzeichnis',
      personSearching: 'Suche läuft…',
      personError: 'Verzeichnis konnte nicht abgefragt werden',
    },
    notApplicable: {
      title_one: 'Der Filter {{filtros}} gilt nicht für diesen Bereich.',
      // `title_few` — inerter Alias von `title_other`, nur wegen der Schlüsselparität mit `ro`.
      title_few: 'Die Filter {{filtros}} gelten nicht für diesen Bereich.',
      title_other: 'Die Filter {{filtros}} gelten nicht für diesen Bereich.',
      and: 'und',
      reason: {
        embudo: 'Der Trichter teilt die gesamte Belegschaft in Stammnutzer, Gelegentliche und Inaktive auf; auf eine einzelne Person eingegrenzt wäre er keine Aufteilung mehr.',
        historico: 'Diese Zahlen gelten für „irgendwann", nicht für den gewählten Zeitraum: Sie zählen jeden, der jemals jemanden anerkannt hat, in seiner gesamten Historie auf der Plattform.',
        audienciaCampana: 'Diese Kennzahl wird über die von der Kampagne einberufene Zielgruppe berechnet, die unabhängig von den gewählten Fundamentals oder der Person gleich bleibt.',
        porBanda: 'Die Verteilung gruppiert Personen nach Generationsband; bei nur einer ausgewählten Person bliebe nur ein Band übrig, und es wäre keine Verteilung mehr.',
        porOu: 'Diese Ansicht gruppiert nach Organisationseinheit, nicht nach Person.',
        redOu: 'Die Knoten des Netzwerks sind Organisationseinheiten, keine Personen.',
        promedioPulso: 'Diese Tabelle stammt aus den durchschnittlichen Pulso-Werten (1-4) nach Generation und Fundamentals, nicht aus der Anerkennungszahl oder der Personalzählung: Keiner der beiden Filter grenzt sie ein.',
        resumenCampana: 'Diese Kennzahl stammt aus der Zusammenfassung der gesamten Kampagne: Das Backend unterstützt keine Eingrenzung auf eine einzelne Person (wohl aber nach Fundamentals).',
        casosReportados: 'Der Bericht listet gemeldete FÄLLE auf, und den Meldegrund schreibt die meldende Person: Er ist nicht an ein Fundamental der Anerkennung gebunden. OU, Zeitraum und Person grenzen diese Tabelle hingegen ein.',
      },
    },
    daily: {
      title: 'Tägliche Anerkennung',
      subtitle: 'Nur Anerkennungen aus dem Alltag, ohne Kampagnen: gewählter vs. vorheriger Zeitraum, Beteiligungstrichter und Tops.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Gewählter Zeitraum',
      prevPeriod: 'Vorheriger Zeitraum',
      vsPrev: '{{variacion}} vs. Vorperiode · {{previo}}',
      fundamentalDistribution: 'Verteilung nach Fundamental',
      totalSentTitle: 'Gesendete Anerkennungen insgesamt',
      totalSentHint: 'Summe aller im Zeitraum gesendeten Anerkennungen',
      retiredFundamental: 'Zurückgezogenes Fundamental',
      unresolvedFundamental: 'Fundamental (Katalog nicht verfügbar)',
      retiredFundamentalHint: 'Aus dem Katalog entferntes Fundamental: Es bleibt in der Historie, weil es Anerkennungen damit gab, kann aber nicht mehr ausgewählt werden.',
      adoptionStaff: 'Staff-Nutzende',
      adoptionFrontline: 'Frontline-Nutzende',
      adoptionTotal: 'Nutzende insgesamt',
      noActivity: 'Ohne Aktivität',
      adoptionHint: '{{reconocedores}} von {{plantilla}} haben jemanden anerkannt',
      adoptionTotalHint: '{{pct}} der Gesamtbelegschaft ({{plantilla}})',
      noActivityHint: 'Haben noch nie eine Anerkennung gesendet',
      variation: 'Veränderung',
      sparkAria: 'Täglicher Trend für {{label}}: {{dias}} Tage, von {{primero}} bis {{ultimo}}',
      uniquePeople: 'Einzelpersonen',
      pares: 'Kollegen',
      lideres: 'Führungskräfte',
      funnel: 'Beteiligungstrichter',
      funnelMonthSelector: 'Monat des Beteiligungstrichters',
      funnelRange: 'Zeitraum: {{from}} – {{to}}',
      funnelPeople: '{{count}} Personen',
      topPeople: 'Top anerkannte Personen',
      topRecognizers: 'Top Anerkennende',
      topFundamentals: 'Top Grundprinzipien',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Täglich exportieren (6 Blätter)',
      colStage: 'Phase',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Name",
      colDepto: "Abteilung",
      colOu: "OU",
      colFundamental: "Grundwert",
      colRecos: 'Anerkennungen',
      colEnviados: "Gesendet",
      colCrossOu: "OU-übergreifend",
      colType: "Typ",
      crossOu: {
        si: "Ja",
        no: "Nein",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'E-Mail',
      colEmployeeId: 'Personalnummer',
      colRecognitions: 'Anerkennungen',
      colDominantType: 'Dominanter Typ',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05). El libro entero sale en el idioma de quien descarga.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Management-Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetFunnel: 'Adoptionstrichter',
        sheetTopRecognized: 'Top Anerkannte',
        sheetTopRecognizers: 'Top Anerkennende',
        sheetAllRecognitions: 'Alle Anerkennungen',
        summaryTitle: 'Tägliche Anerkennung — Fundamentals des Arbeitsalltags',
        summarySubtitle: 'Kennzahlen des gewählten Zeitraums: wer anerkennt, wen und wie häufig.',
        definitionsTitle: 'Was bedeutet jede Kennzahl?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen — ganz ohne Datenkenntnisse.',
        funnelTitle: 'Adoptionstrichter',
        funnelSubtitle: 'Segmentierung nach der Häufigkeit der im Trichtermonat gesendeten Anerkennungen ({{rango}}).',
        funnelEmpty: 'Keine Daten: Im Trichtermonat gibt es keine Anerkennungen.',
        topRecognizedTitle: 'Am häufigsten anerkannt',
        topRecognizersTitle: 'Top Anerkennende',
        rankingSubtitle: 'Rangliste auf Basis der Anerkennungen dieses Zeitraums.',
        topRecognizersEmpty: 'Keine Daten: In diesem Zeitraum hat niemand eine Anerkennung gesendet.',
        allRecognitionsTitle: 'Alle Anerkennungen',
        allRecognitionsSubtitle: 'Rohdaten des Alltags im Zeitraum, ohne Kampagnen-Einsendungen: eine Zeile pro anerkannter Person. Die Spaltennamen behalten ihre Originalform, damit die Pivot-Tabellen des Komitees weiter funktionieren.',
        allRecognitionsNoRange: 'Keine Daten: Der genaue Zeitraum ließ sich nicht bestimmen, weil die Aggregation durch die Anonymitätsschwelle unterdrückt ist und der Filter keine expliziten Daten enthält.',
        metaPeriod: 'Zeitraum',
        metaFilters: 'Angewendete Filter',
        metaFunnelMonth: 'Trichtermonat',
        metaGenerated: 'Erstellt',
        colKpi: 'KPI',
        colValue: 'Wert',
        colDetail: 'Detail',
        colDatum: 'Kennzahl',
        colWhatIs: 'Was sie ist',
        colHowCalculated: 'Wie sie berechnet wird',
        colPercentOfTotal: '% des Gesamtwerts',
        colSegment: 'Segment',
        colPeople: 'Personen',
        colAdministrative: 'Verwaltung',
        colOperational: 'Operativ',
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Bereich',
        colSite: 'Standort',
        headcountTitle: 'Belegschaft',
        headcountTotal: 'Gesamt',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personen',
        kpiPeers: 'Peers (eindeutige Anerkennungen unter Peers)',
        kpiLeaders: 'Führungskräfte (eindeutige Anerkennungen mit Beteiligung einer Führungskraft)',
        datumTeamRecognitions: 'Anerkennungen an Teams',
        datumAudienceStaff: 'Zielgruppe Staff (Verwaltung)',
        datumAudienceFrontline: 'Zielgruppe Frontline (operativ)',
        datumComparison: 'Vorheriger Zeitraum und Veränderung',
        datumRankings: 'Top Anerkannte / Top Anerkennende',
        datumLeader: 'Führungskraft',
        datumTruncated: 'Alle Anerkennungen — gekürzt',
        whatRecognitionsMade: 'Wie viele Anerkennungen im Zeitraum insgesamt gesendet wurden, mit den angewendeten Filtern.',
        calcRecognitionsMade: 'Die Anerkennungen aus dem Alltag mit Datum im gewählten Zeitraum werden summiert. Die zu einer Kampagne gehörenden werden im Bericht «Wir glänzen gemeinsam» gezählt.',
        whatUniqueRecognized: 'Wie viele verschiedene Personen mindestens eine Anerkennung erhalten haben. Wer fünf erhalten hat, zählt nur einmal.',
        calcUniqueRecognized: 'Gezählt werden die verschiedenen Personen, die im Zeitraum als Empfangende auftreten.',
        whatTeamRecognitions: 'Eine Anerkennung gilt als Gruppenanerkennung, wenn sie mehr als eine empfangende Person hat.',
        calcTeamRecognitions: 'Die Spalte «Recognition type» im Blatt «Alle Anerkennungen» kennzeichnet jede Zeile als Individual oder Grupal.',
        whatPeers: 'Anerkennungen, bei denen weder die sendende noch die empfangende Person Mitarbeitende führt: Kollege zu Kollege, Führungskraft zu Führungskraft, Manager zu Manager.',
        calcPeers: 'Gefiltert werden die Anerkennungen unter Peers innerhalb des Zeitraums.',
        whatLeaders: 'Anerkennungen, an denen mindestens eine Person mit Führungsverantwortung beteiligt ist.',
        calcLeaders: 'Gefiltert werden die Anerkennungen, bei denen die sendende oder die empfangende Person eine Rolle als Führungskraft, Supervisor oder Manager hat.',
        whatStaffAdoption: 'Von allen Büromitarbeitenden (Staff) der Anteil, der im Zeitraum bereits jemanden anerkannt hat.',
        calcStaffAdoption: 'Staff-Personen mit mindestens einer im Zeitraum gesendeten Anerkennung, geteilt durch die gesamte Staff-Belegschaft des Geltungsbereichs.',
        whatFrontlineAdoption: 'Von allen Personen in Betrieb oder Werk (Frontline) der Anteil, der im Zeitraum bereits jemanden anerkannt hat.',
        calcFrontlineAdoption: 'Frontline-Personen mit mindestens einer im Zeitraum gesendeten Anerkennung, geteilt durch die gesamte Frontline-Belegschaft des Geltungsbereichs.',
        whatTotalUsers: 'Wie viele Personen im Geltungsbereich seit Bestehen ihres Kontos jemals mindestens eine Anerkennung gesendet haben.',
        calcTotalUsers: 'Personen mit mindestens einer gesendeten Anerkennung in ihrer gesamten Historie. Unabhängig vom gewählten Zeitraum: der Wert stammt aus der täglichen Erhebung.',
        whatNoActivity: 'Personen, die seit Bestehen ihres Kontos noch nie eine einzige Anerkennung gesendet haben.',
        calcNoActivity: 'Gesamtbelegschaft des Geltungsbereichs abzüglich der Personen mit mindestens einer gesendeten Anerkennung in ihrer gesamten Historie.',
        whatAudienceStaff: 'Personen mit einem Entra-ID-Firmenkonto.',
        whatAudienceFrontline: 'Personen, die sich mit ihrer eigenen E-Mail-Adresse auf der Plattform registrieren.',
        whatPrevPeriod: 'Anerkennungen, die in denselben Tagen unmittelbar vor dem gewählten Zeitraum gesendet wurden.',
        whatVariation: 'Wie stark das Anerkennungsvolumen gegenüber dem gleichwertigen Vorzeitraum gestiegen oder gefallen ist.',
        calcVariation: 'Der Vorzeitraum umfasst dieselben Tage unmittelbar vor dem gewählten. Die Veränderung ist die Differenz beider, geteilt durch den Gesamtwert des Vorzeitraums.',
        whatFunnel: 'Segmentiert den Geltungsbereich nach Häufigkeit innerhalb des Trichtermonats, eines eigenen und vom obigen Zeitraum unabhängigen Fensters: Regelmäßige (vier oder mehr pro Monat), Gelegentliche (eine bis drei) und Inaktive (keine). Jede Stufe wird nach Verwaltung und operativ aufgeschlüsselt.',
        calcFunnel: 'Prozentsatz und Spalte Personen werden auf die Belegschaft des Geltungsbereichs bezogen. Verwaltung und operativ zählen dieselben Personen nach Stellentyp und bleiben leer, wenn diese Einstufung nicht verfügbar ist.',
        whatRankings: 'Die am häufigsten anerkannten Personen und jene, die am meisten anerkennen, bis zu 200 pro Liste.',
        calcRankings: 'Sortiert nach der Zahl der erhaltenen oder gesendeten Anerkennungen. Wer die Anonymitätsschwelle nicht erreicht, erscheint maskiert.',
        whatAllRecognitions: 'Rohdaten des Zeitraums, eine Zeile pro Kandidat: die vollständigen Blöcke Nominee, OnBehalfOf und Candidate, das Datum, die Matrix der aktiven Habits und die Audit-Kennzeichen. Personen werden nicht maskiert: Es ist die Arbeitsquelle des Komitees, und die Anonymitätsschwelle gilt für aggregierte Berichte. Enthalten sind auch Anerkennungen aus laufenden Brillamos-Juntos-Kampagnen, denn der Tagesbericht zählt sie alle.',
        calcAllRecognitions: 'Vollständige Liste der Anerkennungen des Zeitraums, bis maximal 5000 Zeilen. Die Habit-Spalten enthalten nur die zum Exportzeitpunkt im Katalog aktiven. Die Spalte Reco_ID bleibt leer, weil das System noch keine eindeutige Kennung pro Zeile erzeugt.',
        whatTruncated: 'Dieser Download wurde bei der Obergrenze von 5000 Zeilen abgeschnitten: Der Zeitraum hat mehr Anerkennungen, als die Datei enthält.',
        calcTruncated: 'Die Obergrenze wurde erreicht, bevor alle Seiten durchlaufen waren, die Datei ist also unvollständig. Grenze den Zeitraum ein und exportiere erneut.',
        noteLeader: 'Eine Rolle gilt als Führungskraft, wenn ihr Mitarbeitende unterstellt sind.',
        masked: 'Aus Anonymitätsgründen ausgeblendet',
      },
    },
    shine: {
      title: 'Gemeinsam Strahlen',
      subtitle: 'Nominierungsranking der Kampagne und Live-KPIs.',
      recognitionsMade: 'Abgegebene Anerkennungen',
      uniqueRecognized: 'Eindeutig anerkannte Personen',
      uniqueRecognizers: 'Eindeutige anerkennende Personen',
      participationRate: 'Beteiligungsquote',
      totalHeadcount: 'Gesamtbelegschaft',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Shine exportieren (7 Blätter)',
      exporting: 'Wird exportiert…',
      exportError: 'Der Download konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
      winnersFormat: 'Format des Gewinner:innen-Exports',
      formatRaw: 'Roh',
      formatCascaded: 'Kaskadiert',
      exportWinners: 'Gewinner:innen exportieren',
      colPos: 'Platzierung',
      kpiTotal: 'Gesamt',
      kpiParticipants: 'Teilnehmende',
      kpiParticipation: 'Teilnahme',
      kpiAvgPerPerson: 'Durchschnitt pro Person',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Kampagne',
      modalidadSelector: 'Brillamos-Filter',
      daysLeft: 'Verbleibende Tage',
      activeOus: 'Aktive OUs',
      modalidadTodos: 'Alle Nominierten',
      modalidadPersonaUnica: 'Nur einzelne Empfangende',
      modalidadCrossOu: 'OU-übergreifend',
      pickCampaign: 'Wähle eine Kampagne, um ihre Kennzahlen und ihr Ranking zu sehen.',
      habitsRanking: 'Ranking der Daily Habits',
      colHabit: 'Daily Habit',
      colRecognitions: 'Anerkennungen',
      colName: 'Name',
      colBu: 'BU',
      colDept: 'Abteilung',
      colOrigin: 'Herkunft',
      filterHabitsByFundamental: 'Gewohnheiten nach Fundamental filtern',
      allFundamentals: 'Alle Fundamentals',
      colCount: 'Anerkennungen',
      colOu: 'OU',
      colCountry: 'Land',
      colBadge: 'Abzeichen',
      colCrossed: 'Gekreuzter Ursprung',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colCrossOu` reusa la misma
      // traducción que ya usa `reports.daily` para el mismo dato.
      colEmail: 'E-Mail',
      colEmployeeId: 'Personalnummer',
      colCrossOu: 'OU-übergreifend',
      colDominantType: 'Vorherrschender Typ',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Staff-Nutzer',
      adoptionFrontline: 'Frontline-Nutzer',
      adoptionTotal: 'Nutzer insgesamt',
      noActivity: 'Ohne Aktivität',
      adoptionHint: '{{reconocedores}} von {{plantilla}} haben nominiert',
      adoptionTotalHint: '{{pct}} des Gesamtbestands ({{plantilla}})',
      noActivityHint: 'Haben noch nie nominiert',
      appliedFilters: 'Angewendete Filter:',
      appliedFiltersValue: 'Vom oberen Bereich übernommen · Aktive Kampagnen',
      clearAll: 'Alles löschen',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetDistribution: 'Verteilung Fundamental',
        sheetFunnel: 'Adoptions-Funnel',
        sheetTopRecognized: 'Meistanerkannte',
        sheetTopRecognizers: 'Top-Anerkennende',
        sheetAllRecognitions: 'Alle Anerkennungen',
        summaryTitle: 'Kampagne Gemeinsam Strahlen',
        definitionsTitle: 'Was bedeutet welche Angabe?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen, ganz ohne Datenkenntnisse.',
        distributionTitle: 'Verteilung nach Fundamental',
        distributionSubtitle: 'Anteil berechnet aus den Anerkennungen dieser Kampagne.',
        distributionChart: 'Anerkennungen nach Fundamental',
        distributionNote: 'Eine Anerkennung kann mehrere Fundamentals oder mehrere Habits zugleich enthalten, und jedes wird einzeln gezählt: Die Summen dieser Tabelle müssen daher weder der Gesamtzahl der Kampagne noch der Zahl ihres Fundamentals entsprechen.',
        distributionEmpty: 'Keine Daten: Die Kampagne hat im Zeitraum keine Anerkennung mit erfasstem Fundamental.',
        funnelTitle: 'Adoptions-Funnel',
        funnelSubtitle: 'Segmentierung nach der Häufigkeit der im Kampagnenzeitraum gesendeten Anerkennungen.',
        funnelEmpty: 'Keine Daten: Die Kampagne hat im Zeitraum keine Anerkennungen.',
        topRecognizedTitle: 'Meistanerkannte Personen',
        topRecognizersTitle: 'Top-Anerkennende',
        rankingSubtitle: 'Rangliste berechnet aus den Anerkennungen dieser Kampagne.',
        topRecognizersEmpty: 'Keine Daten: In dieser Kampagne hat niemand Anerkennung ausgesprochen.',
        allRecognitionsTitle: 'Alle Anerkennungen',
        allRecognitionsSubtitle: 'Rohdaten der Kampagne: eine Zeile je anerkannter Person. Die Spaltennamen bleiben in ihrer Originalform, damit die Pivot-Tabellen des Komitees weiter funktionieren.',
        metaPeriod: 'Zeitraum',
        metaFilters: 'Angewendete Filter',
        metaGenerated: 'Erstellt',
        colKpi: 'KPI',
        colValue: 'Wert',
        colDetail: 'Detail',
        colDatum: 'Angabe',
        colWhatIs: 'Was es ist',
        colHowCalculated: 'Berechnung',
        colFundamentals: 'Fundamentals',
        colPercentOfTotal: '% der Gesamtzahl',
        colSegment: 'Segment',
        colPeople: 'Personen',
        colAdministrative: 'Verwaltung',
        colOperational: 'Produktion',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Bereich',
        colSite: 'Standort',
        headcountTitle: 'Belegschaft',
        headcountTotal: 'Gesamt',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personen',
        kpiPeers: 'Kolleginnen und Kollegen (eindeutige Anerkennungen unter Gleichrangigen)',
        kpiLeaders: 'Führungskräfte (eindeutige Anerkennungen mit Beteiligung einer Führungskraft)',
        kpiTotalSent: 'Gesendete Anerkennungen insgesamt',
        kpiIndividual: 'Anerkennungen an eine einzelne Person insgesamt',
        kpiGroup: 'Anerkennungen an Gruppen insgesamt',
        datumTeamRecognitions: 'Anerkennungen an Teams',
        datumAudienceStaff: 'Zielgruppe Staff (Verwaltung)',
        datumAudienceFrontline: 'Zielgruppe Frontline (Produktion)',
        datumLeader: 'Führungskraft',
        datumTruncated: 'Alle Anerkennungen — gekürzt',
        whatRecognitionsMade: 'Wie viele Anerkennungen innerhalb der Kampagne insgesamt gesendet wurden, mit den angewendeten Filtern.',
        calcRecognitionsMade: 'Alle Anerkennungen mit Datum innerhalb des Kampagnenzeitraums werden addiert.',
        whatUniqueRecognized: 'Wie viele verschiedene Personen mindestens eine Anerkennung erhalten haben. Wer fünf erhalten hat, zählt einmal.',
        calcUniqueRecognized: 'Gezählt werden die verschiedenen Personen, die im Zeitraum als Empfangende auftreten.',
        whatTeamRecognitions: 'Eine Anerkennung gilt als Gruppenanerkennung, wenn sie mehr als eine empfangende Person hat.',
        calcTeamRecognitions: 'Gezählt werden Anerkennungen mit zwei oder mehr Empfangenden.',
        whatIndividual: 'Anerkennungen der Kampagne, die an eine einzelne Person gerichtet sind.',
        calcIndividual: 'Gezählt werden Anerkennungen mit genau einer empfangenden Person.',
        whatPeers: 'Anerkennungen, bei denen weder die sendende noch die empfangende Person Mitarbeitende führt: Kollegin zu Kollege, Führungskraft zu Führungskraft, Leitung zu Leitung.',
        calcPeers: 'Es werden die Anerkennungen unter Gleichrangigen innerhalb dieser Kampagne gefiltert.',
        whatLeaders: 'Anerkennungen, an denen mindestens eine Person mit Führungsverantwortung beteiligt ist.',
        calcLeaders: 'Es werden die Anerkennungen gefiltert, bei denen die sendende oder die empfangende Person eine Rolle als Führungskraft, Supervisor oder Manager hat.',
        whatStaffAdoption: 'Von allen Büroangestellten (Staff) der Anteil, der in dieser Kampagne bereits jemanden anerkannt hat.',
        calcStaffAdoption: 'Staff-Personen mit mindestens einer gesendeten Anerkennung in der Kampagne, geteilt durch alle Staff-Personen ihrer Zielgruppe.',
        whatFrontlineAdoption: 'Von allen Personen in Betrieb oder Werk (Frontline) der Anteil, der in dieser Kampagne bereits jemanden anerkannt hat.',
        calcFrontlineAdoption: 'Frontline-Personen mit mindestens einer gesendeten Anerkennung in der Kampagne, geteilt durch alle Frontline-Personen ihrer Zielgruppe.',
        whatTotalUsers: 'Wie viele Personen der Kampagnen-Zielgruppe innerhalb der Kampagne mindestens eine Anerkennung gesendet haben.',
        calcTotalUsers: 'Personen mit mindestens einer gesendeten Anerkennung im Kampagnenzeitraum. Es ist keine lebenslange Gesamtzählung.',
        whatNoActivity: 'Personen der Zielgruppe, die während der Kampagne keine Anerkennung gesendet haben.',
        calcNoActivity: 'Zielgruppe der Kampagne abzüglich der Personen mit mindestens einer darin gesendeten Anerkennung.',
        whatAudienceStaff: 'Personen mit einem Entra-ID-Firmenkonto.',
        whatAudienceFrontline: 'Personen, die sich mit ihrer eigenen E-Mail-Adresse auf der Plattform registrieren.',
        whatParticipationRate: 'Anteil der Zielgruppe, der an der Kampagne teilgenommen hat, durch Anerkennen oder Anerkanntwerden.',
        calcParticipationRate: 'Teilnehmende geteilt durch die Zielgruppe der Kampagne.',
        whatUniqueRecognizers: 'Verschiedene Personen, die innerhalb dieser Kampagne mindestens eine Anerkennung gesendet haben.',
        calcUniqueRecognizers: 'Zählung der verschiedenen Sendenden in den Anerkennungen der Kampagne.',
        whatDistribution: 'Hierarchie mit zwei Ebenen: jedes Fundamental mit seinem Anteil an der Gesamtzahl der Kampagne und darunter eingerückt seine Daily Habits mit dem Anteil, den sie innerhalb dieses Fundamentals ausmachen.',
        calcDistribution: 'Der Anteil eines Fundamentals ist seine Zahl der Anerkennungen geteilt durch die Gesamtzahl der Kampagne. Der eines Habits ist seine Zahl der Anerkennungen geteilt durch die Gesamtzahl seines Fundamentals.',
        whatFunnel: 'Segmentiert die Zielgruppe der Kampagne nach Häufigkeit: Regelmäßige (vier oder mehr pro Monat), Gelegentliche (eine bis drei) und Inaktive (keine). Jede Stufe wird zusätzlich nach Verwaltung und Produktion aufgeschlüsselt.',
        calcFunnel: 'Prozentsatz und Spalte Personen werden über die Zielgruppe der Kampagne berechnet, nicht über die gesamte Organisation. Verwaltung und Produktion zählen dieselben Personen nach Tätigkeitsart und bleiben leer, wenn diese Einordnung nicht verfügbar ist.',
        whatAllRecognitions: 'Rohdaten der Kampagne, eine Zeile je Person: die vollständigen Blöcke Nominee, OnBehalfOf und Candidate, das Datum, die Matrix der aktiven Habits und die Prüfkennzeichen. Personen werden nicht maskiert: Dies ist die Arbeitsgrundlage des Komitees, und die Anonymitätsschwelle gilt für aggregierte Berichte.',
        calcAllRecognitions: 'Vollständige Liste der Anerkennungen des Zeitraums, bis zu 5000 Zeilen. Die Habit-Spalten enthalten nur die zum Exportzeitpunkt im Katalog aktiven. Die Spalte Reco_ID bleibt leer, weil das System noch keine eindeutige Kennung je Zeile erzeugt.',
        whatTruncated: 'Dieser Download wurde bei der Grenze von 5000 Zeilen abgeschnitten: Die Kampagne hat mehr Anerkennungen, als die Datei enthält.',
        calcTruncated: 'Die Grenze wurde erreicht, bevor alle Seiten gelesen waren, die Datei ist daher unvollständig. Grenzen Sie Zeitraum oder Kampagne ein und exportieren Sie erneut.',
        noteLeader: 'Eine Rolle gilt als Führungskraft, sobald ihr Mitarbeitende unterstellt sind.',
        masked: 'Aus Anonymitätsgründen ausgeblendet',
        crossOuCount: '{{count}} OUs',
      },
    },
    history: {
      title: 'Historie',
      subtitle: 'Vollständige Historie einer Kampagne: Name und erhaltene Nominierungen.',
      selectCampaign: 'Kampagne auswählen',
      pickCampaign: 'Wähle eine Kampagne, um ihre Historie zu sehen.',
      search: 'Nach Namen suchen…',
      colPos: 'Position',
      colName: 'Name',
      colNominations: 'Nominierungen',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
      colCampaign: "Kampagne",
        colType: "Typ",
        colStatus: "Status",
      colAudience: 'Zielgruppe (Personen)',
        colRecognitions: "Anerkennungen",
      colOrigin: "Herkunft",
        colExpiration: "Ablauf",
        colActions: "Aktionen",
        status: {
        activo: "Aktiv",
          expirado: "Abgelaufen",
          borrador: "Entwurf",
        },
        origin: {
        original: "Original",
          local: "Lokal",
        },
      // P18-ter — GLOBALER Kampagnenbericht (alle, nicht nur eine), nach Vorbild von 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Kampagnen gesamt',
      kpiTotalRecognitions: 'Anerkennungen gesamt',
      kpiAudienceTotal: 'Zielgruppe gesamt',
      kpiParticipantsTotal: 'Teilnehmer',
      kpiParticipantsStaff: 'Teilnehmer Staff',
      kpiParticipantsFrontline: 'Teilnehmer Frontline',
      kpiParticipationRate: 'Teilnahmequote',
      kpiAvgPerParticipant: 'Durchschnittliche Anerkennungen pro Teilnehmer',
      colDescription: 'Beschreibung',
      colParticipants: 'Teilnehmer',
      colParticipantsStaff: 'Teilnehmer Staff',
      colParticipantsFrontline: 'Teilnehmer Frontline',
      colDuration: 'Kampagnendauer',
      colFrequency: 'Häufigkeit',
      colGoalPercent: '% des Ziels',
      downloadGlobalExcel: 'Globalen Bericht herunterladen',
      downloadGlobalError: 'Der globale Bericht konnte nicht heruntergeladen werden.',
      // Historien-Excel (`historicosExcel.ts`) — Texte, die AUSSCHLIESSLICH zur Datei gehören:
      // Blattnamen, Banner, Metadaten und Glossar. Datenbeschriftungen werden nicht wiederholt: die
      // `kpi*`/`col*`-Schlüssel oben werden wiederverwendet, damit Datei und Bildschirm übereinstimmen.
      excel: {
        sheetSummary: 'Management-Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetCampaigns: 'Historische Kampagnen',
        summaryTitle: 'Historie nach Kampagne',
        summarySubtitle: 'Fasst die Historie der Anerkennungskampagnen zusammen: Zielgruppe, Teilnahme und Anerkennungsvolumen jeder Kampagne.',
        campaignsSubtitle: 'Vergleichende Detailansicht je Kampagne.',
        definitionsTitle: 'Was bedeutet jede Kennzahl?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache, abgestimmt auf die Management-Zusammenfassung, inklusive der Messweise jedes KPI.',
        metaFilter: 'Angewendeter Filter',
        metaGenerated: 'Erstellt',
        filterAllCampaigns: 'Alle Kampagnen',
        colKpi: 'KPI',
        colValue: 'Wert',
        colNote: 'Hinweis / Definition',
        colDatum: 'Kennzahl',
        colWhatIs: 'Was sie ist',
        colHowMeasured: 'Wie sie gemessen wird',
        colHowCalculated: 'Wie sie berechnet wird',
        colComparedTo: 'Vergleichsmaßstab',
        colWhereShown: 'Wo sie erscheint',
        colAudienceOu: 'Zielgruppe OU',
        whereSummary: 'Management-Zusammenfassung',
        whereSummaryCampaigns: 'Management-Zusammenfassung / Historische Kampagnen',
        datumStaffFrontline: 'Teilnehmer Staff / Teilnehmer Frontline',
        durationMonths_one: '{{count}} Monat',
        durationMonths_few: '{{count}} Monate',
        durationMonths_other: '{{count}} Monate',
        whatCampaigns: 'Anzahl der Kampagnen in der Historie bzw. im angewendeten Filter.',
        measuredCampaigns: 'Gezählt wird jede Kampagne, die mit gültigem Namen in der Historie steht.',
        calcCampaigns: 'Anzahl eindeutiger Kampagnen im Berichtsumfang.',
        vsCampaigns: 'Gegen alle verfügbaren Kampagnen oder gegen frühere Stichtage.',
        whatRecognitions: 'Im gewählten Umfang aufgelaufene Anerkennungen.',
        measuredRecognitions: 'Gezählt wird jede Anerkennung, die zu den einbezogenen Kampagnen erfasst ist.',
        calcRecognitions: 'Summe aller Anerkennungen der gefilterten Kampagnen.',
        vsRecognitions: 'Gegen andere Kampagnen, frühere Zeiträume oder das gesetzte Ziel.',
        whatAudience: 'Zahl der Mitarbeitenden, an die sich die Kampagne richtete.',
        measuredAudience: 'Gemessen an der Zielgruppe, die in der Kampagnenkonfiguration hinterlegt ist.',
        calcAudience: 'Alle berechtigten Mitarbeitenden in der OU, im Land, in der BU oder im konfigurierten Umfang.',
        vsAudience: 'Basis der Teilnahmequote; 100 % entspricht der gesamten Zielgruppe.',
        whatParticipants: 'Verschiedene Personen, die mindestens eine Anerkennung gesendet haben.',
        measuredParticipants: 'Gezählt werden eindeutige Personen mit mindestens einer gesendeten Anerkennung.',
        calcParticipants: 'Eindeutige Anzahl der Sendenden mit einer oder mehreren Anerkennungen.',
        vsParticipants: 'Gegen die Zielgruppe gesamt und gegen vergleichbare Kampagnen.',
        whatStaffFrontline: 'Von den Teilnehmenden: wie viele im Büro (Staff) und wie viele im Betrieb (Frontline) arbeiten.',
        measuredStaffFrontline: 'Maßgeblich ist das aktuelle Segment der Person zum Zeitpunkt des Berichts, nicht das zur Teilnahme.',
        calcStaffFrontline: 'Anzahl der Teilnehmenden nach dem Segment in ihrem Verzeichniseintrag.',
        vsStaffFrontline: 'Gegen die Gesamtzahl der Teilnehmenden derselben Zeile.',
        whatRate: 'Anteil der Zielgruppe, der tatsächlich teilgenommen hat.',
        measuredRate: 'Gemessen als Anteil der Teilnehmenden an der gesamten Zielgruppe.',
        calcRate: 'Teilnehmer / Zielgruppe gesamt.',
        vsRate: 'Gegen das Teilnahmeziel; 100 % heißt, die gesamte Zielgruppe hat teilgenommen.',
        whatAvg: 'Durchschnittliche Zahl der Anerkennungen je aktivem Teilnehmenden.',
        measuredAvg: 'Gemessen unter den Personen, die mindestens eine Anerkennung gesendet haben.',
        calcAvg: 'Anerkennungen gesamt / Teilnehmer.',
        vsAvg: 'Gegen andere Kampagnen oder gegen den erwarteten Schnitt je Teilnehmenden.',
      },
    },
    headcount: {
      notaPeriodo: 'Referenz für den Zeitraum: die Kennzahlen oben werden auf diesen Personalbestand berechnet.',
      notaAdopcion: 'Das ist der Nenner der Nutzung: von diesem Bestand, wie viele Personen nominiert haben.',
      title: 'Belegschaft',
      updatedOn: 'Belegschaft aktualisiert: {{fecha}}',
      updatedOnTitle: 'Belegschaft aktualisiert',
      sourceLatam: 'LATAM: {{fecha}}',
      sourceEuropa: 'Europa: {{fecha}}',
      sourceUsa: 'USA: {{fecha}}',
      sinDato: 'Keine Daten',
      hint: 'Letzter Import der auf der Plattform registrierten Nutzenden',
      total: 'Personen insgesamt',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Heatmap OU × Grundprinzip',
      subtitle: 'Anerkennungsvolumen nach Einheit und Grundprinzip. Die Farbintensität zeigt die relative Konzentration innerhalb jeder Spalte.',
      ou: 'Organisationseinheit',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Gesamt',
    },
    network: {
      title: 'ONA-Netzwerk',
      subtitle: 'Anerkennungsfluss zwischen Einheiten (übergreifende Zusammenarbeit).',
      ous: 'Einheiten',
      flows: 'Flüsse',
      legendCross: 'Cross-OU-Fluss',
      legendInternal: 'Interner Fluss',
      legendNode: 'Einheit (Größe = Volumen)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Fluss (Von → Nach)',
      colRecognitions: 'Anerkennungen',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Anerkennungsvolumen',
      colDominantFundamentalHelp: 'Die Länge des Balkens stellt das Anerkennungsvolumen des Flusses dar; die Farbe zeigt, welches Grundprinzip darin am häufigsten anerkannt wurde.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: 'Was bedeutet jede Kennzahl?',
      subtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen, ganz ohne Datenkenntnisse.',
      colData: 'Kennzahl',
      colWhat: 'Was sie ist',
      colHow: 'Wie sie berechnet wird',
      colVs: 'Verglichen mit',
      percentTotalWhat: 'Welcher Anteil der gesamten aktiven Belegschaft auf jede Generation entfällt.',
      percentTotalHow: 'Aktive Personen dieser Generation über alle OUs im Geltungsbereich, geteilt durch die gesamte aktive Belegschaft mit bekanntem Generationenband.',
      percentTotalVs: 'Die übrigen Generationen derselben Tabelle.',
      gapWhat: 'Wie stark eine Generation jedes Fundamental lebt, auf einer Skala von 1 bis 4, und wie weit ihr niedrigstes Fundamental vom höchsten entfernt liegt.',
      gapHow: 'Durchschnitt der Pulso-Werte je Generation und Fundamental; das Δ ist das Maximum minus das Minimum der Zeile, auf eine Dezimalstelle.',
      gapVs: 'Die übrigen Fundamentals derselben Generation.',
      heatmapWhat: 'Wie viele Anerkennungen in jeder Organisationseinheit vergeben wurden, aufgeschlüsselt nach Fundamental.',
      heatmapHow: 'Zählung gruppiert nach OU und Fundamental; Zellen mit weniger als 5 Anerkennungen werden aus Anonymitätsgründen ausgeblendet.',
      heatmapVs: 'Die übrigen OUs und Fundamentals derselben Tabelle.',
      networkWhat: 'Wie viele Anerkennungen von einer Organisationseinheit zu einer anderen geflossen sind.',
      networkHow: 'Zählung der von einer OU an eine andere gesendeten Anerkennungen, absteigend sortiert.',
      networkVs: 'Die übrigen Flüsse derselben Tabelle.',
    },
    generational: {
      title: 'Generationenverteilung',
      subtitle: 'Anerkennungen gruppiert nach Generationenband.',
      filterBu: 'Nach BU filtern…',
      filterDepto: 'Nach Abteilung filtern…',
      filterSite: 'Nach Standort filtern…',
      roleAll: 'Alle',
      roleLeaders: 'Führungskräfte',
      rolePeers: 'Kollegen',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Generationslücke × Fundamental',
      gapSubtitle: 'Durchschnittswert (1–4) je Generation und Fundamental. Δ Lücke ≥ 1,0 = kritisch.',
      gapTitleHelp: 'Jede Zelle wird für die Anzeige auf 1 Dezimalstelle gerundet. Die Δ Lücke wird anhand des vollständigen (ungerundeten) Werts aus Maximum minus Minimum der Zeile berechnet und kann daher von der visuellen Subtraktion der gerundeten Spalten abweichen.',
      colGeneration: 'Generation',
      colGap: 'Δ Lücke',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} Person',
      people_other: '{{count}} Personen',
      majority: 'Mehrheit',
      coverageTitle: 'Einheiten mit generationsbezogener Datenabdeckung',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Demografie-Bereich exportieren (5 Tabellenblätter)',
      // Task 9 — etiquetas de columna para la hoja de export de distribución generacional.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Zusammensetzung der Belegschaft nach Generation, OU und Mitarbeitertyp',
      metaPeriod: 'Zeitraum',
      metaFilters: 'Angewendete Filter',
      metaGenerated: 'Erstellt',
      colPercentTotal: '% der Gesamtzahl',
      colYearRange: 'Jahresspanne',
      colPeople: 'Personen',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Hinweis',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Mehrheit',
      noteSmallSample: 'Kleine Stichprobe',
    },
    leaders: {
      title: 'Führungskräfte',
      subtitle: 'Direkte Teamgröße und Anerkennungen pro Führungskraft.',
      export: 'Nach Excel exportieren',
      colLeader: 'Führungskraft',
      colPosition: 'Position',
      colOu: 'OE',
      colLevel: 'Ebene',
      colTeamSize: 'Teamgröße',
      colTeamReceived: 'Team-Anerkennungen (erhalten)',
      colTeamReceivedHelp: 'Gesamtzahl der Anerkennungen, die Personen innerhalb der Führungsstrukturen erhalten haben.',
      colTeamSent: 'Team-Anerkennungen (gesendet)',
      colTeamSentHelp: 'Gesamtzahl der Anerkennungen, die Personen innerhalb der Führungsstrukturen gesendet haben.',
      colLeaderSent: 'Von der Führungskraft gesendete Anerkennungen',
      colLeaderReceived: 'Von der Führungskraft erhaltene Anerkennungen',
      colParticipation: 'Beteiligung',
      colRatio: 'Verhältnis',
      colExport: 'Exportieren',
      exportRow: 'Diese Zeile exportieren',
      exportRowFor: 'Zeile von {{name}} exportieren',
      kpiTotalLeaders: 'Führungskräfte insgesamt',
      kpiTeamSizeSum: 'Gesamte Teamgröße',
      kpiRatioAvg: 'Durchschnittliches Verhältnis',
      kpiParticipationAvg: 'Durchschnittliche Beteiligung',
      emptyByPerson: 'Die ausgewählte Person gehört zu keinem Team in Ihrem Bereich. Entfernen Sie den Personenfilter, um die vollständige Tabelle zu sehen.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Zusammenfassung',
        sheetDefinitions: 'Definitionen',
        sheetTeams: 'Teams nach Führungskraft',
        teamsSubtitle: 'Detail der Anerkennungen nach Führungsstruktur.',
        definitionsTitle: 'Was bedeutet jede Kennzahl?',
        definitionsSubtitle: 'Erklärung in einfacher Sprache für alle, die diese Datei herunterladen — ganz ohne Datenkenntnisse.',
        metaPeriod: 'Zeitraum',
        metaFilters: 'Angewendete Filter',
        metaGenerated: 'Erstellt am',
        colKpi: 'Kennzahl',
        colValue: 'Wert',
        colDetail: 'Detail',
        colDatum: 'Angabe',
        colWhatIs: 'Was es ist',
        colHowCalculated: 'Wie es berechnet wird',
        detailTotalLeaders: 'Personen mit mindestens einem direkt unterstellten Mitarbeitenden im abgefragten Bereich.',
        detailTeamSize: 'Summe der direkt unterstellten Mitarbeitenden aller Führungskräfte der Liste.',
        detailTeamReceived: 'Anerkennungen, die die Mitglieder dieser Teams erhalten haben.',
        detailTeamSent: 'Anerkennungen, die die Mitglieder dieser Teams gesendet haben.',
        detailLeaderReceived: 'Anerkennungen, die die Führungskräfte selbst erhalten haben, ohne ihr Team.',
        detailLeaderSent: 'Anerkennungen, die die Führungskräfte selbst gesendet haben, ohne ihr Team.',
        detailRatio: 'Erhaltene Team-Anerkennungen geteilt durch die gesendeten.',
        detailParticipation: 'Durchschnittliche Beteiligung der Teams der Führungskräfte.',
        whatTeamSize: 'Wie viele Personen dieser Führungskraft direkt berichten.',
        howTeamSize: 'Anzahl der Personen, deren Vorgesetzter die Führungskraft ist. Tiefere Ebenen des Organigramms werden nicht kumuliert.',
        whatTeamReceived: 'Wie viele Anerkennungen das Team dieser Führungskraft insgesamt erhalten hat, von wem auch immer.',
        howTeamReceived: 'Summe der Anerkennungen, bei denen die empfangende Person zum direkten Team der Führungskraft gehört.',
        whatTeamSent: 'Wie viele Anerkennungen das Team dieser Führungskraft insgesamt gesendet hat, an wen auch immer.',
        howTeamSent: 'Summe der Anerkennungen, bei denen die sendende Person zum direkten Team der Führungskraft gehört.',
        whatLeaderReceived: 'Wie viele Anerkennungen die Führungskraft insgesamt erhalten hat, von wem auch immer.',
        howLeaderReceived: 'Anzahl der Anerkennungen, bei denen die Führungskraft die empfangende Person ist. Ihr Team zählt nicht mit.',
        whatLeaderSent: 'Wie viele Anerkennungen die Führungskraft gesendet hat, an wen auch immer.',
        howLeaderSent: 'Anzahl der Anerkennungen, bei denen die Führungskraft die sendende Person ist. Ihr Team zählt nicht mit.',
        whatRatio: 'Wie viel mehr Anerkennung ein Team erhält, als es anderen entgegenbringt.',
        howRatio: 'Erhaltene Team-Anerkennungen geteilt durch die gesendeten. „—“, wenn das Team keine gesendet hat.',
        whatParticipation: 'Welcher Anteil des Teams dieser Führungskraft mindestens einmal jemanden anerkannt hat.',
        howParticipation: 'Teammitglieder mit mindestens 1 gesendeten Anerkennung, geteilt durch die Teamgröße. Empfangen zählt nicht: Das ist die Handlung einer anderen Person.',
        whatLeader: 'Mitarbeitende Person, der im Personalbestand des Unternehmens Personal unterstellt ist.',
        howLeader: 'Jede Person mit mindestens einem direkt unterstellten Mitarbeitenden. Die Zusammenfassung addiert die Führungskräfte aller Regionen des abgefragten Bereichs.',
        whatLevel: 'Tiefe der Führungskraft im Organigramm: N-1 ist die Wurzel (ohne Vorgesetzten), dann N-2, N-3… abwärts.',
        howLevel: 'Kette der Vorgesetzten bis zur Wurzel + 1, berechnet über das gesamte Unternehmen und nicht nur unter den in dieser Liste sichtbaren Führungskräften.',
      },
    },
    moderation: {
      title: 'Moderation',
      subtitle: 'Detail der gemeldeten Anerkennungen. Enthält Kontaktdaten zur Eskalation.',
      total: 'Meldungen gesamt',
      pending: 'Ausstehend',
      hidden: 'Ausgeblendet',
      restored: 'Wiederherstellt',
      colReported: 'Gemeldet',
      colReportedEmail: 'E-Mail gemeldet',
      colOu: 'OE',
      colCountry: 'Land',
      colReporter: 'Meldender',
      colReporterEmail: 'E-Mail Meldender',
      colReason: 'Grund',
      colStatus: 'Status',
      colDate: 'Datum',
      statusPending: 'Ausstehend',
      statusHidden: 'Ausgeblendet',
      statusRestored: 'Wiederherstellt',
      statusPublished: 'Veröffentlicht',
      colComment: 'Gemeldeter Kommentar',
      colLanguage: 'Sprache',
      colReportCount: '# Meldungen',
      export: 'Nach Excel exportieren',
    },
    campaigns: {
      title: 'Kampagnenverlauf',
      subtitle: 'Alle Kampagnen (aktiv und abgelaufen): Zielgruppe und Anerkennungen.',
      search: 'Nach Namen suchen…',
      // D4 — Kategorieauswahl (Fundamentales/Brillamos/Personalizada), die den kombinierten
      // Tabellenexport ersetzt.
      filterTypeLabel: 'Kategorie',
      filterAllTypes: 'Alle Kategorien',
      summaryParticipants: 'Teilnehmende gesamt',
      summaryRate: 'Teilnahme in %',
      colName: 'Name',
      colType: 'Typ',
      colStatus: 'Status',
      colAudience: 'Zielgruppe (Personen)',
      colRecognitions: 'Anerkennungen',
      // C2 — «Teilnahme pro Kampagne» (rep-panel-campgeneral).
      colParticipants: 'Teilnehmende',
      colRate: 'Teilnahmequote',
      colAvgUser: 'Durchschnitt je Teilnehmer',
      colAvgUserHelp: 'Durchschnittliche Anerkennungen je Teilnehmer der Kampagne: Anerkennungen ÷ Teilnehmer.',
      dominantFundamentalTooltip: 'Am häufigsten anerkanntes Fundamental: {{name}}',
      colExpiration: 'Ablaufdatum',
      colActions: 'Aktionen',
      prevPage: 'Zurück',
      nextPage: 'Weiter',
      pageOf: 'Seite {{page}} von {{total}}',
      type: {
        Fundamentales: 'Grundprinzipien',
        Brillamos: 'Shine Together',
        Personalizada: 'Individuell',
      },
      status: {
        activo: 'Aktiv',
        finalizada: 'Abgelaufen',
        borrador: 'Entwurf',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      downloadExcel: 'Excel herunterladen',
      // D6 — nutzersichtbare Fehlermeldung, wenn der Kampagnen-Export fehlschlägt (Netzwerk/Backend), via Toast.
      downloadError: 'Die Excel-Datei der Kampagne konnte nicht heruntergeladen werden.',
    },
  },
  // ── D5 Pass-C — Präferenzen, Team, Übersicht, Ranking, individuelle Kampagne ──
  notifPrefs: {
    title: 'Benachrichtigungen',
    subtitle: 'Wählen Sie, welche Hinweise Sie per E-Mail erhalten möchten.',
    unavailable: 'Ihre Präferenzen konnten nicht geladen werden.',
    emailEnabled: 'E-Mails erhalten',
    emailHint: 'Hauptschalter für alle E-Mails.',
    saveError: 'Ihre Präferenzen konnten nicht gespeichert werden.',
    cat: {
      recognitionReceived: 'Erhaltene Anerkennungen',
      streakAndBadges: 'Serien und Abzeichen',
      campaigns: 'Kampagnen',
      digest: 'Aktivitätsübersicht',
    },
    catHint: {
      recognitionReceived: 'Wenn jemand Sie anerkennt.',
      streakAndBadges: 'Ihre Serie und freigeschaltete Abzeichen.',
      campaigns: 'Neuigkeiten zu Kampagnen Wir strahlen.',
      digest: 'Regelmäßige Übersicht Ihrer Aktivität.',
    },
    catLockedAntiSpoiler: 'Gesperrt, solange der Anti-Spoiler-Modus aktiv ist: Wir können Sie erst nach Kampagnenende über Ihre Anerkennungen benachrichtigen.',
  },
  team: {
    mostRecognized: 'Am meisten anerkannt', mostRecognizers: 'Aktivste Anerkenner:innen',
    title: 'Mein Team',
    subtitle: 'Beteiligung Ihres Teams an der Anerkennung.',
    subtitleFor: 'Team von {{name}}',
    empty: 'Es gibt noch keine Aktivität Ihres Teams.',
    teamSize: 'Teamgröße',
    sent: 'Gesendet',
    received: 'Erhalten',
    participation: 'Beteiligung',
    members: 'Teammitglieder',
    emptyMembers: 'Es gibt keine Mitglieder zum Anzeigen.',
    colMember: 'Mitglied',
    colSent: 'Gesendet',
    colReceived: 'Erhalten',
    colStreak: 'Serie',
    noStreak: 'Keine Serie',
    explore: 'Sein Team erkunden',
    myTeam: 'Mein Team',
    breadcrumb: 'Teampfad',
    colTopFundamental: 'Top-Grundprinzip',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'Anerkannt für:',
    fundEnviado: 'Erkennt an für:',
    colActions: 'Aktionen',
    viewButton: 'Profil von {{name}} ansehen',
    viewButton_short: 'Ansehen',
    backToTeam: 'Zurück zum Team',
    backToProfile: 'Zurück zu meinem Profil',
    expandMember: 'Details von {{name}} ansehen',
  },
  tablero: {
    title: 'Management-Übersicht',
    subtitle: 'KPIs des Anerkennungsprogramms. Zeigt nie Punkte an.',
    empty: 'Für den gewählten Geltungsbereich gibt es keine KPIs.',
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'Alle Grundwerte',
    allGenerations: 'Alle Generationen',
    notApplicableNote: 'Mit dem Generationsfilter werden KPIs, die auf der Gesamtbelegschaft beruhen, als „n/a“ angezeigt: Der Personalbestand ist nicht nach Generation aufgeschlüsselt, dieser Prozentsatz würde also etwas anderes bedeuten.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Generation Alpha',
      GenZ: 'Generation Z',
      Millennial: 'Millennials',
      GenX: 'Generation X',
      BabyBoomer: 'Babyboomer',
      Silent: 'Stille Generation',
    },
  },
  leaderboard: {
    title: 'Ranking nach OU',
    subtitle: 'Nominierungen nach Organisationseinheit/Land.',
    noOu: 'Ohne OU',
    you: ' (Sie)',
  },
  campaignType: {
    personalizada: 'Individuelle Kampagne',
  },
  campaignLanding: {
    customNote: 'Dies ist eine informative Kampagne. Erkunden Sie ihre Dokumente und ihre Microsite.',
  },
  innovacion: {
    kpiStreak: 'Serie',
    kpiStreakHint: 'Rekord: {{record}} Wochen',
    kpiStreakHintMonthly: 'Rekord: {{record}} Monate',
    kpiNominations: 'Nominierungen',
    kpiNominationsHint: 'In dieser Kampagne gesendet',
    kpiNominationsHint2: '{{count}} verschiedene Personen',
    kpiUnique: 'Nominierte Personen',
    kpiUniqueHint: 'Eindeutige Empfänger',
    kpiDaysLeft: 'Verbleibende Tage',
    suppressed: 'Die Daten werden aus Datenschutzgründen unterdrückt: die Gruppe ist zu klein, um Zahlen anzuzeigen.',
    kpisUnavailable: 'Live-KPIs sind derzeit nicht verfügbar.',
    fundamentalsTitle: 'Grundprinzipien dieser Kampagne',
    nominateSecondary: 'Zur Seite Nominieren gehen',
    recentTitle: 'Neueste Anerkennungen',
    recentEmpty: 'Noch keine Anerkennungen in dieser Kampagne.',
    noCampaign: 'Es gibt keine aktive individuelle Kampagne. Sie kann unter Verwaltung → Kampagnen erstellt werden.',
  },
};

export default recognition;
